// src/screens/admin/SuperAdminStoresScreen.js
// 80차: 테마 등록/수정 폼에 예약 형식(bookingFormat: 방탈출/체험형 공연) 선택 + 체험형
//       선택 시 정원(capacity) 입력 추가(RegisterTab/EditStore 양쪽), 엑셀 일괄등록에도
//       "예약형식"/"정원" 컬럼 신규(선택, 비우면 방탈출).
// 78차 63차: 정산(현황/수납관리) "전체" 보기에서 매장 카드 하나로만 뭉쳐 보이던 금액을
// 지점별로 풀어서 표기(지점명·플랜·할인율·금액). 일괄등록 난이도 입력에 1~5 숫자 지원
// 추가(1~2=쉬움,3=보통,4=어려움,5=전문가) — 실제 도트 표기(4단계)와 헷갈리지 않도록.
// 78차 62차: 수정/계약이력/계약연장/플랜변경/비활성화 5개 동작을 지점(branch) 단위로도
// 가능하게 확장 — 지점이 2개 이상인 매장은 각 지점 카드에 동일한 버튼을 추가.
// 일괄등록 시 plan/납부일/할인율/계약기간을 "사업자 그룹" 최초 1행이 아니라 "지점" 최초
// 1행 기준으로 저장하도록 수정(같은 사업자의 지점끼리도 플랜이 다르게 계약되는 경우
// 실사용자 신고로 발견 — 기존엔 두 번째 지점 값이 조용히 무시되고 있었음). 일괄등록으로
// 생성된 매장은 기본 비활성 상태로 생성(추가 확인 전 노출 방지). 엑셀 시간 서식 셀이
// 소수(예: 0.5)로 파싱되던 버그 수정(parseExcelTimeCell). 장르 "기타" 선택 시 직접
// 입력(예: 야외테마) 가능하게 함.
// 총관리자 매장관리 화면 — 매장관리 / 매장등록 / 수수료 / 정산
// 32차: 매장 soft-delete / 복구 기능 추가 (isDeleted 플래그)
// 34차: notifyStoreDeleted 자동 연결 / 이미지 업로드 전 클라이언트 압축 (expo-image-manipulator)
// 51차: 색/폰트 theme.js 단일화 — onGold·dangerSoft 토큰, 'serif'→FONTS.display
// 56차: 매장별 plan(free/premium) 토글 추가 — UNLOCK 기여도 카드 과금 게이트
// 58차: 탭 구조 개편 — 매장등록을 매장관리 탭 안 모달로, 수수료+정산을 정산 탭(현황/수납관리)으로 통합
// 74차: 영업용 데모 매장(isDemo:true) 배지 추가 — isDeleted 배지와 동일한 패턴, 계약 전
//       영업용으로 등록해둔 테스트 매장임을 총괄관리자가 목록에서 바로 구분할 수 있게 함
// 76차: RegisterTab에 "매장관리자 계정 발급(선택)" 추가 — 기존엔 매장 등록과 계정 발급이
//       완전히 분리돼 있어(유저관리에서 기존 일반회원을 매장관리자로 전환해야만 접속
//       가능) 번거로웠음. 로그인 ID를 입력하면 매장 등록 직후 createStoreAdminAccountCF를
//       호출해 계정을 바로 만들고, 1회성 임시 비밀번호를 모달로 보여준다(다시 조회 불가).
//       비워두면 기존과 동일하게 매장 문서만 생성(하위 호환).
// 76차: StoresTab 보강 — 매장명 검색, 등록순/매출순 정렬 칩, 평균 평점(테마 rating/
//       reviewCount 가중평균, 이미 로드된 데이터라 추가 조회 없음), 담당 매장관리자
//       로그인 ID 표시(카드 펼침 시 지연 조회), 총괄관리자 전용 내부 메모(stores.
//       internalNote) 추가. 이미 있던 "이번달 매출"/D-Day 뱃지는 그대로 재사용.
// 76차: 이 화면 안 나머지 모달 5개(매장 수정/플랜 변경/계약 이력/계정 발급 결과/수납 처리)의
//       커스텀 헤더(goldLineTop+제목 텍스트)를 전부 공통 AppHeader(isModal)로 교체 —
//       "새 매장 등록" 모달만 AppHeader를 쓰고 나머지는 제각각이라 톤이 안 맞았음.
// 76차: 매장 수정(EditStore) 모달에 수수료 조건(feeType/discountRate/fixedFee/paymentDay)
//       편집 기능 추가 — 지금까지 등록 시 한 번만 입력 가능하고 이후 변경 UI가 아예 없었음.
//       변경 시 logContractChange(id,'fee',...)로 이력 기록(plan/contractPeriod와 동일 패턴).
// 76차: 플랜 구독료가 정산에 반영 안 되던 버그 수정 — FeeTab/BillingTab이 calcStoreFee
//       (매출 연동 수수료)만 계산하고 플랜 구독료(feeService.js의 getPlanFee)는 어디에도
//       합산하지 않고 있었음. FeeTab은 매출/수수료/구독료/합계 4항목으로 확장, BillingTab의
//       calcMonthlyFee는 총액만 반환하는 얇은 래퍼로 유지하고 calcMonthlyBreakdown 신규
//       추가, billings 문서에 fee(총액)와 함께 commissionFee/planFee도 기록.
// 76차: 매장 일괄 등록(엑셀) 신규 — 계약 체결 후 다수 매장을 한 번에 등록해야 하는
//       상황을 위해, 정해진 엑셀 규칙대로 입력하면 매장 등록 + 로그인 ID/PW 발급까지
//       한 번에 처리(`BulkStoreImportTab`). StoreAdminScreen.js의 BulkThemeImportTab(75차)
//       와 동일한 파일 읽기/파싱 패턴, RegisterTab과 동일한 매장 생성 필드 구성,
//       Feature 2에서 만든 createStoreAdminAccountCF를 그대로 재사용.

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, TouchableOpacity, StyleSheet,
  TextInput, ActivityIndicator, RefreshControl,
  Modal, Image,
} from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import { Calendar } from 'react-native-calendars'; // 78차 46차: 계약 시작/종료일 달력 선택
import * as ImageManipulator from 'expo-image-manipulator';   // ← 34차: 업로드 전 압축
import * as DocumentPicker from 'expo-document-picker';        // ← 76차: 매장 일괄 등록(엑셀)
import { saveAndShareXlsx, readPickedFileBytes } from '../../services/fileExportService'; // 78차 39차: 웹 지원
import * as XLSX from 'xlsx';
import {
  collection, getDocs, doc, updateDoc,
  addDoc, deleteDoc, query, where,
} from 'firebase/firestore'; // deleteDoc은 기존부터 미사용 — 이번 작업 범위 밖이라 유지
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../services/firebase';
// 78차 50차: 테마 이미지 업로드가 uploadAdminImageCF 경유로 바뀌면서 firebase/storage
// 직접 호출(ref/uploadBytes/getDownloadURL)과 storage import 자체가 더 이상 필요 없어짐.
import { softDeleteStore, restoreStore, getAllStoresIncludeDeleted, logContractChange, getContractHistory, invalidateStoreCache, parseProductId } from '../../services/productService';
import { useAuth } from '../../contexts/AuthContext';
import { notifyStoreDeleted } from '../../services/recruitService';
import { calcStoreFee, getStoreThemeCount, getPlanFee, calcTotalOwed, getPickAddonFee, getPlanDiscountRate, getBranchPlan, getEffectivePlan, hasOpsAddon, getOpsAddonFee } from '../../services/feeService';
import { getAllPaidPickCountsForMonth } from '../../services/eventService';
import AppHeader, { RoleBadge } from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import MinutesPickerField from '../../components/common/MinutesPickerField';
import PlanInfoView from '../../components/common/PlanInfoView';
import { SecondaryButton, DangerButton, TextButton } from '../../components/common/Buttons';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import {
  MenuStoreIcon, ReceiptIcon, StatsIcon, SearchIcon, LocationIcon, PeopleIcon,
  EditIcon, ContractIcon, PaymentIcon, PriceIcon, MenuReservationIcon,
  MenuEscapeIcon, CheckmarkIcon, IconLabel, ClockIcon,
  CancelIcon, StarIcon, HourglassIcon, MenuPasswordIcon, WarningIcon, PersonIcon,
} from '../../components/common/Icons';
import { COLORS, RADIUS, SHADOW, FONTS } from '../../constants/theme';
import { PLAN_TIERS, PLAN_LABELS, PLAN_PRICES, PLAN_COLORS, PLAN_DEFAULT_DISCOUNT_RATE, OPS_ADDON_FEE, normalizePlan, getPlanBadgeLabel, GENRES, BOOKING_FORMATS, SEATING_TYPES, ACTIVITY_META, SHOW_DEFAULT_NOTICES, SHOW_DEFAULT_REFUND_POLICY } from '../../constants';
import { todayStr as localTodayStr, thisMonthStr as localThisMonthStr, addDaysStr as localAddDaysStr } from '../../utils/dateUtils';

// 78차 45차: 이 화면 전용으로 따로 들고 있던 장르 목록이 constants/index.js의 GENRES와
// 어긋나(미스터리/드라마/감성 누락) 실제 테마 등록 중 선택 불가 문제로 발견됨 — 마스터
// 목록을 그대로 참조하도록 교체(향후 장르 추가 시 한 곳만 고치면 되게)
const GENRE_OPTIONS      = GENRES;
const DIFFICULTY_OPTIONS = [
  { v:'easy',   l:'쉬움 ★☆☆☆' },
  { v:'normal', l:'보통 ★★☆☆' },
  { v:'hard',   l:'어려움 ★★★☆' },
  { v:'expert', l:'전문가 ★★★★' },
];
const REGIONS = ['서울','경기','인천','부산','대구','광주','대전','울산','세종','제주','기타'];
const SUB_REGIONS = {
  '서울': ['강남','강북','강서','강동','종로','중구','용산','성동','광진','동대문','중랑','성북','도봉','노원','은평','서대문','마포','양천','구로','금천','영등포','동작','관악','서초','송파'],
  '경기': ['수원','성남','고양','용인','부천','안산','안양','남양주','화성','평택','의정부','시흥','파주','김포','광명','광주','군포','하남','오산','이천','양주','구리','안성','포천','의왕','양평','동두천','가평','연천','과천','여주'],
  '인천': ['중구','동구','미추홀','연수','남동','부평','계양','서구','강화','옹진'],
  '부산': ['중구','서구','동구','영도','부산진','동래','남구','북구','해운대','사하','금정','강서','연제','수영','사상','기장'],
  '대구': ['중구','동구','서구','남구','북구','수성','달서','달성'],
  '광주': ['동구','서구','남구','북구','광산'],
  '대전': ['동구','중구','서구','유성','대덕'],
  '울산': ['중구','남구','동구','북구','울주'],
  '세종': ['세종시'],
  '제주': ['제주시','서귀포시'],
  '기타': ['기타'],
};

const C = {
  bg:      COLORS.bg,
  surface: COLORS.surface,
  card:    COLORS.surface2,
  border:  COLORS.border,
  gold:    COLORS.gold,
  goldBg:  COLORS.goldBg,
  goldBdr: COLORS.goldBorder,
  onGold:  COLORS.onGold,
  text:    COLORS.text,
  textSec: COLORS.textSec,
  muted:   COLORS.textMuted,
  success: COLORS.green,
  danger:  COLORS.red,
  warning: COLORS.warning,
  info:    COLORS.blue,
  dangerSoft:       COLORS.dangerSoft,
  dangerSoftBg:     COLORS.dangerSoftBg,
  dangerSoftBorder: COLORS.dangerSoftBorder,
};

const krw = (n) => new Intl.NumberFormat('ko-KR',{style:'currency',currency:'KRW'}).format(n||0);
// 78차: UTC 기준(toISOString)이던 것을 로컬 기준으로 교체(dateUtils.js 참고) — 이하 today10()
const today10 = () => localTodayStr();
// 79차: [버그 수정] SuperAdminScreen.js의 dDayLabel과 같은 목적의 형제 함수인데, 그쪽만
// UTC-vs-로컬 혼동을 고치고(주석 참고) 이 파일 안의 복사본은 원래 버그 그대로 남아있었음
// (fork로 발견) — new Date(end)(UTC 자정 파싱)와 new Date()(로컬 현재시각)를 그대로 빼서
// 계약 만료일 당일 자정~오전9시(KST) 사이 D-Day가 하루 더 밀려 보일 수 있었음. 둘 다
// 순수 날짜 문자열이므로 SuperAdminScreen.js와 동일하게 Date.UTC 기반 비교로 통일.
const dDayLabel = (end) => {
  if (!end) return '-';
  const [ey, em, ed] = end.split('-').map(Number);
  const [ty, tm, td] = localTodayStr().split('-').map(Number);
  const diff = Math.round((Date.UTC(ey, em - 1, ed) - Date.UTC(ty, tm - 1, td)) / 86400000);
  if (diff<0) return '만료'; if (diff===0) return 'D-DAY'; return `D-${diff}`;
};
// 68차: 수수료 계산은 feeService.calcStoreFee로 단일화 (FeeTab/BillingTab/
// StoreAdminScreen이 서로 다른 계산식을 쓰던 중복·불일치 버그 수정, 인수인계서
// "코드 중복 정리: 수수료·정산 중복" 항목 대응)

// 34차: 업로드 전 클라이언트 압축 — 최대 1400px (테마 이미지는 리뷰보다 조금 크게)
async function compressImageAsync(uri) {
  try {
    const result = await ImageManipulator.manipulateAsync(
      uri,
      [{ resize: { width: 1400 } }],
      { compress: 0.78, format: ImageManipulator.SaveFormat.JPEG }
    );
    return result.uri;
  } catch (e) {
    return uri; // 압축 실패 시 원본 사용
  }
}

// 78차 50차: storage.rules의 themes/notices가 로그인 여부만 확인하고 역할 검증이 없어
// 로그인한 아무 유저나 직접 쓸 수 있던 문제 — Storage Rules의 firestore.get() 크로스서비스
// 조회를 먼저 시도했으나 이 프로젝트 환경에서 지원되지 않는 것으로 확인(라이브 테스트로
// 발견, 실제 총관리자도 거부됨) — 업로드 자체를 Admin SDK 기반 CF(uploadAdminImageCF)로
// 옮기고 storage.rules의 themes/notices는 write:false로 완전 차단. 클라이언트는 이미지를
// base64로 인코딩해 CF에 넘기기만 하면 됨(직접 Storage 쓰기 없음).
async function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]);
    reader.onerror = () => reject(new Error('이미지 인코딩 실패'));
    reader.readAsDataURL(blob);
  });
}

async function uploadImageAsync(uri, prefix) {
  const compressed = await compressImageAsync(uri);
  const blob = await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => resolve(xhr.response);
    xhr.onerror = () => reject(new Error('이미지 로드 실패'));
    xhr.responseType = 'blob';
    xhr.open('GET', compressed, true);
    xhr.send(null);
  });
  const imageBase64 = await blobToBase64(blob);
  blob.close && blob.close();
  const cf = httpsCallable(functions, 'uploadAdminImageCF');
  const result = await cf({ prefix, imageBase64, contentType: 'image/jpeg' });
  return result.data.url;
}

// 78차 71차: 테마 이미지를 재업로드하면 예전 파일이 Storage에서 지워지지 않고 영구히
// 남는 문제(고아 파일) — uploadAdminImageCF가 만드는 URL 형식(themes%2F{파일명}?alt=media)에서
// 파일명을 뽑아 deleteAdminImageCF로 정리. EventsScreen.js의 공지 포스터 삭제와 동일 패턴.
// best-effort — 실패해도(예: 외부에서 직접 입력한 URL이라 이 형식이 아닌 경우) 저장 자체는 막지 않음.
async function deleteOldThemeImage(oldUrl) {
  if (!oldUrl) return;
  const match = oldUrl.match(/themes%2F([^?]+)/);
  if (!match) return;
  await httpsCallable(functions, 'deleteAdminImageCF')({
    prefix: 'themes', fileName: decodeURIComponent(match[1]),
  }).catch(() => {});
}

// 78차 70차: 매장 등록(단건/일괄) 시 이미 있는 매장과 동일한 정보로 중복 등록되는 걸
// 막기 위한 사전 체크 — email(필수 필드)과, 있으면 businessRegNumber까지 확인.
// 소프트 삭제된(isDeleted:true) 매장은 재계약으로 재등록하는 정상 케이스일 수 있어 제외.
async function checkDuplicateStore({ email, businessRegNumber }) {
  // 기존 데이터에 저장된 email 대소문자가 일정하다는 보장이 없어(정규화 이력 없음),
  // 오탐(false negative)을 피하려 소문자 변환 없이 trim만 해서 정확히 비교한다.
  const trimmedEmail = (email || '').trim();
  if (trimmedEmail) {
    const snap = await getDocs(query(collection(db, 'stores'), where('email', '==', trimmedEmail)));
    const dup = snap.docs.find(d => d.data().isDeleted !== true);
    if (dup) return `이미 등록된 이메일이에요(${dup.data().ownerName || '기존 매장'}).`;
  }
  if (businessRegNumber && businessRegNumber.trim()) {
    const snap = await getDocs(query(collection(db, 'stores'), where('businessRegNumber', '==', businessRegNumber.trim())));
    const dup = snap.docs.find(d => d.data().isDeleted !== true);
    if (dup) return `이미 등록된 사업자등록번호예요(${dup.data().ownerName || '기존 매장'}).`;
  }
  return null;
}

// 58차: 매장등록은 매장관리 탭 안 모달로, 수수료+정산은 하나의 정산 탭(현황/수납관리)으로 통합
const TABS = [
  { key:'plans',      label:'플랜 안내', Icon:PriceIcon },
  { key:'stores',     label:'매장관리', Icon:MenuStoreIcon },
  { key:'settlement', label:'정산',     Icon:ReceiptIcon },
];

export default function SuperAdminStoresScreen() {
  const [tab,        setTab]        = useState('stores');
  const [loading,    setLoading]    = useState(true);
  const [refreshing, setRefresh]    = useState(false);
  const [stores,       setStores]       = useState([]);
  const [reservations, setReservations] = useState([]);
  const [billings,     setBillings]     = useState([]);

  const loadAll = useCallback(async () => {
    try {
      // 오늘 fork 재검토(Firestore 읽기비용 전수점검)로 발견/수정: 이 화면(매장목록
      // 이번달 매출 요약, FeeTab/BillingTab의 최근 6개월 정산)은 전부 "이번달" 또는
      // "최근 6개월"까지만 쓰는데(BillingTab의 monthOptions가 실제로 6개월로 고정) 필터
      // 없이 reservations 전체(플랫폼 생성 이래 모든 예약)를 매번 읽고 있었음 — 6개월
      // 이전 데이터는 이 화면 어디에도 안 쓰이므로 쿼리 단계에서 잘라냄.
      const settlementCutoff = (() => {
        const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 5);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
      })();
      // 32차: 삭제된 매장 포함 전체 조회 (SuperAdmin은 삭제 매장도 관리)
      const [storeSnap, reservSnap, billingSnap] = await Promise.all([
        getAllStoresIncludeDeleted(),
        getDocs(query(collection(db,'reservations'), where('date', '>=', settlementCutoff))),
        getDocs(collection(db,'billings')),
      ]);
      setStores(storeSnap);
      setReservations(reservSnap.docs.map(d=>({id:d.id,...d.data()})));
      setBillings(billingSnap.docs.map(d=>({id:d.id,...d.data()})));
    } catch(e){ /* 무음 처리 */ }
    finally { setLoading(false); }
  }, []);

  useEffect(()=>{ loadAll(); },[loadAll]);
  const onRefresh = async ()=>{ setRefresh(true); await loadAll(); setRefresh(false); };

  const [showRegister, setShowRegister] = useState(false); // 58차: 매장등록 모달
  const [showBulkImport, setShowBulkImport] = useState(false); // 76차: 매장 일괄 등록 모달
  const [showStaffAccount, setShowStaffAccount] = useState(false); // 78차 70차: 일반 계정(직원용) 등록 모달

  // 73차: 로딩 중에도 AppHeader 유지 (탭 전환마다 헤더가 잠깐 사라지던 문제 수정)
  if (loading) return (
    <View style={s.container}>
      <AppHeader rightElement={<RoleBadge role="super" />} />
      <LoadingOverlay />
    </View>
  );

  return (
    <View style={s.container}>
      {/* 78차 37차: 총관리자 화면 전체에서 이 배지가 화면마다 다르거나 아예 없던 것을
          통일 — 75차엔 "탭바와 중복"이라 제거했으나, 다른 총관리자 화면들은 RoleBadge를
          그대로 쓰고 있어 오히려 이 화면만 빠진 상태였음. 공용 RoleBadge로 재추가. */}
      <AppHeader rightElement={<RoleBadge role="super" />} />
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={s.tabScroll}>
        <View style={s.tabRow}>
          {TABS.map(t=>(
            <TouchableOpacity key={t.key}
              style={[s.tabBtn, tab===t.key&&s.tabBtnOn]}
              onPress={()=>setTab(t.key)}>
              <IconLabel Icon={t.Icon} size={13} color={tab===t.key ? undefined : C.muted}
                textStyle={[s.tabTxt, tab===t.key&&s.tabTxtOn]}>{t.label}</IconLabel>
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>
      <ScrollView style={s.body}
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={C.gold}/>}>
        {tab==='plans'      && <PlanInfoView />}
        {tab==='stores'     && <StoresTab stores={stores} reservations={reservations} onUpdate={loadAll} onRegister={()=>setShowRegister(true)} onBulkImport={()=>setShowBulkImport(true)} onStaffAccount={()=>setShowStaffAccount(true)}/>}
        {tab==='settlement' && <SettlementComboTab stores={stores} reservations={reservations} billings={billings} onUpdate={loadAll}/>}
        <View style={{height:60}}/>
      </ScrollView>

      {/* 58차: 매장등록 — 독립 탭에서 모달로 전환 (등록은 빈도 낮은 작업) */}
      {/* 75차: 커스텀 헤더(paddingTop:50 해킹) → 공통 AppHeader로 교체 */}
      <Modal visible={showRegister} animationType="slide" onRequestClose={()=>setShowRegister(false)}>
        <View style={s.container}>
          <AppHeader
            centerElement={<Text style={[s.sectionTitle,{marginTop:0,marginBottom:0}]}>➕ 새 매장 등록</Text>}
            rightElement={
              <TouchableOpacity onPress={()=>setShowRegister(false)}>
                <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
              </TouchableOpacity>
            }
          />
          <ScrollView style={s.body}>
            <RegisterTab onComplete={()=>{loadAll();setShowRegister(false);}}/>
            <View style={{height:60}}/>
          </ScrollView>
        </View>
      </Modal>

      {/* 76차: 매장 일괄 등록(엑셀) 모달 */}
      <Modal visible={showBulkImport} animationType="slide" onRequestClose={()=>setShowBulkImport(false)}>
        <View style={s.container}>
          <AppHeader
            centerElement={<IconLabel Icon={StatsIcon} size={14} color={C.gold} textStyle={[s.sectionTitle,{marginTop:0,marginBottom:0}]}>매장 일괄 등록</IconLabel>}
            rightElement={
              <TouchableOpacity onPress={()=>setShowBulkImport(false)}>
                <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
              </TouchableOpacity>
            }
          />
          <ScrollView style={s.body}>
            <BulkStoreImportTab onComplete={()=>{loadAll();}}/>
            <View style={{height:60}}/>
          </ScrollView>
        </View>
      </Modal>

      {/* 78차 70차: 일반 계정(직원용) 등록 — 기존 매장에 사장님 계정 신규 발급 없이
          직원용 제한 계정만 단독으로 추가 발급하는 화면(일괄등록으로 만든 매장 등) */}
      <Modal visible={showStaffAccount} animationType="slide" onRequestClose={()=>setShowStaffAccount(false)}>
        <View style={s.container}>
          <AppHeader
            centerElement={<IconLabel Icon={PersonIcon} size={14} color={C.gold} textStyle={[s.sectionTitle,{marginTop:0,marginBottom:0}]}>일반 계정 등록 (직원용)</IconLabel>}
            rightElement={
              <TouchableOpacity onPress={()=>setShowStaffAccount(false)}>
                <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
              </TouchableOpacity>
            }
          />
          <ScrollView style={s.body}>
            <StaffAccountTab stores={stores} onComplete={()=>{setShowStaffAccount(false);}}/>
            <View style={{height:60}}/>
          </ScrollView>
        </View>
      </Modal>
    </View>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 78차 64차: "플랜 안내" 탭 내용을 공용 컴포넌트(PlanInfoView)로 분리 — 매장관리자도
// 같은 내용을 볼 수 있게 해달라는 요청으로, 두 화면이 각자 들고 있다가 어긋나지 않도록
// src/components/common/PlanInfoView.js 하나만 쓰도록 통일(이 파일 전용 PlanInfoTab/
// PLAN_FEATURES는 삭제).
// ══════════════════════════════════════════════════════════════════════════════

// ══════════════════════════════════════════════════════════════════════════════
// 매장 관리 탭 (원본 그대로)
// ══════════════════════════════════════════════════════════════════════════════
function StoresTab({ stores, reservations, onUpdate, onRegister, onBulkImport, onStaffAccount }) {
  const { user } = useAuth();
  const [selected,    setSelected]    = useState(null);
  const [editStore,   setEditStore]   = useState(null);
  const [saving,      setSaving]      = useState(false);
  const [deletingId,  setDeletingId]  = useState(null);
  const [uploadingEditTheme, setUploadingEditTheme] = useState(null); // 78차 46차: 매장 수정 화면 이미지 업로드 로딩 표시
  const [historyStore, setHistoryStore] = useState(null); // 75차: 계약 변경 이력 조회 대상
  const [historyBranchIdx, setHistoryBranchIdx] = useState(null); // 78차 62차: 지점별 이력만 필터
  // 76차: 검색/정렬 — 매출·평점은 정렬 이전에 한 번만 계산해 렌더 중 중복 계산을 피한다
  // 78차: 위 의도와 달리 useMemo 없이 렌더 함수 안에 그대로 있어 검색창 입력 등 무관한
  // 리렌더마다 전체 매장×전체 예약을 매번 다시 순회/재계산하고 있었음 — useMemo로 수정
  // (71차/55차에 HomeScreen.js/BookingScreen.js에서 고친 것과 동일한 유형의 문제).
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('createdAt'); // 'createdAt' | 'revenue'
  const storesWithStats = useMemo(() => {
    const thisMonth = localThisMonthStr();
    const activeRes = reservations.filter(r=>!r.cancelled&&r.revenueDuplicate!==true); // 78차 44차: 모집 일괄예약 매출 중복집계 방지
    return stores.map(store => {
      // 79차: [버그 수정] 테마명(자유 입력 텍스트) 매칭만으로 이 매장의 예약을 걸러내고
      // 있었음 — 서로 다른 두 매장이 우연히 같은 테마명("1호실" 등)을 쓰면 한 매장의
      // 매출에 남의 매장 예약이 그대로 합산되는 구조(전수 정독으로 발견). storeId가
      // 있는 예약(모든 신규 예약 경로에 존재)은 그걸로 정확히 매칭하고, storeId가 없는
      // 레거시 예약만 기존 테마명 매칭으로 폴백.
      const names = store.branches?.flatMap(b=>b.themes?.map(t=>t.name)||[]) || [];
      const matchesStore = r => r.storeId ? r.storeId === store.id : names.includes(r.productName);
      const thisRev = activeRes.filter(r=>matchesStore(r)&&r.date?.startsWith(thisMonth))
        .reduce((acc,r)=>acc+(r.price||0),0);
      const allThemes = store.branches?.flatMap(b=>b.themes||[]) || [];
      const ratedThemes = allThemes.filter(t=>t.reviewCount>0);
      const totalReviews = ratedThemes.reduce((s,t)=>s+t.reviewCount,0);
      const avgRating = totalReviews>0
        ? ratedThemes.reduce((s,t)=>s+t.rating*t.reviewCount,0)/totalReviews
        : null;
      return { ...store, _thisRev: thisRev, _avgRating: avgRating, _totalReviews: totalReviews };
    });
  }, [stores, reservations]);
  const visibleStores = useMemo(() => storesWithStats
    .filter(store => !search.trim() || store.ownerName?.toLowerCase().includes(search.trim().toLowerCase()))
    .sort((a,b) => sortBy==='revenue' ? b._thisRev-a._thisRev : (a.createdAt||'').localeCompare(b.createdAt||'')),
  [storesWithStats, search, sortBy]);

  // 76차: 담당 매장관리자 계정 정보 — 카드 펼침(selected) 시에만 지연 조회
  // 78차 42차: ID/PW 재발급 버튼이 uid를 필요로 해서 loginId만 담던 값을 {uid,loginId}로 확장
  const [adminInfo, setAdminInfo] = useState({}); // { [storeId]: 'loading' | 'none' | {uid, loginId} }
  useEffect(() => {
    if (!selected || adminInfo[selected.id]) return;
    setAdminInfo(p => ({ ...p, [selected.id]: 'loading' }));
    getDocs(query(collection(db,'users'), where('managedStores','array-contains',selected.id)))
      .then(snap => setAdminInfo(p => ({ ...p, [selected.id]: snap.empty ? 'none' : { uid: snap.docs[0].id, loginId: snap.docs[0].data().loginId || '(loginId 없음)' } })))
      .catch(() => setAdminInfo(p => ({ ...p, [selected.id]: 'none' })));
  }, [selected?.id]);

  // 78차 42차: 영업용 사전 등록 매장 — 계약 성사 시 ID/PW 재발급, 계약 불발 시 완전 삭제
  const [reissueTarget, setReissueTarget] = useState(null); // store
  const [newLoginIdDraft, setNewLoginIdDraft] = useState('');
  const [reissuing, setReissuing] = useState(false);
  const [reissuedResult, setReissuedResult] = useState(null); // {loginId, tempPassword}
  const [hardDeletingId, setHardDeletingId] = useState(null);

  const handleReissue = async () => {
    const info = adminInfo[reissueTarget?.id];
    if (!info || info === 'loading' || info === 'none') return;
    if (!newLoginIdDraft || !/^[A-Za-z0-9_]{4,}$/.test(newLoginIdDraft)) {
      showAlert('알림', 'ID는 영문/숫자/밑줄 4자 이상이어야 해요.'); return;
    }
    setReissuing(true);
    try {
      const cf = httpsCallable(functions, 'reissueStoreAdminCredentialsCF');
      const { data } = await cf({ uid: info.uid, newLoginId: newLoginIdDraft.trim() });
      setAdminInfo(p => ({ ...p, [reissueTarget.id]: { uid: info.uid, loginId: data.loginId } }));
      setReissueTarget(null);
      setNewLoginIdDraft('');
      setReissuedResult(data);
    } catch (e) { showAlert('오류', e.message); }
    finally { setReissuing(false); }
  };

  // 계약 불발 시 완전 삭제 — softDeleteStore(일시 비활성화)와 달리 되돌릴 수 없음.
  // 실수 방지를 위해 이미 "비활성화" 상태인 매장에만 허용(라이브 매장 오조작 방지).
  const handleHardDelete = (store) => {
    showAlert(
      '매장 완전 삭제',
      `"${store.ownerName}" 매장과 담당 관리자 계정을 되돌릴 수 없이 완전히 삭제합니다.\n영업용으로 미리 등록해둔 매장이 계약 불발됐을 때만 사용하세요.`,
      [
        { text: '취소', style: 'cancel' },
        { text: '완전 삭제', style: 'destructive', onPress: async () => {
          setHardDeletingId(store.id);
          try {
            const cf = httpsCallable(functions, 'deleteStoreCompletelyCF');
            await cf({ storeId: store.id });
            setSelected(null);
            onUpdate();
          } catch (e) { showAlert('오류', e.message); }
          finally { setHardDeletingId(null); }
        }},
      ]
    );
  };

  // 76차: 매장 내부 메모 — 총괄관리자 전용 자유 텍스트
  const [noteDraft, setNoteDraft] = useState({}); // { [storeId]: text }
  const [savingNoteId, setSavingNoteId] = useState(null);
  const handleSaveNote = async (store) => {
    setSavingNoteId(store.id);
    try {
      await updateDoc(doc(db,'stores',store.id), { internalNote: noteDraft[store.id] ?? '' });
      // 80차 후속: [버그 수정 — write-then-display 재감사로 발견] 이 화면의 다른 모든
      // stores 문서 쓰기(삭제/복구/플랜변경/애드온/계약연장/EditStore저장)는 전부
      // invalidateStoreCache()를 부르는데 이것만 빠져있었음 — noteDraft가 이 화면
      // 자체의 표시는 이미 정확히 가리고 있어 눈에 띄는 버그는 아니었지만, 12초 공용
      // 캐시가 안 비워져 그 창 안에 다른 화면이 낡은 값을 볼 수 있는 사각지대였음.
      invalidateStoreCache();
      onUpdate();
    } catch(e) { showAlert('오류', e.message); }
    finally { setSavingNoteId(null); }
  };

  // 32차: 매장 soft-delete
  // 78차 62차: branchIdx를 넘기면 그 지점만 비활성화(branches[i].isDeleted) — 다른
  // 지점은 계속 노출됨. 안 넘기면 기존처럼 매장(사업자) 전체를 비활성화.
  const handleSoftDelete = (store, branchIdx = null) => {
    const branch = branchIdx != null ? store.branches?.[branchIdx] : null;
    const target = branchIdx != null ? `${store.ownerName} · ${branch?.branchName || ''}` : store.ownerName;
    showAlert(
      branchIdx != null ? '지점 비활성화' : '매장 비활성화',
      `"${target}"${branchIdx != null ? ' 지점을' : ' 매장을'} 비활성화하시겠습니까?\n앱에서 검색되지 않으며 언제든 복구할 수 있습니다.`,
      [
        { text: '취소', style: 'cancel' },
        { text: '비활성화', style: 'destructive', onPress: async () => {
          const key = branchIdx != null ? `${store.id}_${branchIdx}` : store.id;
          setDeletingId(key);
          try {
            if (branchIdx != null) {
              const branches = (store.branches || []).map((b, i) => i === branchIdx ? { ...b, isDeleted: true } : b);
              await updateDoc(doc(db, 'stores', store.id), { branches });
              invalidateStoreCache();
            } else {
              await softDeleteStore(store.id);
              // 34차: notifyStoreDeleted 자동 연결 — 미래 예약자에게 일괄 알림
              notifyStoreDeleted(store.id, store.ownerName).catch(() => {});
            }
            onUpdate();
          } catch(e) { showAlert('오류', e.message); }
          finally { setDeletingId(null); }
        }},
      ]
    );
  };

  // 32차: 매장 복구
  const handleRestore = async (store, branchIdx = null) => {
    const branch = branchIdx != null ? store.branches?.[branchIdx] : null;
    const target = branchIdx != null ? `${store.ownerName} · ${branch?.branchName || ''}` : store.ownerName;
    showAlert(
      branchIdx != null ? '지점 복구' : '매장 복구',
      `"${target}"${branchIdx != null ? ' 지점을' : ''} 다시 활성화하시겠습니까?`,
      [
        { text: '취소', style: 'cancel' },
        { text: '복구', onPress: async () => {
          const key = branchIdx != null ? `${store.id}_${branchIdx}` : store.id;
          setDeletingId(key);
          try {
            if (branchIdx != null) {
              const branches = (store.branches || []).map((b, i) => i === branchIdx ? { ...b, isDeleted: false } : b);
              await updateDoc(doc(db, 'stores', store.id), { branches });
              invalidateStoreCache();
            } else {
              await restoreStore(store.id);
            }
            onUpdate();
          } catch(e) { showAlert('오류', e.message); }
          finally { setDeletingId(null); }
        }},
      ]
    );
  };

  // 78차 46차: 계약 연장 — 동일 조건(플랜 등 그대로) 유지하고 계약종료일만 현재
  // 종료일 기준 +1년으로 미루는 원클릭 버튼. 기존 계약기간 변경(수동 수정)과 동일하게
  // logContractChange의 'contractPeriod' 카테고리를 그대로 재사용해 계약 이력에 남김
  // (새 이력 유형/화면 추가 없이 기존 "📜 계약 이력" 조회에 바로 잡히게).
  // 78차 62차: branchIdx를 넘기면 그 지점의 계약종료일(없으면 store 값 폴백)만 연장 —
  // 지점마다 계약 시작/종료일이 다를 수 있다는 요청 반영.
  const [extendingId, setExtendingId] = useState(null);
  const handleExtendContract = (store, branchIdx = null) => {
    const branch = branchIdx != null ? store.branches?.[branchIdx] : null;
    const oldEnd = (branch && branch.contractEnd) || store.contractEnd;
    const oldStart = (branch && branch.contractStart) || store.contractStart;
    if (!oldEnd) { showAlert('알림', '계약 종료일이 없어서 연장할 기준일을 알 수 없어요. 매장 수정에서 먼저 계약 기간을 설정해주세요.'); return; }
    const newEnd = new Date(oldEnd);
    newEnd.setFullYear(newEnd.getFullYear() + 1);
    const newEndStr = newEnd.toISOString().slice(0,10);
    const target = branchIdx != null ? `${store.ownerName} · ${branch?.branchName || ''}` : store.ownerName;
    const key = branchIdx != null ? `${store.id}_${branchIdx}` : store.id;
    showAlert(
      '계약 연장',
      `"${target}"의 계약 종료일을 ${oldEnd} → ${newEndStr}로 연장할까요?\n(다른 계약 조건은 그대로 유지됩니다)`,
      [
        { text: '취소', style: 'cancel' },
        { text: '연장', onPress: async () => {
          setExtendingId(key);
          try {
            if (branchIdx != null) {
              const branches = (store.branches || []).map((b, i) =>
                i === branchIdx ? { ...b, contractStart: oldStart ?? null, contractEnd: newEndStr } : b
              );
              await updateDoc(doc(db,'stores',store.id), { branches });
            } else {
              // 78차: functions/index.js의 scheduledContractExpiryReminder가 한 번 알림을
              // 보내면 contractExpiryReminded30d/7d를 영구히 true로 남겨서, 계약을 연장해도
              // "새 종료일 기준" 30일/7일 전 알림이 다시는 안 오던 버그(전수조사로 발견) —
              // 종료일이 실제로 바뀌는 시점에 두 플래그를 초기화.
              await updateDoc(doc(db,'stores',store.id), {
                contractEnd: newEndStr,
                contractExpiryReminded30d: false,
                contractExpiryReminded7d: false,
              });
            }
            invalidateStoreCache();
            logContractChange(store.id, 'contractPeriod',
              { contractStart: oldStart ?? null, contractEnd: oldEnd },
              { contractStart: oldStart ?? null, contractEnd: newEndStr },
              user?.uid, branchIdx
            ).catch(()=>{});
            onUpdate();
          } catch(e) { showAlert('오류', e.message); }
          finally { setExtendingId(null); }
        }},
      ]
    );
  };

  // 68차: plan 4단계(basic/standard/premium/boost) 선택 모달로 교체
  // 기존엔 free↔premium 2단계 토글뿐이었으나, 코드 곳곳(StoreAdminScreen 등)이
  // 이미 4단계를 전제로 게이트하고 있어 실제 설정 UI가 없는 상태였음(버그).
  const [togglingPlanId, setTogglingPlanId] = useState(null);
  const [planPickerStore, setPlanPickerStore] = useState(null);
  const [planPickerBranchIdx, setPlanPickerBranchIdx] = useState(null); // 78차 62차: 지점별 플랜 변경

  const handleChangePlan = async (store, nextPlan, branchIdx = null) => {
    const key = branchIdx != null ? `${store.id}_${branchIdx}` : store.id;
    setTogglingPlanId(key);
    try {
      const beforePlan = getBranchPlan(store, branchIdx);
      // 80차 후속: PREMIUM은 UNLOCK 기여도/업계비교가 애드온까지 켜져 있어야 실제로
      // 보이는데, 애드온을 따로 켜는 걸 잊으면 "PREMIUM 요금 내고도 잠겨있다"는 불만이
      // 생길 수 있음(사용자 지적) — PREMIUM으로 "새로 전환"하는 순간엔 애드온도 함께
      // 켜서 기본으로 전체 가치를 보여준다. 이미 PREMIUM이던 걸 다시 선택(재확인 클릭)
      // 하는 경우는 건드리지 않음 — 노출만 원해서 의도적으로 애드온을 꺼둔 매장이
      // 재클릭만으로 다시 켜지는 걸 방지.
      const autoEnableOps = nextPlan === 'premium' && beforePlan !== 'premium' && !hasOpsAddon(store, branchIdx);
      if (branchIdx != null) {
        const branches = (store.branches || []).map((b, i) => i === branchIdx ? { ...b, plan: nextPlan, ...(autoEnableOps ? { opsAddon: true } : {}) } : b);
        await updateDoc(doc(db,'stores',store.id), { branches });
      } else {
        await updateDoc(doc(db,'stores',store.id), { plan: nextPlan, ...(autoEnableOps ? { opsAddon: true } : {}) });
      }
      invalidateStoreCache();
      logContractChange(store.id, 'plan', { plan: beforePlan }, { plan: nextPlan }, user?.uid, branchIdx).catch(()=>{});
      if (autoEnableOps) {
        logContractChange(store.id, 'opsAddon', { opsAddon: false }, { opsAddon: true }, user?.uid, branchIdx).catch(()=>{});
      }
      setPlanPickerStore(null);
      setPlanPickerBranchIdx(null);
      onUpdate();
    } catch(e) { showAlert('오류', e.message); }
    finally { setTogglingPlanId(null); }
  };

  // 80차 후속: 매장관리자 기능 애드온 — plan과 완전히 독립된 boolean, handleChangePlan과
  // 동일한 저장/이력기록/무효화 패턴을 재사용.
  // [버그 수정] handleChangePlan은 성공 시 모달을 닫아버려서(setPlanPickerStore(null))
  // 다음에 열 때 항상 최신 store를 다시 받는데, 이 함수는 여러 번 연속 토글할 수 있도록
  // 모달을 열어둔 채로 두면서 정작 화면이 읽는 planPickerStore 로컬 상태는 갱신을 안 해서
  // Firestore 쓰기는 실제로 성공해도 화면(뱃지/"켜짐·꺼짐" 라벨)은 토글 이전 값 그대로
  // 남아 "눌러도 반응이 없다"로 보였음 — 쓰기 성공 직후 planPickerStore를 직접 갱신.
  const handleToggleOpsAddon = async (store, branchIdx = null) => {
    const key = `ops_${branchIdx != null ? `${store.id}_${branchIdx}` : store.id}`;
    setTogglingPlanId(key);
    try {
      const before = hasOpsAddon(store, branchIdx);
      const next = !before;
      let updatedStore;
      if (branchIdx != null) {
        const branches = (store.branches || []).map((b, i) => i === branchIdx ? { ...b, opsAddon: next } : b);
        await updateDoc(doc(db,'stores',store.id), { branches });
        updatedStore = { ...store, branches };
      } else {
        await updateDoc(doc(db,'stores',store.id), { opsAddon: next });
        updatedStore = { ...store, opsAddon: next };
      }
      invalidateStoreCache();
      logContractChange(store.id, 'opsAddon', { opsAddon: before }, { opsAddon: next }, user?.uid, branchIdx).catch(()=>{});
      setPlanPickerStore(prev => (prev && prev.id === store.id) ? updatedStore : prev);
      onUpdate();
    } catch(e) { showAlert('오류', e.message); }
    finally { setTogglingPlanId(null); }
  };

  // 75차: 계약기간(contractStart/contractEnd) 변경 여부를 나중에 diff하기 위해 원본 스냅샷 보관
  // 78차 46차: 수수료(feeType 등) 스냅샷/이력 기록 삭제 — 해당 정책 자체를 안 씀
  // 79차: [버그 수정] plan/planDiscountRate 스냅샷 누락 — 이 모달(EditStore) 안의 인라인
  // 필드로 플랜 할인율(store.planDiscountRate, FI)이나 지점별 플랜(다중지점 매장의 b.plan
  // 칩)을 바꿔 저장해도 contractHistory에 전혀 기록되지 않고 있었음(계약 이력 화면에
  // "언제 할인율이 바뀌었는지"가 통째로 빠짐) — 별도의 "💳 플랜 변경" 버튼(handleChangePlan)
  // 경로만 'plan' 카테고리로 기록하고 있어서, 어느 UI로 같은 필드를 바꿨는지에 따라
  // 감사 기록 여부가 갈리는 구조였음(전수 정독으로 발견). contractPeriod와 동일한
  // 스냅샷+diff 패턴을 plan/planDiscountRate에도 적용.
  const [origContract, setOrigContract] = useState(null);
  // 78차 71차: 테마 이미지 재업로드 시 이전 Storage 파일이 지워지지 않고 영구히 남던
  // 문제 — 저장 시점에 "바뀌었는지" 비교할 원본 imageUrl을 편집 시작 시점에 스냅샷.
  const [origThemeImages, setOrigThemeImages] = useState({});
  const openEdit = (store) => {
    setEditStore(JSON.parse(JSON.stringify(store)));
    setOrigContract({
      contractStart: store.contractStart ?? null, contractEnd: store.contractEnd ?? null,
      plan: store.plan ?? null, planDiscountRate: store.planDiscountRate ?? null,
      // 78차 62차: 지점별 계약기간도 나중에 diff해서 바뀐 지점만 이력에 남기기 위한 스냅샷
      branches: (store.branches || []).map(b => ({
        contractStart: b.contractStart ?? null, contractEnd: b.contractEnd ?? null,
        plan: b.plan ?? null, planDiscountRate: b.planDiscountRate ?? null,
        opsAddon: b.opsAddon ?? null,
      })),
    });
    const images = {};
    (store.branches || []).forEach((b, bi) => (b.themes || []).forEach((t, ti) => {
      if (t.imageUrl) images[`${bi}_${ti}`] = t.imageUrl;
    }));
    setOrigThemeImages(images);
  };

  // 78차 46차: 매장 수정 화면의 테마 이미지가 URL 텍스트 입력만 가능했던 것 —
  // RegisterTab의 pickThemeImage와 동일한 패턴으로 갤러리 업로드 추가
  const pickEditThemeImage = async (bi,ti) => {
    const perm = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (!perm.granted) { showAlert('권한 필요','갤러리 접근 권한이 필요합니다.'); return; }
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true, aspect: [4,3], quality: 0.8,
    });
    if (!result.canceled && result.assets[0]) {
      ET(bi,ti,'imageLocalUri',result.assets[0].uri);
      ET(bi,ti,'imageUrl','');
    }
  };

  const handleEditSave = async () => {
    if (!editStore) return;
    setSaving(true);
    try {
      const { id, ...data } = editStore;
      data.paymentDay   = data.paymentDay ? Number(data.paymentDay) : null;
      data.planDiscountRate = Math.min(100, Math.max(0, Number(data.planDiscountRate) || 0));
      // 78차 50차: 운영시간이 매장 공통 설정으로 바뀜 — 비워두면 기본값
      data.startTime = data.startTime || '09:00';
      data.endTime   = data.endTime   || '22:00';
      // 78차: 계약 종료일을 여기서 직접 수정해도(연장 버튼 말고) contractExpiryReminded30d/7d가
      // 그대로 남아 새 종료일 기준 재알림이 안 가던 문제 — 종료일이 바뀔 때만 초기화.
      if ((data.contractEnd ?? null) !== (origContract?.contractEnd ?? null)) {
        data.contractExpiryReminded30d = false;
        data.contractExpiryReminded7d = false;
      }
      // 78차 46차: 로컬에서 새로 고른 테마 이미지(imageLocalUri)를 Storage에 업로드하고
      // 그 결과 URL로 치환 — RegisterTab의 handleRegister와 동일한 패턴
      // 78차 57차: 운영 종료시간(매장 공통)이 바뀌었을 수 있어 저장 시점에 모든 테마의
      // availableTimes를 다시 계산 — 간격 = 플레이시간(duration)+준비시간(prepMinutes),
      // 시작시간은 테마 자체 값 우선, 없으면 매장 공통(data.startTime).
      data.branches = await Promise.all((data.branches||[]).map(async (b,bi)=>({
        ...b,
        // 78차 62차: 지점별 계약 조건 입력값(문자열)을 저장 전 타입 보정 — 레거시 지점
        // (아직 이 필드들이 없던 단일지점 매장)은 null로 정리돼도 branchOverride가
        // store 최상위 값으로 폴백하므로 동작에 변화 없음.
        paymentDay: b.paymentDay ? Number(b.paymentDay) : null,
        // 78차 48차: planDiscountRate가 아예 없는 지점(필드 자체가 undefined인 레거시/
        // 신규 지점)을 저장하면 else 분기가 b.planDiscountRate(undefined)를 그대로 반환해
        // Firestore updateDoc이 "Unsupported field value: undefined"로 저장 자체를
        // 실패시키던 버그 — 위 주석의 원래 의도(레거시 지점은 null로 정리)대로 수정.
        planDiscountRate: (b.planDiscountRate !== undefined && b.planDiscountRate !== null && b.planDiscountRate !== '')
          ? Math.min(100, Math.max(0, Number(b.planDiscountRate) || 0)) : null,
        themes: await Promise.all((b.themes||[]).map(async (t,ti)=>{
          let imageUrl = t.imageUrl;
          if (t.imageLocalUri) {
            setUploadingEditTheme({bi,ti});
            imageUrl = await uploadImageAsync(t.imageLocalUri, 'themes');
            // 78차 71차: 새 이미지로 교체됐으면 이전 파일은 이제 아무 데도 안 쓰이는
            // 고아 파일이 되므로 정리(저장 실패와 무관하게 best-effort)
            const prevUrl = origThemeImages[`${bi}_${ti}`];
            if (prevUrl && prevUrl !== imageUrl) deleteOldThemeImage(prevUrl);
          }
          const { imageLocalUri, ...rest } = t;
          const prepMinutes = Number(t.prepMinutes) || 0;
          const interval = Number(t.duration || 60) + prepMinutes;
          // 80차 후속: [버그 수정] 여기서 매번 computeShowPricing으로 pricing을 강제
          // 재계산하고 있어서, EditStore의 "표에 일괄 채우기" 버튼 이후 인원별로 직접
          // 고친 값이 저장 시점에 전부 덮어써지고 있었음 — rest.pricing(테이블에 이미
          // 반영된 값)을 그대로 저장(방탈출과 동일하게).
          return {
            ...rest, imageUrl,
            prepMinutes, intervalMinutes: interval,
            capacity: t.capacity ? Number(t.capacity) : 0,
            availableTimes: generateBulkSlots(t.startTime || data.startTime, data.endTime, interval, t.blockedSlots),
          };
        })),
      })));
      setUploadingEditTheme(null);
      // stores 문서 업데이트
      // 68차: products 컬렉션 동기화 로직 제거 — 아무 화면에서도 읽지 않는 죽은
      // 병행 시스템으로 확인되어, 이중 쓰기 자체를 제거함(인수인계서 PENDING 항목 해결).
      // productService.js 주석에도 명시되어 있듯 앱 전역 productId 표준은
      // stores.branches[].themes[] 기반 합성 ID(storeId_branchIdx_themeIdx)이다.
      await updateDoc(doc(db,'stores',id), data);
      invalidateStoreCache();

      // 75차: 계약기간이 실제로 바뀐 경우에만 이력 기록
      if (origContract && (origContract.contractStart !== (data.contractStart ?? null) || origContract.contractEnd !== (data.contractEnd ?? null))) {
        logContractChange(id, 'contractPeriod',
          { contractStart: origContract.contractStart, contractEnd: origContract.contractEnd },
          { contractStart: data.contractStart ?? null, contractEnd: data.contractEnd ?? null }, user?.uid
        ).catch(()=>{});
      }
      // 79차: [버그 수정] 이 모달의 "플랜 할인율" FI 필드로 store.planDiscountRate를
      // 바꿔도 이력에 안 남던 것 — contractPeriod와 동일한 diff 패턴 적용.
      if (origContract && (normalizePlan(origContract.plan) !== normalizePlan(data.plan) || (origContract.planDiscountRate ?? null) !== (data.planDiscountRate ?? null))) {
        logContractChange(id, 'plan',
          { plan: normalizePlan(origContract.plan), planDiscountRate: origContract.planDiscountRate ?? null },
          { plan: normalizePlan(data.plan), planDiscountRate: data.planDiscountRate ?? null }, user?.uid
        ).catch(()=>{});
      }
      // 78차 62차: 지점별 계약기간도 바뀐 지점만 골라 이력에 남김(branchIdx 태그)
      (data.branches || []).forEach((b, bi) => {
        const before = origContract?.branches?.[bi];
        if (!before) return;
        const after = { contractStart: b.contractStart ?? null, contractEnd: b.contractEnd ?? null };
        if (before.contractStart !== after.contractStart || before.contractEnd !== after.contractEnd) {
          logContractChange(id, 'contractPeriod', { contractStart: before.contractStart, contractEnd: before.contractEnd }, after, user?.uid, bi).catch(()=>{});
        }
        // 79차: [버그 수정] 다중지점 매장의 지점별 플랜 칩/할인율 FI(이 모달 "이 지점 계약
        // 조건" 섹션)도 동일하게 누락돼 있었음 — 지점별로도 바뀐 경우에만 기록.
        // 80차 후속: opsAddon(매장관리자 기능 애드온) 인라인 체크박스도 동일 패턴으로 추가.
        if ((before.plan ?? null) !== (b.plan ?? null) || (before.planDiscountRate ?? null) !== (b.planDiscountRate ?? null) || (before.opsAddon ?? null) !== (b.opsAddon ?? null)) {
          logContractChange(id, 'plan',
            { plan: before.plan ?? null, planDiscountRate: before.planDiscountRate ?? null, opsAddon: before.opsAddon ?? null },
            { plan: b.plan ?? null, planDiscountRate: b.planDiscountRate ?? null, opsAddon: b.opsAddon ?? null }, user?.uid, bi
          ).catch(()=>{});
        }
      });

      showAlert('완료','매장 정보가 수정되었습니다.');
      setEditStore(null);
      onUpdate();
    } catch(e) { showAlert('오류','수정 실패: '+e.message); }
    finally { setSaving(false); }
  };

  const EB = (bi,k,v) => setEditStore(p=>{const u=JSON.parse(JSON.stringify(p));u.branches[bi][k]=v;return u;});
  const ET = (bi,ti,k,v) => setEditStore(p=>{
    const u=JSON.parse(JSON.stringify(p));
    const theme=u.branches[bi].themes[ti];
    theme[k]=v;
    // 80차 후속: "체험형"으로 처음 전환할 때(비어있을 때만) 기본 유의사항/환불정책 채움
    if(k==='bookingFormat'&&v==='show'){
      if(!theme.notices) theme.notices=SHOW_DEFAULT_NOTICES;
      if(!theme.refundPolicy) theme.refundPolicy=SHOW_DEFAULT_REFUND_POLICY;
    }
    // 80차 후속: [기능 추가] RegisterTab의 updateTheme과 동일 — 최소/최대 인원이 바뀌면
    // 가격표 행도 그 범위에 맞춰 다시 만듦(기존에 입력해둔 값은 인원수가 겹치면 보존).
    // 지금까지 EditStore엔 이 동기화 자체가 없어서 기존 매장은 인원 범위를 넓혀도
    // 가격표 행이 안 늘어나고 있었음.
    if(k==='minPeople'||k==='maxPeople'){
      const min=Number(k==='minPeople'?v:theme.minPeople);
      const max=Number(k==='maxPeople'?v:theme.maxPeople);
      if(min>0&&max>=min){
        theme.pricing=Array.from({length:max-min+1},(_,i)=>{
          const existing=(theme.pricing||[]).find(pp=>pp.people===min+i);
          return {people:min+i,price:existing?.price||''};
        });
      }
    }
    return u;
  });
  // 80차 후속: [기능 추가] EditStore에는 지금까지 가격표를 직접 수정하는 UI 자체가 없어서
  // (RegisterTab에만 있었음) 기존 매장의 인원별 가격은 등록 이후엔 고칠 방법이 없었음
  // — 방탈출도 체험형도 동일하게 적용되는 사각지대라 함께 추가.
  const updateEditPricing = (bi,ti,pi,v) => setEditStore(p=>{
    const u=JSON.parse(JSON.stringify(p));
    const theme=u.branches[bi].themes[ti];
    const pricing=[...(theme.pricing||[])];
    pricing[pi]={...pricing[pi],price:v};
    theme.pricing=pricing;
    return u;
  });
  const addBranch = () => setEditStore(p=>{const u=JSON.parse(JSON.stringify(p));u.branches.push({branchName:'',city:'',district:'',addressDetail:'',themes:[{name:'',genre:'공포',difficulty:'normal',minPeople:2,maxPeople:4,duration:60,bookingFormat:'room',capacity:'',activityLevel:'normal',pricePerPerson:'',notices:'',refundPolicy:'',seatingType:'shared',description:'',imageUrl:'',pricing:[]}]});return u;});
  // 78차 46차: splice로 배열 중간 지점을 실제로 빼면 뒤 지점들의 branchIdx가 당겨져서,
  // 이미 저장된 예약/리뷰/즐겨찾기/PICK이 참조하던 productId(storeId_branchIdx_themeIdx,
  // 위치 기반)가 엉뚱한 지점·테마를 가리키게 되는 버그가 있었음(크래시 없이 조용히
  // 데이터가 틀어지는 유형이라 더 위험) — 배열에서 빼지 않고 isDeleted 플래그만 세우는
  // 소프트 삭제로 전환(78차62차의 지점 비활성화·restore와 동일 패턴, 아래 목록 렌더링에서
  // isDeleted인 지점/테마는 숨김). 지점은 이미 있는 "지점 복구" 버튼(store 상세 카드)으로
  // 되돌릴 수 있고, 테마는 이 화면 안에 인라인 복구 버튼을 추가함.
  const removeBranch = (bi) => setEditStore(p=>{const u=JSON.parse(JSON.stringify(p));u.branches[bi].isDeleted=true;return u;});
  const addTheme = (bi) => setEditStore(p=>{const u=JSON.parse(JSON.stringify(p));u.branches[bi].themes.push({name:'',genre:'공포',difficulty:'normal',minPeople:2,maxPeople:4,duration:60,bookingFormat:'room',capacity:'',activityLevel:'normal',pricePerPerson:'',notices:'',refundPolicy:'',seatingType:'shared',description:'',imageUrl:'',pricing:[]});return u;});
  const removeTheme  = (bi,ti) => setEditStore(p=>{const u=JSON.parse(JSON.stringify(p));u.branches[bi].themes[ti].isDeleted=true;return u;});
  const restoreTheme = (bi,ti) => setEditStore(p=>{const u=JSON.parse(JSON.stringify(p));u.branches[bi].themes[ti].isDeleted=false;return u;});

  return (
    <View>
      {/* 58차: 매장등록 — 빈도 낮은 작업이라 독립 탭 대신 여기 버튼으로 노출 */}
      {/* 76차: 매장 일괄 등록(엑셀) 버튼 추가 — 계약 체결 후 다수 매장을 한 번에 등록하는 용도 */}
      {/* 80차 후속: 표준 경로를 "새 매장 등록"(테마 3~6개는 그 화면의 "+ 테마 추가"로 한
          세션에 처리 가능)으로 확정 — 일괄 등록(엑셀)은 기능은 유지하되 여러 "매장"을
          정말 한 번에 등록해야 하는 드문 경우 전용으로 순서/문구만 조정(사용자 결정). */}
      <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginBottom:2,gap:8}}>
        <Text style={[s.sectionTitle,{marginTop:6,marginBottom:0,flex:1}]}>매장 목록 ({stores.length}개)</Text>
        <SecondaryButton label="+ 새 매장 등록" onPress={onRegister} style={s.smBtn} textStyle={s.smBtnTxt} />
        <SecondaryButton label="👤 일반 계정 등록" onPress={onStaffAccount} style={s.smBtn} textStyle={s.smBtnTxt} />
        <SecondaryButton label="📊 일괄 등록" onPress={onBulkImport} style={s.smBtn} textStyle={s.smBtnTxt} />
      </View>
      <Text style={[s.muted,{marginBottom:6,fontSize:11}]}>테마가 여러 개인 매장 하나는 "새 매장 등록"에서 "+ 테마 추가"로 한 번에 등록하세요. 일괄 등록(엑셀)은 매장 여러 곳을 동시에 등록해야 할 때만 사용하세요.</Text>

      {/* 76차: 검색 + 정렬 */}
      <TextInput style={[s.input,{marginBottom:8}]} value={search} onChangeText={setSearch}
        placeholder="매장명 검색" placeholderTextColor={C.muted}/>
      <View style={{flexDirection:'row',gap:8,marginBottom:12}}>
        {[{v:'createdAt',l:'등록순'},{v:'revenue',l:'매출순'}].map(opt=>(
          <TouchableOpacity key={opt.v} style={[s.chip,sortBy===opt.v&&s.chipOn]} onPress={()=>setSortBy(opt.v)}>
            <Text style={[s.chipTxt,sortBy===opt.v&&s.chipTxtOn]}>{opt.l}</Text>
          </TouchableOpacity>
        ))}
      </View>

      {stores.length===0
        ? <EmptyState Icon={MenuStoreIcon} text="등록된 매장이 없습니다."/>
        : visibleStores.length===0
        ? <EmptyState Icon={SearchIcon} text="검색 결과가 없습니다."/>
        : visibleStores.map(store=>{
          const names  =store.branches?.flatMap(b=>b.themes?.map(t=>t.name)||[])||[];
          // 80차 후속: 매장이 매장관리자 화면에 로그인 안 해도(대형 프랜차이즈는 특히
          // 로그인 자체를 잘 안 할 수 있음) 대표님이 영업 중에 바로 확인할 수 있도록
          // 홍보 링크(themeShareCF) 조회수를 매장 전체 합산해서 총관리자 화면에 노출.
          const shareViews = store.branches?.flatMap(b=>b.themes?.map(t=>t.shareViewCount||0)||[]).reduce((a,c)=>a+c,0)||0;
          const thisRev=store._thisRev;
          // 78차 47차: 카드 우상단 금액이 순수 예약 매출(테스트 매장은 항상 0원)이라
          // 상세보기의 "월 청구액"과 달라 보인다는 지적 — 동일한 청구액 계산으로 통일
          // 80차 후속: [버그 수정, 돈 표시 누락] opsAddonFee가 빠져 있어 애드온 켜진
          // 매장은 이 카드의 "월 청구액"이 실제보다 15,000원 적게 보였음. pickAddonFee는
          // 이 탭(StoresTab)이 애초에 PICK 유료슬롯 개수를 안 불러와(BillingTab/FeeTab만
          // paidPickCounts를 fetch) 여기 넣으려면 별도 조회가 필요한 기존부터의 설계
          // 범위 밖이라 이번엔 opsAddonFee만 추가(원래도 없었던 pickAddonFee까지 확장하는
          // 건 범위 밖 — 필요하면 별도 요청).
          const billing=calcStoreFee(store,thisRev,names.length)+getPlanFee(store)+getOpsAddonFee(store);
          const dd     =dDayLabel(store.contractEnd);
          const urgent =dd!=='-'&&dd!=='만료'&&parseInt(dd.replace('D-',''))<=30;
          const isOpen =selected?.id===store.id;
          const multiBranch = (store.branches||[]).length > 1; // 78차 62차: 지점 2개 이상이면 아래 버튼이 "전체" 대상임을 명시
          return (
            <View key={store.id} style={[s.card,{padding:0,overflow:'hidden'}, store.isDeleted&&s.cardDeleted]}>
              <TouchableOpacity style={s.storeHeader} onPress={()=>setSelected(isOpen?null:store)}>
                <View style={{flex:1}}>
                  <View style={{flexDirection:'row',alignItems:'center',gap:6}}>
                    <Text style={s.drillName}>{store.ownerName}</Text>
                    {/* 32차: 비활성화 배지 */}
                    {store.isDeleted && (
                      <View style={s.deletedBadge}>
                        <Text style={s.deletedBadgeTxt}>비활성</Text>
                      </View>
                    )}
                    {/* 74차: 영업용 데모 매장 배지 — 실제 계약 전 테스트 데이터임을 총괄관리자가 바로 알 수 있도록 */}
                    {store.isDemo && (
                      <View style={s.demoBadge}>
                        <Text style={s.demoBadgeTxt}>🧪 데모</Text>
                      </View>
                    )}
                    {/* 75차: 디자인 시스템 플랜 라인 컬러 적용 */}
                    {/* 78차 62차: plan이 지점별로 다를 수 있어 목록 카드엔 지점 중 최고 등급만
                        요약 배지로 표시(getEffectivePlan) — 정확한 지점별 값은 펼쳐서 확인 */}
                    {/* 80차 후속: 2단계 체계에선 항상 STANDARD/PREMIUM 둘 중 하나라 "무배지"
                        조건 자체가 의미 없어져 제거, opsAddon 켜져 있으면 "+" 표시 */}
                    <View style={[s.premiumBadge,{
                      backgroundColor:PLAN_COLORS[normalizePlan(getEffectivePlan(store))]+'22',
                      borderColor:PLAN_COLORS[normalizePlan(getEffectivePlan(store))]+'55',
                    }]}>
                      <Text style={[s.premiumBadgeTxt,{color:PLAN_COLORS[normalizePlan(getEffectivePlan(store))]}]}>
                        {normalizePlan(getEffectivePlan(store)) === 'premium' ? '✨ ' : '⭐ '}
                        {getPlanBadgeLabel(getEffectivePlan(store), hasOpsAddon(store))}
                      </Text>
                    </View>
                  </View>
                  <Text style={s.muted}>{store.branches?.length||0}개 지점 · 테마 {names.length}개</Text>
                </View>
                <View style={{alignItems:'flex-end',gap:4}}>
                  <Text style={{color:urgent?C.danger:C.warning,fontWeight:'700',fontSize:12}}>{dd}</Text>
                  <Text style={{color:C.success,fontSize:12}}>{krw(billing)}</Text>
                  {store._avgRating!=null && (
                    <IconLabel Icon={StarIcon} size={12} color={C.gold} textStyle={{color:C.gold,fontSize:12}}>{store._avgRating.toFixed(1)} ({store._totalReviews})</IconLabel>
                  )}
                  <Text style={{color:C.muted,fontSize:12}}>{isOpen?'▲':'▼'}</Text>
                </View>
              </TouchableOpacity>
              {isOpen&&(
                <View style={s.storeDetail}>
                  <InfoRow label="이메일"    value={store.email||'-'}/>
                  <InfoRow label="연락처"    value={store.contact||'-'}/>
                  {/* 78차 52차: "매장 관리자 이름을 더 보여줬으면" 요청 — 사업자명/연락처만
                      있고 실제 담당자 실명 필드가 아예 없었음, 새로 추가 */}
                  <InfoRow label="담당자명"  value={store.contactName||'-'}/>
                  {/* 78차 54차: 정산·세금계산서 등에 필요한 사업자등록번호 — 별도 필드가 없어 추가 */}
                  <InfoRow label="사업자등록번호" value={store.businessRegNumber||'-'}/>
                  <InfoRow label="계약 기간" value={`${store.contractStart||'-'} ~ ${store.contractEnd||'-'}`}/>
                  <InfoRow label="결제 방식" value={store.paymentType==='external'?'외부 결제':'플랫폼 결제'}/>
                  {/* 78차 44차: feeType 없는(=수수료 안 받는) 신규 매장이 기본값이 됨 —
                      과거에 feeType이 실제로 설정된 매장만 예전처럼 표시, 나머진 "없음" */}
                  {/* 78차 46차: 안 쓰는 수수료 정책 행 삭제 — 플랜 구독료만 받으므로
                      "플랜"과 별개로 이 매장에 실제 청구되는 월 금액(구독료+수수료, 지금은
                      항상 구독료와 같음)을 바로 보여주는 "월 청구액" 행 추가 */}
                  {/* 78차 52차: 할인율을 "플랜" 행이 아니라 실제 금액이 있는 "월 청구액" 행에 표기 */}
                  {/* 78차 62차: 지점이 2개 이상이면 plan/할인율이 지점마다 다를 수 있어
                      단일 값 대신 "지점별 상이" 안내 — 실제 값은 아래 지점 카드에서 확인.
                      월 청구액(billing)은 getPlanFee가 지점별로 합산해 이미 정확함. */}
                  <InfoRow label="플랜"      value={multiBranch ? '지점별 상이 (아래 참고)' : PLAN_LABELS[normalizePlan(store.plan)]}/>
                  <InfoRow label="월 청구액" value={multiBranch
                    ? `${billing.toLocaleString()}원 (전체 합산)`
                    : `${billing.toLocaleString()}원 (할인 ${getPlanDiscountRate(store)}%)`}/>
                  {/* 80차 후속: 매장 전체 테마의 홍보 링크(unlockapp.co.kr/t/...) 누적
                      조회수 — 매장 로그인 없이 영업 중에 바로 확인하는 용도 */}
                  <InfoRow label="홍보 링크 조회수" value={`${shareViews.toLocaleString()}회`}/>
                  <InfoRow label="관리자 계정" value={
                    adminInfo[store.id]==='loading' ? '조회 중…'
                    : adminInfo[store.id]==='none' ? '미배정'
                    : adminInfo[store.id]?.loginId || '조회 중…'
                  }/>
                  {/* 78차 42차: 계약 성사 시 영업용 계정을 실제 매장관리자에게 인계 —
                      로그인 ID를 원하는 값으로 바꾸고 비밀번호를 새로 발급 */}
                  {adminInfo[store.id] && adminInfo[store.id]!=='loading' && adminInfo[store.id]!=='none' && (
                    <SecondaryButton
                      label="🔑 ID/PW 재발급"
                      onPress={()=>{ setReissueTarget(store); setNewLoginIdDraft(''); }}
                      style={[s.smBtn,{alignSelf:'flex-start',marginTop:6}]}
                      textStyle={s.smBtnTxt}
                    />
                  )}

                  {/* 76차: 총괄관리자 전용 내부 메모 */}
                  <IconLabel Icon={EditIcon} size={12} color={C.muted} textStyle={s.muted} style={{marginTop:10,marginBottom:6}}>내부 메모</IconLabel>
                  <TextInput
                    style={[s.input,{minHeight:60,textAlignVertical:'top',paddingTop:10}]}
                    value={noteDraft[store.id] ?? store.internalNote ?? ''}
                    onChangeText={v=>setNoteDraft(p=>({...p,[store.id]:v}))}
                    placeholder="계약 특이사항 등 내부용 메모" placeholderTextColor={C.muted}
                    multiline numberOfLines={3}
                  />
                  <SecondaryButton
                    label={savingNoteId===store.id ? '저장 중...' : '메모 저장'}
                    disabled={savingNoteId===store.id}
                    onPress={()=>handleSaveNote(store)}
                    style={[s.smBtn,{alignSelf:'flex-start',marginTop:6}]}
                    textStyle={s.smBtnTxt}
                  />

                  {(store.branches||[]).map((b,bi)=>{
                    const branchKey = `${store.id}_${bi}`;
                    const branchPlan = getBranchPlan(store, bi);
                    const branchEnd = b.contractEnd || store.contractEnd;
                    const branchDd = dDayLabel(branchEnd);
                    return (
                    <View key={bi} style={[s.card,{marginTop:10,backgroundColor:C.surface}, b.isDeleted&&s.cardDeleted]}>
                      <View style={{flexDirection:'row',alignItems:'center',marginBottom:10,gap:8}}>
                        <MenuStoreIcon size={16} color={C.warning} />
                        <View style={{flex:1}}>
                          <View style={{flexDirection:'row',alignItems:'center',gap:6}}>
                            <Text style={[s.drillName,{color:C.warning}]}>{b.branchName}</Text>
                            {/* 78차 62차: 지점별 비활성화 배지 */}
                            {b.isDeleted && (
                              <View style={s.deletedBadge}>
                                <Text style={s.deletedBadgeTxt}>비활성</Text>
                              </View>
                            )}
                            <View style={[s.premiumBadge,{
                              backgroundColor:PLAN_COLORS[normalizePlan(branchPlan)]+'22',
                              borderColor:PLAN_COLORS[normalizePlan(branchPlan)]+'55',
                            }]}>
                              <Text style={[s.premiumBadgeTxt,{color:PLAN_COLORS[normalizePlan(branchPlan)]}]}>
                                {getPlanBadgeLabel(branchPlan, hasOpsAddon(store, bi))}
                              </Text>
                            </View>
                          </View>
                          {(b.city||b.district)&&(
                            <IconLabel Icon={LocationIcon} size={10} color={C.muted} gap={3} textStyle={[s.muted,{fontSize:11,marginTop:1}]}>
                              {[b.city,b.district].filter(Boolean).join(' ')}
                            </IconLabel>
                          )}
                        </View>
                        <View style={[s.badge,{borderColor:C.goldBdr,backgroundColor:C.goldBg}]}>
                          <Text style={[s.badgeTxt,{color:C.gold}]}>테마 {(b.themes||[]).length}개</Text>
                        </View>
                      </View>
                      {/* 78차 48차: 테마 소프트 삭제(EditStore)를 이 요약 카드에선 아무 표시
                          없이 그대로 보여주고 있어, 여기만 보고는 비활성 상태를 알 수 없었음
                          — 지점 비활성 배지(위)와 동일한 패턴으로 테마에도 배지 추가. */}
                      {(b.themes||[]).map((t,ti)=>(
                        <View key={ti} style={{
                          marginBottom:8, padding:10, borderRadius:8,
                          backgroundColor:C.bg, borderWidth:1, borderColor:C.border,
                          borderLeftWidth:3, borderLeftColor:t.isDeleted?C.border:C.gold,
                          opacity:t.isDeleted?0.55:1,
                        }}>
                          <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginBottom:4}}>
                            <IconLabel Icon={MenuEscapeIcon} size={12} color={C.text} gap={4}
                              textStyle={{color:C.text,fontWeight:'700',fontSize:13}} style={{flex:1}} numberOfLines={1}>
                              {t.name||'이름 없음'}
                            </IconLabel>
                            {t.isDeleted && (
                              <View style={s.deletedBadge}>
                                <Text style={s.deletedBadgeTxt}>비활성</Text>
                              </View>
                            )}
                            {t.genre&&(
                              <View style={[s.badge,{borderColor:'rgba(96,165,250,0.4)',backgroundColor:'rgba(96,165,250,0.1)'}]}>
                                <Text style={[s.badgeTxt,{color:C.info}]}>{t.genre}</Text>
                              </View>
                            )}
                          </View>
                          <View style={{flexDirection:'row',flexWrap:'wrap',gap:8,marginTop:2}}>
                            {t.difficulty&&(
                              <Text style={[s.muted,{fontSize:11}]}>
                                ⚡ {DIFFICULTY_OPTIONS.find(d=>d.v===t.difficulty)?.l||t.difficulty}
                              </Text>
                            )}
                            {t.minPeople&&t.maxPeople&&(
                              <IconLabel Icon={PeopleIcon} size={10} color={C.muted} gap={3} textStyle={[s.muted,{fontSize:11}]}>{t.minPeople}~{t.maxPeople}명</IconLabel>
                            )}
                            {t.duration&&(
                              <Text style={[s.muted,{fontSize:11}]}>⏱ {t.duration}분</Text>
                            )}
                          </View>
                        </View>
                      ))}
                      {/* 78차 62차: 지점별 계약이력/계약연장/플랜변경/비활성화 — 지점이 2개 이상인
                          매장만 노출(단일 지점은 아래 매장 전체 버튼과 중복이라 생략). */}
                      {(store.branches||[]).length > 1 && (
                        <View style={{flexDirection:'row',gap:8,marginTop:10,flexWrap:'wrap'}}>
                          <SecondaryButton label="📜 이력" onPress={()=>{setHistoryStore(store);setHistoryBranchIdx(bi);}} style={s.smBtn} textStyle={s.smBtnTxt} />
                          {!b.isDeleted && (
                            <SecondaryButton
                              label={extendingId===branchKey ? '연장 중...' : `🔄 연장 (${branchDd})`}
                              disabled={extendingId===branchKey}
                              onPress={()=>handleExtendContract(store, bi)}
                              style={s.smBtn} textStyle={s.smBtnTxt}
                            />
                          )}
                          {!b.isDeleted && (
                            <SecondaryButton
                              label={togglingPlanId===branchKey ? '변경 중...' : `💳 ${PLAN_LABELS[normalizePlan(branchPlan)]}`}
                              disabled={togglingPlanId===branchKey}
                              onPress={()=>{setPlanPickerStore(store);setPlanPickerBranchIdx(bi);}}
                              style={s.smBtn} textStyle={s.smBtnTxt}
                            />
                          )}
                          {b.isDeleted ? (
                            <SecondaryButton
                              label={deletingId===branchKey ? '복구 중...' : '🔓 지점 복구'}
                              disabled={deletingId===branchKey}
                              onPress={()=>handleRestore(store, bi)}
                              style={[s.smBtn,{borderColor:C.success+'60'}]}
                              textStyle={[s.smBtnTxt,{color:C.success}]}
                            />
                          ) : (
                            <DangerButton
                              label={deletingId===branchKey ? '처리 중...' : '🗑 지점 비활성화'}
                              disabled={deletingId===branchKey}
                              onPress={()=>handleSoftDelete(store, bi)}
                              style={s.smBtn} textStyle={s.smBtnTxt}
                            />
                          )}
                        </View>
                      )}
                    </View>
                  );})}
                  {/* 32차: 수정 + 비활성화/복구 버튼, 56차: 플랜 토글 버튼, 75차: 계약 이력 버튼 */}
                  <View style={{flexDirection:'row',gap:8,marginTop:14,flexWrap:'wrap'}}>
                    {!store.isDeleted && (
                      <SecondaryButton label="✏️ 지점 / 테마 수정" onPress={()=>openEdit(store)} style={s.smBtn} textStyle={s.smBtnTxt} />
                    )}
                    <SecondaryButton label={multiBranch ? '📜 계약 이력 (전체)' : '📜 계약 이력'} onPress={()=>setHistoryStore(store)} style={s.smBtn} textStyle={s.smBtnTxt} />
                    {!store.isDeleted && (
                      <SecondaryButton
                        label={extendingId===store.id ? '연장 중...' : (multiBranch ? '🔄 계약 연장 (전체, +1년)' : '🔄 계약 연장 (+1년)')}
                        disabled={extendingId===store.id}
                        onPress={()=>handleExtendContract(store)}
                        style={s.smBtn}
                        textStyle={s.smBtnTxt}
                      />
                    )}
                    {!store.isDeleted && (
                      <SecondaryButton
                        label={togglingPlanId===store.id ? '변경 중...' : `💳 플랜 변경${multiBranch ? ' (전체)' : ''} (${PLAN_LABELS[normalizePlan(store.plan)]})`}
                        disabled={togglingPlanId===store.id}
                        onPress={()=>setPlanPickerStore(store)}
                        style={s.smBtn}
                        textStyle={s.smBtnTxt}
                      />
                    )}
                    {store.isDeleted ? (
                      <>
                        <SecondaryButton
                          label={deletingId===store.id ? '복구 중...' : '🔓 매장 복구'}
                          disabled={deletingId===store.id}
                          onPress={()=>handleRestore(store)}
                          style={[s.smBtn,{borderColor:C.success+'60'}]}
                          textStyle={[s.smBtnTxt,{color:C.success}]}
                        />
                        {/* 78차 42차: 영업용 사전 등록 매장의 계약 불발 시 완전 삭제 —
                            라이브 매장 오조작 방지를 위해 이미 비활성화된 매장에만 노출 */}
                        <DangerButton
                          label={hardDeletingId===store.id ? '삭제 중...' : '💥 완전 삭제'}
                          disabled={hardDeletingId===store.id}
                          onPress={()=>handleHardDelete(store)}
                          style={s.smBtn}
                          textStyle={s.smBtnTxt}
                        />
                      </>
                    ) : (
                      <DangerButton
                        label={deletingId===store.id ? '처리 중...' : (multiBranch ? '🗑 비활성화 (전체)' : '🗑 비활성화')}
                        disabled={deletingId===store.id}
                        onPress={()=>handleSoftDelete(store)}
                        style={s.smBtn}
                        textStyle={s.smBtnTxt}
                      />
                    )}
                  </View>
                </View>
              )}
            </View>
          );
        })}

      {/* 수정 모달 */}
      {editStore&&(
        <Modal visible={true} transparent animationType="slide" onRequestClose={()=>setEditStore(null)}>
          <View style={s.modalOverlay}>
            <View style={[s.modalBox,{maxHeight:'90%',padding:0,overflow:'hidden'}]}>
              <AppHeader isModal
                centerElement={<IconLabel Icon={EditIcon} size={14} color={C.text} textStyle={s.modalHeaderTitle}>매장 수정</IconLabel>}
                rightElement={
                  <TouchableOpacity onPress={()=>setEditStore(null)}>
                    <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
                  </TouchableOpacity>
                }
              />
              <Text style={[s.drillName,{marginTop:12,marginHorizontal:24}]}>{editStore.ownerName}</Text>
              <ScrollView showsVerticalScrollIndicator={false} style={{paddingHorizontal:24}}>
                <FI label="사업자명" value={editStore.ownerName||''} onChange={v=>setEditStore(p=>({...p,ownerName:v}))}/>
                <FI label="이메일"   value={editStore.email||''}     onChange={v=>setEditStore(p=>({...p,email:v}))} keyboard="email-address"/>
                <FI label="연락처"   value={editStore.contact||''}   onChange={v=>setEditStore(p=>({...p,contact:v}))} keyboard="phone-pad"/>
                <FI label="담당자명 (선택)" value={editStore.contactName||''} onChange={v=>setEditStore(p=>({...p,contactName:v}))} placeholder="예: 홍길동"/>
                <FI label="사업자등록번호 (선택)" value={editStore.businessRegNumber||''} onChange={v=>setEditStore(p=>({...p,businessRegNumber:v}))} placeholder="예: 123-45-67890"/>
                <DateField label="계약 시작일" value={editStore.contractStart||''} onChange={v=>setEditStore(p=>({...p,contractStart:v}))} maxDate={editStore.contractEnd||undefined}/>
                <DateField label="계약 종료일" value={editStore.contractEnd||''} onChange={v=>setEditStore(p=>({...p,contractEnd:v}))} minDate={editStore.contractStart||undefined}/>

                {/* 78차 46차: 안 쓰는 수수료(요율/정액) 선택 UI 삭제 — 플랜 구독료만 받음 */}
                <FI label="납부일 (비우면 등록일 자동)" value={String(editStore.paymentDay||'')} onChange={v=>setEditStore(p=>({...p,paymentDay:v}))} keyboard="numeric" placeholder="예: 10 → 매달 10일"/>
                {/* 78차 47차: 플랜 할인율(0~100%) — BASIC "1년 무료" 자동정책을 대체, 총괄관리자가 직접 조정 */}
                <FI label="플랜 할인율 (%)" value={String(editStore.planDiscountRate??'')} onChange={v=>setEditStore(p=>({...p,planDiscountRate:v}))} keyboard="numeric" placeholder="0~100"/>
                {/* 78차 57차: 종료시간은 매장 공통, 시작시간은 테마별로 다르면 아래 각
                    테마 카드에서 덮어쓸 수 있음(비워두면 여기 값을 기본값으로 사용) */}
                <Text style={[s.muted,{marginBottom:6}]}>운영시간 (기본값)</Text>
                <View style={{flexDirection:'row',gap:10}}>
                  <View style={{flex:1}}><FI label="시작 시간" value={editStore.startTime||''} onChange={v=>setEditStore(p=>({...p,startTime:v}))} placeholder="09:00"/></View>
                  <View style={{flex:1}}><FI label="종료 시간" value={editStore.endTime||''} onChange={v=>setEditStore(p=>({...p,endTime:v}))} placeholder="22:00"/></View>
                </View>

                <IconLabel Icon={MenuStoreIcon} size={13} color={C.gold} textStyle={s.sectionTitle} style={{marginTop:8}}>지점 목록</IconLabel>
                {/* 78차 46차: 비활성화(isDeleted)된 지점은 여기선 숨기고, 매장 목록의
                    "지점 복구" 버튼으로 되돌릴 수 있음(index 유지를 위해 배열에서 빼지 않음) */}
                {(editStore.branches||[]).some(b=>b.isDeleted) && (
                  <Text style={[s.muted,{fontSize:11,marginBottom:8}]}>
                    비활성화된 지점은 여기서 숨겨집니다 — 매장 목록 카드의 "지점 복구" 버튼으로 되돌릴 수 있어요.
                  </Text>
                )}
                {(editStore.branches||[]).map((b,bi)=>{
                  if (b.isDeleted) return null;
                  return (
                  <View key={bi} style={[s.card,{backgroundColor:C.surface,marginBottom:10}]}>
                    <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                      <Text style={[s.drillName,{color:C.warning}]}>지점 {bi+1}</Text>
                      {(editStore.branches||[]).filter(x=>!x.isDeleted).length>1&&(
                        <TextButton label="삭제" onPress={()=>removeBranch(bi)} textStyle={{color:C.danger,fontSize:12}} />
                      )}
                    </View>
                    <FI label="지점명" value={b.branchName||''} onChange={v=>EB(bi,'branchName',v)}/>
                    <Text style={[s.muted,{marginBottom:6}]}>시 / 도</Text>
                    <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                      <View style={{flexDirection:'row',gap:8,marginBottom:8}}>
                        {REGIONS.map(city=>(
                          <TouchableOpacity key={city} style={[s.chip,b.city===city&&s.chipOn]}
                            onPress={()=>{EB(bi,'city',city);EB(bi,'district','');}}>
                            <Text style={[s.chipTxt,b.city===city&&s.chipTxtOn]}>{city}</Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    </ScrollView>
                    {b.city&&SUB_REGIONS[b.city]&&(
                      <>
                        <Text style={[s.muted,{marginBottom:6}]}>구 / 동</Text>
                        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                          <View style={{flexDirection:'row',gap:8,marginBottom:8}}>
                            {SUB_REGIONS[b.city].map(dist=>(
                              <TouchableOpacity key={dist} style={[s.chip,b.district===dist&&s.chipOn]}
                                onPress={()=>EB(bi,'district',dist)}>
                                <Text style={[s.chipTxt,b.district===dist&&s.chipTxtOn]}>{dist}</Text>
                              </TouchableOpacity>
                            ))}
                          </View>
                        </ScrollView>
                      </>
                    )}
                    <FI label="상세 주소" value={b.addressDetail||''} onChange={v=>EB(bi,'addressDetail',v)} placeholder="예: OO빌딩 3층"/>

                    {/* 78차 62차: 지점이 2개 이상인 매장은 plan/계약조건이 지점마다 다를 수
                        있어 위 "매장 공통" 입력란 대신 여기서 지점별로 직접 설정 — 단일
                        지점 매장은 위 매장 공통 값이 곧 그 지점 값이라 중복 노출 안 함. */}
                    {(editStore.branches||[]).length>1 && (
                      <View style={{marginTop:6,marginBottom:6,paddingTop:10,borderTopWidth:1,borderTopColor:C.border}}>
                        <Text style={[s.muted,{fontWeight:'700',marginBottom:6}]}>이 지점 계약 조건</Text>
                        <Text style={[s.muted,{marginBottom:6}]}>플랜</Text>
                        <View style={{flexDirection:'row',gap:8,marginBottom:8}}>
                          {PLAN_TIERS.map(tier=>(
                            <TouchableOpacity key={tier} style={[s.chip,normalizePlan(b.plan)===tier&&s.chipOn]}
                              onPress={()=>EB(bi,'plan',tier)}>
                              <Text style={[s.chipTxt,normalizePlan(b.plan)===tier&&s.chipTxtOn]}>{PLAN_LABELS[tier]}</Text>
                            </TouchableOpacity>
                          ))}
                        </View>
                        <DateField label="계약 시작일" value={b.contractStart||''} onChange={v=>EB(bi,'contractStart',v)} maxDate={b.contractEnd||undefined}/>
                        <DateField label="계약 종료일" value={b.contractEnd||''} onChange={v=>EB(bi,'contractEnd',v)} minDate={b.contractStart||undefined}/>
                        <FI label="납부일 (비우면 등록일 자동)" value={String(b.paymentDay||'')} onChange={v=>EB(bi,'paymentDay',v)} keyboard="numeric" placeholder="예: 10 → 매달 10일"/>
                        <FI label="플랜 할인율 (%)" value={String(b.planDiscountRate??'')} onChange={v=>EB(bi,'planDiscountRate',v)} keyboard="numeric" placeholder="0~100"/>
                        {/* 80차 후속: 이 지점만 매장관리자 기능 애드온을 따로 켜고 끌 수 있음
                            (지점마다 실제 운영 방식이 다를 수 있어 plan과 동일하게 지점별 오버라이드) */}
                        <TouchableOpacity style={s.checkboxRow} onPress={()=>EB(bi,'opsAddon',!b.opsAddon)}>
                          <View style={[s.checkbox, b.opsAddon && s.checkboxOn]}>
                            {b.opsAddon && <CheckmarkIcon size={12} color={C.onGold} />}
                          </View>
                          <Text style={{ color: C.text, fontSize: 13, fontWeight: '700', flex: 1 }}>매장관리자 기능 애드온 (월 {OPS_ADDON_FEE.toLocaleString()}원)</Text>
                        </TouchableOpacity>
                      </View>
                    )}

                    <Text style={[s.muted,{fontWeight:'700',marginBottom:6,marginTop:4}]}>테마 목록</Text>
                    {/* 78차 46차: 비활성화(isDeleted)된 테마는 인라인 복구 버튼만 있는
                        축소된 카드로 표시 — 배열에서 실제로 빼지 않아 themeIdx가 밀리지 않음 */}
                    {(b.themes||[]).map((t,ti)=> t.isDeleted ? (
                      <View key={ti} style={[s.card,{backgroundColor:C.bg,marginBottom:8,opacity:0.55}]}>
                        <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                          <Text style={[s.muted,{fontWeight:'700'}]}>{t.name || `테마 ${ti+1}`} (비활성)</Text>
                          <TextButton label="복구" onPress={()=>restoreTheme(bi,ti)} textStyle={{color:C.success,fontSize:12}} />
                        </View>
                      </View>
                    ) : (
                      <View key={ti} style={[s.card,{backgroundColor:C.bg,marginBottom:8}]}>
                        <View style={{flexDirection:'row',justifyContent:'space-between',marginBottom:6}}>
                          <Text style={[s.muted,{fontWeight:'700'}]}>테마 {ti+1}</Text>
                          {(b.themes||[]).filter(x=>!x.isDeleted).length>1&&(
                            <TextButton label="삭제" onPress={()=>removeTheme(bi,ti)} textStyle={{color:C.danger,fontSize:12}} />
                          )}
                        </View>
                        <FI label="테마명" value={t.name||''} onChange={v=>ET(bi,ti,'name',v)}/>
                        <FI label="설명"   value={t.description||''} onChange={v=>ET(bi,ti,'description',v)} multiline/>
                        <Text style={[s.muted,{marginBottom:6}]}>장르 (최대 2개)</Text>
                        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                          <View style={{flexDirection:'row',gap:6,marginBottom:8}}>
                            {GENRE_OPTIONS.map(g=>{
                              if (g === '기타') {
                                const active = hasCustomGenre(t.genre);
                                return (
                                  <TouchableOpacity key={g} style={[s.chip,active&&s.chipOn]} onPress={()=>ET(bi,ti,'genre',toggleEtcGenre(t.genre))}>
                                    <Text style={[s.chipTxt,active&&s.chipTxtOn]} numberOfLines={1}>{active ? (getCustomGenreText(t.genre)||'기타') : '기타'}</Text>
                                  </TouchableOpacity>
                                );
                              }
                              const selected = (t.genre||'').split('/').map(x=>x.trim()).includes(g);
                              return (
                                <TouchableOpacity key={g} style={[s.chip,selected&&s.chipOn]} onPress={()=>ET(bi,ti,'genre',toggleGenreValue(t.genre,g))}>
                                  <Text style={[s.chipTxt,selected&&s.chipTxtOn]}>{g}</Text>
                                </TouchableOpacity>
                              );
                            })}
                          </View>
                        </ScrollView>
                        {/* 78차 62차: "기타" 선택 시 특이 장르 직접 입력(예: 야외테마) */}
                        {hasCustomGenre(t.genre) && (
                          <FI label="기타 장르 직접 입력" value={getCustomGenreText(t.genre)} onChange={v=>ET(bi,ti,'genre',setCustomGenreText(t.genre,v))} placeholder="예: 야외테마"/>
                        )}
                        {/* 80차 후속: 체험형 공연은 "난이도" 대신 "활동성"(같은 4단계 enum 재사용) */}
                        {(t.bookingFormat||'room')!=='show' ? (
                          <>
                            <Text style={[s.muted,{marginBottom:6}]}>난이도</Text>
                            <View style={{flexDirection:'row',flexWrap:'wrap',gap:6,marginBottom:8}}>
                              {DIFFICULTY_OPTIONS.map(d=>(
                                <TouchableOpacity key={d.v} style={[s.chip,t.difficulty===d.v&&s.chipOn]} onPress={()=>ET(bi,ti,'difficulty',d.v)}>
                                  <Text style={[s.chipTxt,t.difficulty===d.v&&s.chipTxtOn]}>{d.l}</Text>
                                </TouchableOpacity>
                              ))}
                            </View>
                          </>
                        ) : (
                          <>
                            <Text style={[s.muted,{marginBottom:6}]}>활동성</Text>
                            <View style={{flexDirection:'row',flexWrap:'wrap',gap:6,marginBottom:8}}>
                              {Object.entries(ACTIVITY_META).map(([v,meta])=>(
                                <TouchableOpacity key={v} style={[s.chip,(t.activityLevel||'normal')===v&&s.chipOn]} onPress={()=>ET(bi,ti,'activityLevel',v)}>
                                  <Text style={[s.chipTxt,(t.activityLevel||'normal')===v&&s.chipTxtOn]}>{meta.label}</Text>
                                </TouchableOpacity>
                              ))}
                            </View>
                          </>
                        )}
                        {/* 80차: 예약 형식 — 방탈출(전세) 기본, 체험형 공연(정원제) 선택 시 정원 입력 */}
                        <Text style={[s.muted,{marginBottom:6}]}>예약 형식</Text>
                        <View style={{flexDirection:'row',gap:6,marginBottom:8}}>
                          {Object.entries(BOOKING_FORMATS).map(([v,meta])=>(
                            <TouchableOpacity key={v} style={[s.chip,(t.bookingFormat||'room')===v&&s.chipOn]} onPress={()=>ET(bi,ti,'bookingFormat',v)}>
                              <Text style={[s.chipTxt,(t.bookingFormat||'room')===v&&s.chipTxtOn]}>{meta.label}</Text>
                            </TouchableOpacity>
                          ))}
                        </View>
                        {/* 80차 후속: 이미 예약이 쌓인 테마의 형식을 바꾸면 방탈출-체험형의
                            예약/정원 로직이 서로 달라 데이터가 꼬일 수 있음(동적 예약건수
                            조회는 비용 대비 낮은 우선순위로 생략, 정적 경고로 충분하다고 판단) */}
                        <IconLabel Icon={WarningIcon} size={12} color={C.warning} textStyle={{color:C.warning,fontSize:11}} style={{marginBottom:8}}>이미 예약이 있는 테마의 예약 형식을 바꾸면 데이터가 꼬일 수 있어요</IconLabel>
                        {/* 80차 후속: 공포 강도 등으로 매장이 자체적으로 19세 미만 예약을
                            제한하고 싶은 테마 — 선정성이 아니라 순수 공포/폭력성 사유로도
                            실제 업계에 존재하는 패턴(예: 서울이스케이프룸의 유일한 공포
                            테마가 19금). 방/체험형 둘 다 해당 가능해 형식 선택 아래 공통 위치에 둠. */}
                        <TouchableOpacity style={s.checkboxRow} onPress={()=>ET(bi,ti,'isAdultOnly',!t.isAdultOnly)}>
                          <View style={[s.checkbox,t.isAdultOnly&&s.checkboxOn]}>
                            {t.isAdultOnly && <CheckmarkIcon size={12} color={C.onGold} />}
                          </View>
                          <View style={{flex:1}}>
                            <Text style={{color:C.text,fontSize:13,fontWeight:'700'}}>19세 이상만 예약 가능 (19금)</Text>
                            <Text style={s.muted}>예약 시 생년월일로 확인하며, 현장에서 신분증 확인 시 제한될 수 있어요.</Text>
                          </View>
                        </TouchableOpacity>
                        {t.bookingFormat==='show' && (
                          <>
                            <FI label="회차당 정원" value={String(t.capacity||'')} onChange={v=>ET(bi,ti,'capacity',Number(v)||0)} keyboard="numeric" placeholder="예: 30"/>
                            {/* 80차 후속: 단독 대관 vs 합석 일반 회차 — 고객에게 뱃지로 노출됨 */}
                            <Text style={[s.muted,{marginBottom:6}]}>좌석 형태</Text>
                            <View style={{flexDirection:'row',gap:6,marginBottom:8}}>
                              {Object.entries(SEATING_TYPES).map(([v,meta])=>(
                                <TouchableOpacity key={v} style={[s.chip,(t.seatingType||'shared')===v&&s.chipOn]} onPress={()=>ET(bi,ti,'seatingType',v)}>
                                  <Text style={[s.chipTxt,(t.seatingType||'shared')===v&&s.chipTxtOn]}>{meta.label}</Text>
                                </TouchableOpacity>
                              ))}
                            </View>
                            <FI label="유의사항" value={t.notices||''} onChange={v=>ET(bi,ti,'notices',v)} multiline placeholder="한 줄에 하나씩 입력하세요"/>
                            <FI label="환불 정책" value={t.refundPolicy||''} onChange={v=>ET(bi,ti,'refundPolicy',v)} multiline/>
                          </>
                        )}
                        <View style={{flexDirection:'row',gap:12}}>
                          <View style={{flex:1}}><FI label="최소 인원" value={String(t.minPeople||2)} onChange={v=>ET(bi,ti,'minPeople',Number(v))} keyboard="numeric"/></View>
                          <View style={{flex:1}}><FI label="최대 인원" value={String(t.maxPeople||4)} onChange={v=>ET(bi,ti,'maxPeople',Number(v))} keyboard="numeric"/></View>
                        </View>
                        {/* 80차 후속: RegisterTab과 동일 — "1인당 가격"은 입력값이 아니라 표를
                            일괄 채우는 도우미, 실제 예약은 아래 표(pricing)만 참조함 */}
                        {t.bookingFormat==='show' && (
                          <View style={{flexDirection:'row',gap:8,marginBottom:8}}>
                            <View style={{flex:1}}>
                              <FI label="1인당 가격 (원)" value={String(t.pricePerPerson||'')} onChange={v=>ET(bi,ti,'pricePerPerson',Number(v)||0)} keyboard="numeric" placeholder="예: 120000"/>
                            </View>
                            <SecondaryButton
                              label="표에 일괄 채우기"
                              onPress={()=>ET(bi,ti,'pricing', computeShowPricing(Number(t.minPeople)||1, Number(t.maxPeople)||1, t.pricePerPerson))}
                              style={{alignSelf:'flex-end',marginBottom:12}}
                            />
                          </View>
                        )}
                        {(t.pricing||[]).length>0&&(
                          <>
                            <Text style={[s.muted,{marginBottom:8}]}>
                              인원별 가격 (원){t.bookingFormat==='show' ? ' — 인원마다 다르게 직접 수정할 수 있어요' : ''}
                            </Text>
                            {t.pricing.map((pp,pi)=>(
                              <View key={pi} style={{flexDirection:'row',alignItems:'center',gap:10,marginBottom:8}}>
                                <View style={s.pricePeopleBadge}>
                                  <Text style={s.pricePeopleTxt}>{pp.people}명</Text>
                                </View>
                                <TextInput
                                  style={[s.input,{flex:1}]}
                                  value={String(pp.price)}
                                  onChangeText={v=>updateEditPricing(bi,ti,pi,v)}
                                  keyboardType="numeric"
                                  placeholder="예: 25000"
                                  placeholderTextColor={C.muted}
                                />
                                <Text style={s.muted}>원</Text>
                              </View>
                            ))}
                          </>
                        )}
                        <FI label="진행 시간 (분)" value={String(t.duration||60)} onChange={v=>ET(bi,ti,'duration',Number(v))} keyboard="numeric"/>
                        {/* 78차 57차: 방마다 첫 회차 시작시간/회차 사이 준비시간이 다를 수 있어 테마별 입력 추가 */}
                        <View style={{flexDirection:'row',gap:12}}>
                          <View style={{flex:1}}><FI label="시작 시간 (비우면 매장 공통)" value={t.startTime||''} onChange={v=>ET(bi,ti,'startTime',v)} placeholder="09:00"/></View>
                          {/* 78차: 여러 방을 동시 운영해 실제 회전 주기가 진행시간보다 짧은 매장을
                              위해 마이너스 준비시간 허용 — -60~+60분 스크롤 선택으로 교체 */}
                          <MinutesPickerField label="준비시간 (분)" value={t.prepMinutes ?? 0} onChange={v=>ET(bi,ti,'prepMinutes',v)} />
                        </View>
                        {/* 78차 46차: URL 텍스트 입력만 가능했던 것 — 갤러리 업로드 추가(RegisterTab과 동일 패턴) */}
                        <Text style={[s.muted,{marginBottom:8}]}>테마 대표 이미지</Text>
                        {t.imageLocalUri||t.imageUrl ? (
                          <View style={{marginBottom:10}}>
                            <Image source={{uri:t.imageLocalUri||t.imageUrl}} style={s.imgPreview} resizeMode="cover"/>
                            <TouchableOpacity style={s.imgRemoveBtn} onPress={()=>{ET(bi,ti,'imageLocalUri','');ET(bi,ti,'imageUrl','');}}>
                              <IconLabel Icon={CancelIcon} textStyle={s.imgRemoveTxt}>이미지 제거</IconLabel>
                            </TouchableOpacity>
                          </View>
                        ) : (
                          <TouchableOpacity style={s.imgPickBtn} onPress={()=>pickEditThemeImage(bi,ti)}>
                            {uploadingEditTheme?.bi===bi&&uploadingEditTheme?.ti===ti
                              ?<ActivityIndicator color={C.gold}/>
                              :<>
                                <Text style={{fontSize:28,marginBottom:4}}>🖼</Text>
                                <Text style={{color:C.gold,fontWeight:'600',fontSize:13}}>갤러리에서 선택</Text>
                                <Text style={[s.muted,{fontSize:11,marginTop:2}]}>권장: 4:3 비율</Text>
                              </>
                            }
                          </TouchableOpacity>
                        )}
                        <FI label="이미지 URL (직접 입력도 가능)" value={t.imageUrl||''} onChange={v=>ET(bi,ti,'imageUrl',v)} placeholder="https://..." keyboard="url"/>
                      </View>
                    ))}
                    <SecondaryButton label="+ 테마 추가" onPress={()=>addTheme(bi)} style={[s.smBtn,{alignSelf:'flex-start',marginTop:4}]} textStyle={s.smBtnTxt} />
                  </View>
                  );
                })}
                <SecondaryButton label="+ 지점 추가" onPress={addBranch} style={[s.smBtn,{alignSelf:'flex-start',marginBottom:16}]} textStyle={s.smBtnTxt} />
              </ScrollView>
              <View style={[s.modalBtns,{paddingHorizontal:24,paddingBottom:24}]}>
                <SecondaryButton label="취소" onPress={()=>setEditStore(null)} style={{flex:1}} textStyle={s.outlineBtnTxt} />
                <GradientButton
                  label={saving ? '저장 중...' : '💾 저장'}
                  onPress={handleEditSave}
                  disabled={saving}
                  style={{flex:2}}
                  textStyle={s.primaryBtnTxt}
                />
              </View>
            </View>
          </View>
        </Modal>
      )}

      {/* 68차: 플랜 변경 모달 — 4단계(basic/standard/premium/boost) */}
      <Modal visible={!!planPickerStore} transparent animationType="fade" onRequestClose={()=>{setPlanPickerStore(null);setPlanPickerBranchIdx(null);}}>
        <View style={s.modalOverlay}>
          <View style={[s.modalBox,{padding:0,overflow:'hidden'}]}>
            <AppHeader isModal
              centerElement={<IconLabel Icon={PaymentIcon} size={14} color={C.text} textStyle={s.modalHeaderTitle}>플랜 변경</IconLabel>}
              rightElement={
                <TouchableOpacity onPress={()=>{setPlanPickerStore(null);setPlanPickerBranchIdx(null);}}>
                  <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
                </TouchableOpacity>
              }
            />
            <View style={{padding:24}}>
            {planPickerStore && (() => {
              const branch = planPickerBranchIdx != null ? planPickerStore.branches?.[planPickerBranchIdx] : null;
              const key = planPickerBranchIdx != null ? `${planPickerStore.id}_${planPickerBranchIdx}` : planPickerStore.id;
              const currentPlan = getBranchPlan(planPickerStore, planPickerBranchIdx);
              return (
              <>
                <Text style={[s.drillName,{marginBottom:14}]}>
                  {planPickerStore.ownerName}{branch ? ` · ${branch.branchName || ''}` : ''}
                </Text>
                <View style={{gap:8}}>
                  {PLAN_TIERS.map(tier=>{
                    const active = currentPlan === tier;
                    return (
                      <TouchableOpacity
                        key={tier}
                        style={[s.planOptionRow, active && s.planOptionRowOn]}
                        disabled={togglingPlanId===key}
                        onPress={()=>handleChangePlan(planPickerStore, tier, planPickerBranchIdx)}>
                        <View>
                          <Text style={[s.planOptionLabel, active && {color:C.gold}]}>{PLAN_LABELS[tier]}</Text>
                          {/* 78차 46차: "1년 무료" 문구 삭제 — 요청으로 정가만 표시 */}
                          <Text style={s.muted}>{PLAN_PRICES[tier].toLocaleString()}원/월</Text>
                        </View>
                        {active && (togglingPlanId===key
                          ? <ActivityIndicator size="small" color={C.gold}/>
                          : <IconLabel Icon={CheckmarkIcon} size={12} color={C.gold} textStyle={{color:C.gold,fontWeight:'800'}}>적용중</IconLabel>)}
                      </TouchableOpacity>
                    );
                  })}
                </View>
                {/* 80차 후속: 매장관리자 기능(예약관리·통계·정산) — plan과 무관한 별도 애드온.
                    대형 프랜차이즈처럼 자체 예약 시스템이 있어 이 기능이 필요 없는 매장은
                    노출 플랜(STANDARD/PREMIUM)만 켜고 이건 꺼둘 수 있음. */}
                <Text style={[s.muted,{marginTop:20,marginBottom:8}]}>매장관리자 기능 (플랜과 별개 애드온)</Text>
                {(() => {
                  const opsKey = `ops_${key}`;
                  const opsOn = hasOpsAddon(planPickerStore, planPickerBranchIdx);
                  return (
                    <TouchableOpacity
                      style={[s.planOptionRow, opsOn && s.planOptionRowOn]}
                      disabled={togglingPlanId===opsKey}
                      onPress={()=>handleToggleOpsAddon(planPickerStore, planPickerBranchIdx)}>
                      <View>
                        <Text style={[s.planOptionLabel, opsOn && {color:C.gold}]}>예약관리·통계·정산</Text>
                        <Text style={s.muted}>월 {OPS_ADDON_FEE.toLocaleString()}원 추가</Text>
                      </View>
                      {togglingPlanId===opsKey
                        ? <ActivityIndicator size="small" color={C.gold}/>
                        : <IconLabel Icon={CheckmarkIcon} size={12} color={opsOn?C.gold:C.muted} textStyle={{color:opsOn?C.gold:C.muted,fontWeight:'800'}}>{opsOn?'켜짐':'꺼짐 (탭해서 켜기)'}</IconLabel>}
                    </TouchableOpacity>
                  );
                })()}
              </>
              );
            })()}
            </View>
          </View>
        </View>
      </Modal>

      {/* 75차: 계약 변경 이력 조회 모달 */}
      <ContractHistoryModal
        visible={!!historyStore}
        store={historyStore}
        branchIdx={historyBranchIdx}
        onClose={()=>{setHistoryStore(null);setHistoryBranchIdx(null);}}
      />

      {/* 78차 42차: 계약 성사 시 ID/PW 재발급 — 새 로그인 ID 입력 */}
      <Modal visible={!!reissueTarget} transparent animationType="fade" onRequestClose={()=>setReissueTarget(null)}>
        <View style={s.modalOverlay}>
          <View style={[s.modalBox,{padding:0,overflow:'hidden'}]}>
            <AppHeader isModal
              centerElement={<IconLabel Icon={MenuPasswordIcon} size={14} color={C.text} textStyle={s.modalHeaderTitle}>ID/PW 재발급</IconLabel>}
              rightElement={
                <TouchableOpacity onPress={()=>setReissueTarget(null)}>
                  <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
                </TouchableOpacity>
              }
            />
            <View style={{padding:24}}>
              <Text style={[s.muted,{marginBottom:12,lineHeight:18}]}>
                "{reissueTarget?.ownerName}"의 로그인 ID를 새로 정하면, 비밀번호도 새로 발급돼요.
                매장관리자는 최초 로그인 시 이 비밀번호를 직접 원하는 걸로 바꾸게 됩니다.
              </Text>
              <Text style={s.muted}>새 로그인 ID (영문/숫자/밑줄 4자 이상)</Text>
              <TextInput
                style={s.input} value={newLoginIdDraft} onChangeText={setNewLoginIdDraft}
                placeholder="예: zerogangnam" placeholderTextColor={C.muted} autoCapitalize="none"
              />
              <GradientButton
                label={reissuing ? '처리 중...' : '재발급'}
                onPress={handleReissue}
                disabled={reissuing}
                style={{marginTop:16}}
                textStyle={s.primaryBtnTxt}
              />
            </View>
          </View>
        </View>
      </Modal>

      {/* 78차 42차: 재발급 결과 — 임시 비밀번호는 여기서만 보여주고 다시 조회 불가 */}
      <Modal visible={!!reissuedResult} transparent animationType="fade">
        <View style={s.issuedOverlay}>
          <View style={[s.issuedBox,{padding:0,overflow:'hidden'}]}>
            <AppHeader isModal centerElement={<IconLabel Icon={CheckmarkIcon} size={14} color={C.text} textStyle={s.modalHeaderTitle}>재발급 완료</IconLabel>} />
            <View style={{padding:24}}>
              <Text style={s.issuedWarn}>이 비밀번호는 다시 확인할 수 없어요. 지금 매장에 전달해주세요.</Text>
              <Text style={s.muted}>로그인 ID</Text>
              {/* 80차 계속: [버그 수정] "editable={false} + selectTextOnFocus"로 롱프레스 복사가
                  된다고 여러 화면에 반복 적용해뒀던 관례가 실기기(InviteFriendScreen.js)에서
                  실제로는 안 됨을 확인 — editable={false}가 Android에서 선택/복사 컨텍스트
                  메뉴 자체를 막는 것으로 추정. editable은 기본값(true)대로 두고
                  showSoftInputOnFocus={false}(키보드만 안 뜨게)+onChangeText 무시로 대체 —
                  이 파일의 나머지 11곳도 전부 동일하게 교체(InviteFriendScreen.js도 함께 수정). */}
              <TextInput style={s.input} value={reissuedResult?.loginId} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
              <Text style={[s.muted,{marginTop:10}]}>임시 비밀번호</Text>
              <TextInput style={s.input} value={reissuedResult?.tempPassword} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
              <GradientButton
                label="확인"
                onPress={()=>setReissuedResult(null)}
                style={{marginTop:16}}
                textStyle={s.primaryBtnTxt}
              />
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
}

// 75차: 매장 계약 변경(플랜/최대 테마 수/계약 기간) 이력 조회
const CONTRACT_CHANGE_LABEL = { plan:'플랜 변경', maxThemes:'최대 테마 수 변경', contractPeriod:'계약 기간 변경', fee:'수수료 조건 변경' };
const fmtSnapshot = (obj) => obj ? Object.values(obj).map(v=>v ?? '-').join(' ~ ') : '-';
function ContractHistoryModal({ visible, store, branchIdx = null, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible || !store) return;
    setLoading(true);
    getContractHistory(store.id).then(setHistory).catch(()=>setHistory([])).finally(()=>setLoading(false));
  }, [visible, store?.id]);

  // 78차 62차: branchIdx가 지정되면(지점 카드에서 진입) 그 지점 이력만 필터.
  // 매장 전체 보기(branchIdx===null)일 땐 전부 보여주되, 지점 이력엔 지점명을 붙인다.
  const visibleHistory = branchIdx != null
    ? history.filter(h => h.branchIdx === branchIdx)
    : history;
  const branchName = branchIdx != null ? store?.branches?.[branchIdx]?.branchName : null;

  return (
    <Modal visible={visible} transparent animationType="slide" onRequestClose={onClose}>
      <View style={s.modalOverlay}>
        <View style={[s.modalBox,{maxHeight:'75%',padding:0,overflow:'hidden'}]}>
          <AppHeader isModal
            centerElement={<IconLabel Icon={ContractIcon} size={14} color={C.text} textStyle={s.modalHeaderTitle}>계약 변경 이력</IconLabel>}
            rightElement={
              <TouchableOpacity onPress={onClose}>
                <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
              </TouchableOpacity>
            }
          />
          <View style={{padding:24}}>
          <Text style={[s.muted,{marginBottom:14}]}>{store?.ownerName}{branchName ? ` · ${branchName}` : ''}</Text>
          <ScrollView style={{maxHeight:400}}>
            {loading ? <ActivityIndicator color={C.gold}/> :
              visibleHistory.length===0 ? <EmptyState Icon={ContractIcon} text="변경 이력이 없습니다."/> :
              visibleHistory.map(h=>(
                <View key={h.id} style={[s.card,{marginBottom:8}]}>
                  <Text style={{color:C.gold,fontSize:13,fontWeight:'800',marginBottom:4}}>
                    {CONTRACT_CHANGE_LABEL[h.changeType]||h.changeType}
                    {branchIdx == null && h.branchIdx != null
                      ? ` · ${store?.branches?.[h.branchIdx]?.branchName || `지점${h.branchIdx+1}`}`
                      : ''}
                  </Text>
                  <Text style={s.muted}>{fmtSnapshot(h.before)} → {fmtSnapshot(h.after)}</Text>
                  <Text style={[s.muted,{marginTop:4,fontSize:11}]}>
                    {h.changedAt?.toDate ? h.changedAt.toDate().toLocaleString('ko-KR') : '-'}
                  </Text>
                </View>
              ))
            }
          </ScrollView>
          </View>
        </View>
      </View>
    </Modal>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 매장 등록 탭 (원본 그대로)
// ══════════════════════════════════════════════════════════════════════════════
// 80차 후속: 체험형 공연은 "1인당 가격" 하나만 입력받고, 실제 예약 흐름이 참조하는
// pricing 배열(인원수별 총액)은 저장 시점에 여기서 파생 계산 — reserveShowSlotCF/
// buildPeopleItems 등 기존 pricing 기반 로직을 하나도 안 건드리기 위한 선택.
function computeShowPricing(minPeople, maxPeople, pricePerPerson) {
  const min = Number(minPeople) || 1;
  const max = Number(maxPeople) || min;
  const per = Number(pricePerPerson) || 0;
  if (max < min) return [];
  return Array.from({ length: max - min + 1 }, (_, i) => ({ people: min + i, price: (min + i) * per }));
}

function emptyTheme() {
  return {
    name:'', genre:'공포', difficulty:'normal',
    minPeople:2, maxPeople:4, duration:60,
    startTime:'', prepMinutes:'0', // 78차 57차: 시작시간(비우면 매장 공통)/준비시간
    bookingFormat:'room', capacity:'', // 80차: 예약 형식(체험형 공연은 정원 필요)
    activityLevel:'normal', pricePerPerson:'', notices:'', refundPolicy:'', // 80차 후속: 체험형 전용 필드
    seatingType:'shared', // 80차 후속: 체험형 전용 — 단독 대관 vs 합석 일반 회차
    description:'', imageUrl:'', imageLocalUri:'',
    pricing:[
      {people:2, price:''},
      {people:3, price:''},
      {people:4, price:''},
    ],
  };
}

function RegisterTab({ onComplete }) {
  const [saving, setSaving] = useState(false);
  const [uploadingTheme, setUploadingTheme] = useState(null);

  const initForm = () => ({
    ownerName:'', email:'', contact:'', contactName:'', // 78차 52차: 담당자 실명
    businessRegNumber:'', // 78차 54차: 사업자등록번호
    // 78차 60차: "정산 계좌"(bankName/bankAccount/bankHolder) 삭제 — 실제 정산이 계좌이체가
    // 아니라 플랜 구독료/인보이스 방식으로 확정된 이후 어디에서도 이 값을 읽는 곳이 없었음
    // (EditStore/인보이스/일괄등록 전부 이미 이 필드가 없었음 — 이 폼에만 옛날 그대로 남아있던
    // 죽은 코드). "예전 템플릿 같다"는 지적의 실체.
    // 78차 44차: 매출 연동 수수료(feeType/discountRate/fixedFee) 삭제 — 플랜 구독료만 받음
    // 78차 47차: 신규 매장 폼의 초기값 — 등록 시 실제 적용되는 등급별 기본값은
    // PLAN_DEFAULT_DISCOUNT_RATE 참고(총괄관리자가 이후 매장별 재량으로 조정)
    // 80차 후속: 신규 매장은 항상 STANDARD로 시작(등급 변경은 등록 후 "💳 플랜 변경"
    // 버튼으로) — 할인율 기본값도 STANDARD 기준으로. 매장관리자 기능 애드온은 기본 꺼짐.
    paymentDay:'', planDiscountRate:String(PLAN_DEFAULT_DISCOUNT_RATE.standard), opsAddon:false,
    contractStart:today10(),
    contractEnd:localAddDaysStr(365),
    paymentType:'external', reservationUrl:'',
    loginId:'', // 76차: 매장관리자 로그인 ID (비워두면 계정 발급 없이 매장만 등록)
    startTime:'09:00', endTime:'22:00', // 78차 50차: 매장 공통 운영시간
  });
  const [form, setForm] = useState(initForm());
  const F = (k,v)=>setForm(p=>({...p,[k]:v}));
  // 76차: createStoreAdminAccountCF 결과(1회성 임시 비밀번호) 표시용
  const [issuedAccount, setIssuedAccount] = useState(null); // {loginId, tempPassword, staff}
  // 78차 68차: 사장님(owner) 계정과 별개로, 매출·정산이 보이는 "매장관리" 탭이 빠진
  // 직원용 제한 계정({loginId}_staff)도 함께 발급할지 선택
  const [createStaffAccount, setCreateStaffAccount] = useState(false);

  const [branches, setBranches] = useState([
    { branchName:'', city:'', district:'', addressDetail:'', themes:[emptyTheme()] }
  ]);

  const addBranch = ()=>setBranches(p=>[...p,{branchName:'',city:'',district:'',addressDetail:'',themes:[emptyTheme()]}]);
  const removeBranch = (bi)=>setBranches(p=>p.filter((_,i)=>i!==bi));
  const updateBranch = (bi,k,v)=>setBranches(p=>{const u=[...p];u[bi]={...u[bi],[k]:v};return u;});

  const addTheme = (bi)=>setBranches(p=>{const u=[...p];u[bi]={...u[bi],themes:[...u[bi].themes,emptyTheme()]};return u;});
  const removeTheme = (bi,ti)=>setBranches(p=>{const u=[...p];u[bi]={...u[bi],themes:u[bi].themes.filter((_,i)=>i!==ti)};return u;});
  const updateTheme = (bi,ti,k,v)=>setBranches(p=>{
    const u=[...p];const themes=[...u[bi].themes];themes[ti]={...themes[ti],[k]:v};
    if(k==='minPeople'||k==='maxPeople'){
      const min=Number(k==='minPeople'?v:themes[ti].minPeople);
      const max=Number(k==='maxPeople'?v:themes[ti].maxPeople);
      if(min>0&&max>=min){
        themes[ti].pricing=Array.from({length:max-min+1},(_,i)=>{
          const existing=themes[ti].pricing?.find(pp=>pp.people===min+i);
          return {people:min+i,price:existing?.price||''};
        });
      }
    }
    // 80차 후속: "체험형"으로 처음 전환할 때(유의사항/환불정책이 비어있을 때만) 기본 문구 채움
    // — EventsScreen.js의 NOTICE_TEMPLATES pristine-check와 동일 패턴.
    if(k==='bookingFormat'&&v==='show'){
      if(!themes[ti].notices) themes[ti].notices=SHOW_DEFAULT_NOTICES;
      if(!themes[ti].refundPolicy) themes[ti].refundPolicy=SHOW_DEFAULT_REFUND_POLICY;
    }
    u[bi]={...u[bi],themes};return u;
  });
  const updatePricing = (bi,ti,pi,v)=>setBranches(p=>{
    const u=[...p];const themes=[...u[bi].themes];
    const pricing=[...themes[ti].pricing];pricing[pi]={...pricing[pi],price:v};
    themes[ti]={...themes[ti],pricing};u[bi]={...u[bi],themes};return u;
  });

  const pickThemeImage = async (bi,ti)=>{
    const perm=await ImagePicker.requestMediaLibraryPermissionsAsync();
    if(!perm.granted){showAlert('권한 필요','갤러리 접근 권한이 필요합니다.');return;}
    const result=await ImagePicker.launchImageLibraryAsync({
      mediaTypes:ImagePicker.MediaTypeOptions.Images,
      allowsEditing:true, aspect:[4,3], quality:0.8,
    });
    if(!result.canceled&&result.assets[0]){
      updateTheme(bi,ti,'imageLocalUri',result.assets[0].uri);
      updateTheme(bi,ti,'imageUrl','');
    }
  };

  const handleRegister = async ()=>{
    if(!form.ownerName||!form.email) return showAlert('알림','사업자명과 이메일은 필수예요.');
    if(form.paymentType==='external'&&!form.reservationUrl) return showAlert('알림','외부 예약 URL을 입력해주세요.');
    // 76차: 로그인 ID를 입력했다면 CF와 동일한 형식 규칙을 미리 검증(영문/숫자/밑줄 4자 이상)
    if(form.loginId && !/^[A-Za-z0-9_]{4,}$/.test(form.loginId))
      return showAlert('알림','로그인 ID는 영문/숫자/밑줄 4자 이상이어야 해요.');
    for(const b of branches){
      if(!b.branchName) return showAlert('알림','지점명을 입력해주세요.');
      for(const t of b.themes){
        if(!t.name) return showAlert('알림','테마명을 입력해주세요.');
      }
    }
    // 78차 70차: 이미 등록된 매장과 동일한 이메일/사업자등록번호면 중복 등록 차단
    const dupReason = await checkDuplicateStore({ email: form.email, businessRegNumber: form.businessRegNumber });
    if (dupReason) return showAlert('알림', dupReason);
    setSaving(true);
    try {
      const processedBranches = await Promise.all(branches.map(async (b,bi)=>({
        ...b,
        themes: await Promise.all(b.themes.map(async (t,ti)=>{
          let imageUrl=t.imageUrl;
          if(t.imageLocalUri){
            setUploadingTheme({bi,ti});
            imageUrl=await uploadImageAsync(t.imageLocalUri,'themes');
          }
          const {imageLocalUri,...rest}=t;
          const duration = Number(t.duration);
          const prepMinutes = Number(t.prepMinutes) || 0;
          const interval = (duration || 60) + prepMinutes;
          // 78차 57차: 등록 시점부터 바로 예약 가능하도록 availableTimes 생성 — 간격은
          // 플레이시간(duration)+준비시간(prepMinutes), 시작시간은 이 테마 값이 있으면
          // 그걸, 없으면 매장 공통(form.startTime) 사용.
          const minPeople = Number(t.minPeople), maxPeople = Number(t.maxPeople);
          // 80차 후속: [버그 수정] 여기서 매번 computeShowPricing으로 pricing을 강제
          // 재계산하고 있어서, 위 "표에 일괄 채우기" 버튼 이후 인원별로 직접 고친 값이
          // 저장 시점에 전부 덮어써지고 있었음 — rest.pricing(테이블에 이미 반영된 값)을
          // 그대로 저장(방탈출과 동일하게).
          return {
            ...rest, imageUrl, minPeople, maxPeople, duration,
            prepMinutes, intervalMinutes: interval,
            capacity: t.capacity ? Number(t.capacity) : 0,
            availableTimes: generateBulkSlots(t.startTime || form.startTime, form.endTime, interval),
          };
        })),
      })));

      const now = new Date();
      // 68차: products 컬렉션 병행 쓰기 제거 — stores 문서 하나만 생성.
      // 80차 후속: 신규 매장은 2단계 plan 체계의 최하위인 'standard'로 시작
      // (매장관리자 기능 애드온은 폼의 체크박스 값 그대로).
      const { loginId, ...formRest } = form;
      const storeRef = await addDoc(collection(db,'stores'),{
        ...formRest,
        branches:processedBranches,
        status:'active',
        plan:'standard',
        opsAddon: !!form.opsAddon,
        createdAt:now.toISOString(),
        paymentDay: form.paymentDay ? Number(form.paymentDay) : now.getDate(),
        planDiscountRate: Math.min(100, Math.max(0, Number(form.planDiscountRate) || 0)),
      });
      invalidateStoreCache();
      setUploadingTheme(null);

      // 76차: 로그인 ID를 입력했다면 매장 생성 직후 바로 매장관리자 계정 발급
      let account = null;
      if (loginId) {
        try {
          const cf = httpsCallable(functions, 'createStoreAdminAccountCF');
          const { data } = await cf({ loginId, storeId: storeRef.id, storeName: form.ownerName, createStaffAccount });
          account = data;
        } catch (e) {
          showAlert('알림', `매장은 등록됐지만 계정 발급에 실패했어요: ${e.message}\n유저관리에서 다시 시도해주세요.`);
        }
      }

      setForm(initForm());
      setBranches([{branchName:'',city:'',district:'',addressDetail:'',themes:[emptyTheme()]}]);
      setCreateStaffAccount(false);
      if (account) {
        setIssuedAccount(account);
      } else {
        showAlert('완료','매장이 등록되었습니다!',[{text:'확인',onPress:onComplete}]);
      }
    } catch(e){
      setUploadingTheme(null);
      showAlert('오류','등록 실패: '+e.message);
    } finally { setSaving(false); }
  };

  return (
    <View>
      <Text style={s.sectionTitle}>새 매장 등록</Text>

      <SCard title="기본 정보" Icon={EditIcon}>
        <FI label="사업자명 *" value={form.ownerName} onChange={v=>F('ownerName',v)} placeholder="예: 이스케이프팩토리"/>
        <FI label="이메일 *" value={form.email} onChange={v=>F('email',v)} keyboard="email-address" placeholder="예: contact@store.com"/>
        <FI label="연락처" value={form.contact} onChange={v=>F('contact',v)} keyboard="phone-pad"/>
        <FI label="담당자명 (선택)" value={form.contactName} onChange={v=>F('contactName',v)} placeholder="예: 홍길동"/>
        <FI label="사업자등록번호 (선택)" value={form.businessRegNumber} onChange={v=>F('businessRegNumber',v)} placeholder="예: 123-45-67890"/>
      </SCard>

      {/* 76차: 매장관리자 로그인 계정 발급 — 비워두면 계정 없이 매장만 등록(기존 동작 유지) */}
      <SCard title="매장관리자 계정 (선택)" Icon={MenuPasswordIcon}>
        <FI label="로그인 ID (영문/숫자/밑줄 4자 이상)" value={form.loginId}
          onChange={v=>F('loginId', v.trim())} placeholder="예: zerogangnam"/>
        <Text style={s.muted}>입력하면 매장 등록과 동시에 로그인 계정을 발급하고 1회용 임시 비밀번호를 보여줘요. 비워두면 나중에 유저관리에서 발급할 수 있어요.</Text>
        {/* 78차 68차: 사장님이 알바생에게 매출·정산까지 보여주고 싶지 않을 수 있다는 지적으로,
            "매장관리" 탭(매출·통계·정산)이 빠진 직원용 제한 계정을 선택적으로 함께 발급 */}
        {!!form.loginId && (
          <TouchableOpacity style={s.checkboxRow} onPress={() => setCreateStaffAccount(v => !v)}>
            <View style={[s.checkbox, createStaffAccount && s.checkboxOn]}>
              {createStaffAccount && <CheckmarkIcon size={12} color={C.onGold} />}
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ color: C.text, fontSize: 13, fontWeight: '700' }}>직원용 제한 계정도 함께 발급</Text>
              <Text style={s.muted}>{form.loginId}_staff 계정이 추가로 생성돼요. 매출·통계가 보이는 "매장관리" 탭만 빠지고 예약 관리 등 나머지는 동일하게 이용 가능해요.</Text>
            </View>
          </TouchableOpacity>
        )}
      </SCard>

      <SCard title="계약 기간" Icon={MenuReservationIcon}>
        <FI label="계약 시작일 (YYYY-MM-DD)" value={form.contractStart} onChange={v=>F('contractStart',v)} placeholder="2025-01-01"/>
        <FI label="계약 종료일 (YYYY-MM-DD)" value={form.contractEnd} onChange={v=>F('contractEnd',v)} placeholder="2026-01-01"/>
      </SCard>

      <SCard title="결제 방식" Icon={PaymentIcon}>
        {[{v:'external',l:'외부 결제 (자체 예약 URL)'},{v:'internal',l:'플랫폼 내 결제'}].map(o=>(
          <TouchableOpacity key={o.v} style={[s.radioRow,form.paymentType===o.v&&s.radioRowOn]} onPress={()=>F('paymentType',o.v)}>
            <View style={[s.radio,form.paymentType===o.v&&s.radioOn]}/><Text style={s.radioLabel}>{o.l}</Text>
          </TouchableOpacity>
        ))}
        {form.paymentType==='external'&&<FI label="외부 예약 URL *" value={form.reservationUrl} onChange={v=>F('reservationUrl',v)} keyboard="url" placeholder="https://..."/>}
      </SCard>

      {/* 78차 57차: 종료시간은 매장 공통, 시작시간은 테마별로 다르면 아래 각 테마 카드에서
          덮어쓸 수 있음(비워두면 여기 값 사용) — 등록 시점에 예약 가능 시간을 바로 생성 */}
      <SCard title="운영시간 (기본값)" Icon={ClockIcon}>
        <View style={{flexDirection:'row',gap:10}}>
          <View style={{flex:1}}><FI label="시작 시간" value={form.startTime} onChange={v=>F('startTime',v)} placeholder="09:00"/></View>
          <View style={{flex:1}}><FI label="종료 시간" value={form.endTime} onChange={v=>F('endTime',v)} placeholder="22:00"/></View>
        </View>
      </SCard>

      {/* 78차 44차: 매출 연동 수수료(요율/정액) 선택 삭제 — 플랜 구독료만 받기로 확정.
          납부일은 그 구독료 청구 주기로 계속 쓰이므로 유지 */}
      <SCard title="정산 주기" Icon={PriceIcon}>
        <FI label="납부일 (비우면 등록일 자동)" value={String(form.paymentDay||'')} onChange={v=>F('paymentDay',v)} keyboard="numeric" placeholder="예: 10 → 매달 10일"/>
        {/* 78차 47차: 플랜 구독료 할인율(0~100%) — 신규 매장은 등급별 최초계약 기본값(PLAN_DEFAULT_DISCOUNT_RATE)으로
            시작, 이후 총괄관리자가 매장별 재량으로 수동 조정(구체적 수치는 의도적으로 여기 안 적음) */}
        <FI label="플랜 할인율 (%)" value={String(form.planDiscountRate??'')} onChange={v=>F('planDiscountRate',v)} keyboard="numeric" placeholder="0~100"/>
        {/* 80차 후속: 예약관리·통계·정산 — plan(노출 등급)과 무관한 별도 유료 애드온.
            자체 예약 시스템이 있는 대형 매장은 꺼둔 채로 등록하는 게 일반적일 것으로 예상. */}
        <TouchableOpacity style={s.checkboxRow} onPress={() => F('opsAddon', !form.opsAddon)}>
          <View style={[s.checkbox, form.opsAddon && s.checkboxOn]}>
            {form.opsAddon && <CheckmarkIcon size={12} color={C.onGold} />}
          </View>
          <View style={{ flex: 1 }}>
            <Text style={{ color: C.text, fontSize: 13, fontWeight: '700' }}>매장관리자 기능 애드온 (월 {OPS_ADDON_FEE.toLocaleString()}원 추가)</Text>
            <Text style={s.muted}>예약 확인·통계·월별 정산 요약이 필요한 매장만 켜세요. 자체 예약 시스템이 있으면 꺼둬도 앱 노출(PICK 포함)은 그대로 이용 가능해요.</Text>
          </View>
        </TouchableOpacity>
      </SCard>

      <SCard title="지점 & 테마" Icon={MenuStoreIcon}>
        <SecondaryButton label="+ 지점 추가" onPress={addBranch} style={s.smBtn} textStyle={s.smBtnTxt} />

        {branches.map((b,bi)=>(
          <View key={bi} style={[s.card,{backgroundColor:C.surface,marginTop:12}]}>
            <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
              <Text style={[s.drillName,{color:C.warning}]}>지점 {bi+1}</Text>
              {bi>0&&<TextButton label="삭제" onPress={()=>removeBranch(bi)} textStyle={{color:C.danger,fontSize:13}} />}
            </View>
            <FI label="지점명 *" value={b.branchName} onChange={v=>updateBranch(bi,'branchName',v)} placeholder="예: 강남점"/>
            <Text style={[s.muted,{marginBottom:6}]}>시 / 도</Text>
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              <View style={{flexDirection:'row',gap:8,marginBottom:10}}>
                {REGIONS.map(city=>(
                  <TouchableOpacity key={city} style={[s.chip,b.city===city&&s.chipOn]}
                    onPress={()=>{ updateBranch(bi,'city',city); updateBranch(bi,'district',''); }}>
                    <Text style={[s.chipTxt,b.city===city&&s.chipTxtOn]}>{city}</Text>
                  </TouchableOpacity>
                ))}
              </View>
            </ScrollView>
            {b.city&&SUB_REGIONS[b.city]&&(
              <>
                <Text style={[s.muted,{marginBottom:6}]}>구 / 동</Text>
                <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                  <View style={{flexDirection:'row',gap:8,marginBottom:10}}>
                    {SUB_REGIONS[b.city].map(dist=>(
                      <TouchableOpacity key={dist} style={[s.chip,b.district===dist&&s.chipOn]}
                        onPress={()=>updateBranch(bi,'district',dist)}>
                        <Text style={[s.chipTxt,b.district===dist&&s.chipTxtOn]}>{dist}</Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                </ScrollView>
              </>
            )}
            <FI label="상세 주소 (선택)" value={b.addressDetail} onChange={v=>updateBranch(bi,'addressDetail',v)} placeholder="예: OO빌딩 3층 301호"/>

            {b.themes.map((t,ti)=>(
              <View key={ti} style={[s.card,{backgroundColor:C.bg,marginTop:10}]}>
                <View style={{flexDirection:'row',justifyContent:'space-between',marginBottom:8}}>
                  <Text style={[s.muted,{fontWeight:'700'}]}>테마 {ti+1}</Text>
                  {ti>0&&<TextButton label="삭제" onPress={()=>removeTheme(bi,ti)} textStyle={{color:C.danger,fontSize:12}} />}
                </View>
                <FI label="테마명 *" value={t.name} onChange={v=>updateTheme(bi,ti,'name',v)} placeholder="예: 저주받은 저택"/>
                <FI label="상세 설명" value={t.description} onChange={v=>updateTheme(bi,ti,'description',v)} multiline placeholder="테마 스토리, 특징 등을 입력하세요"/>
                <Text style={[s.muted,{marginBottom:6}]}>장르 (최대 2개)</Text>
                <ScrollView horizontal showsHorizontalScrollIndicator={false}>
                  <View style={{flexDirection:'row',gap:6,marginBottom:10}}>
                    {GENRE_OPTIONS.map(g=>{
                      if (g === '기타') {
                        const active = hasCustomGenre(t.genre);
                        return (
                          <TouchableOpacity key={g} style={[s.chip,active&&s.chipOn]} onPress={()=>updateTheme(bi,ti,'genre',toggleEtcGenre(t.genre))}>
                            <Text style={[s.chipTxt,active&&s.chipTxtOn]} numberOfLines={1}>{active ? (getCustomGenreText(t.genre)||'기타') : '기타'}</Text>
                          </TouchableOpacity>
                        );
                      }
                      const selected = (t.genre||'').split('/').map(x=>x.trim()).includes(g);
                      return (
                        <TouchableOpacity key={g} style={[s.chip,selected&&s.chipOn]} onPress={()=>updateTheme(bi,ti,'genre',toggleGenreValue(t.genre,g))}>
                          <Text style={[s.chipTxt,selected&&s.chipTxtOn]}>{g}</Text>
                        </TouchableOpacity>
                      );
                    })}
                  </View>
                </ScrollView>
                {/* 78차 62차: "기타" 선택 시 특이 장르 직접 입력(예: 야외테마) */}
                {hasCustomGenre(t.genre) && (
                  <FI label="기타 장르 직접 입력" value={getCustomGenreText(t.genre)} onChange={v=>updateTheme(bi,ti,'genre',setCustomGenreText(t.genre,v))} placeholder="예: 야외테마"/>
                )}
                {/* 80차 후속: 체험형 공연은 "난이도" 대신 "활동성"(같은 4단계 enum 재사용) */}
                {(t.bookingFormat||'room')!=='show' ? (
                  <>
                    <Text style={[s.muted,{marginBottom:6}]}>난이도</Text>
                    <View style={{flexDirection:'row',flexWrap:'wrap',gap:6,marginBottom:10}}>
                      {DIFFICULTY_OPTIONS.map(d=>(
                        <TouchableOpacity key={d.v} style={[s.chip,t.difficulty===d.v&&s.chipOn]} onPress={()=>updateTheme(bi,ti,'difficulty',d.v)}>
                          <Text style={[s.chipTxt,t.difficulty===d.v&&s.chipTxtOn]}>{d.l}</Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </>
                ) : (
                  <>
                    <Text style={[s.muted,{marginBottom:6}]}>활동성</Text>
                    <View style={{flexDirection:'row',flexWrap:'wrap',gap:6,marginBottom:10}}>
                      {Object.entries(ACTIVITY_META).map(([v,meta])=>(
                        <TouchableOpacity key={v} style={[s.chip,(t.activityLevel||'normal')===v&&s.chipOn]} onPress={()=>updateTheme(bi,ti,'activityLevel',v)}>
                          <Text style={[s.chipTxt,(t.activityLevel||'normal')===v&&s.chipTxtOn]}>{meta.label}</Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                  </>
                )}
                {/* 80차: 예약 형식 — 방탈출(전세) 기본, 체험형 공연(정원제) 선택 시 정원 입력 */}
                <Text style={[s.muted,{marginBottom:6}]}>예약 형식</Text>
                <View style={{flexDirection:'row',gap:6,marginBottom:10}}>
                  {Object.entries(BOOKING_FORMATS).map(([v,meta])=>(
                    <TouchableOpacity key={v} style={[s.chip,(t.bookingFormat||'room')===v&&s.chipOn]} onPress={()=>updateTheme(bi,ti,'bookingFormat',v)}>
                      <Text style={[s.chipTxt,(t.bookingFormat||'room')===v&&s.chipTxtOn]}>{meta.label}</Text>
                    </TouchableOpacity>
                  ))}
                </View>
                {/* 80차 후속: 공포 강도 등으로 매장이 자체적으로 19세 미만 예약을 제한하고
                    싶은 테마 — 방/체험형 둘 다 해당 가능해 형식 선택 아래 공통 위치에 둠. */}
                <TouchableOpacity style={s.checkboxRow} onPress={()=>updateTheme(bi,ti,'isAdultOnly',!t.isAdultOnly)}>
                  <View style={[s.checkbox,t.isAdultOnly&&s.checkboxOn]}>
                    {t.isAdultOnly && <CheckmarkIcon size={12} color={C.onGold} />}
                  </View>
                  <View style={{flex:1}}>
                    <Text style={{color:C.text,fontSize:13,fontWeight:'700'}}>19세 이상만 예약 가능 (19금)</Text>
                    <Text style={s.muted}>예약 시 생년월일로 확인하며, 현장에서 신분증 확인 시 제한될 수 있어요.</Text>
                  </View>
                </TouchableOpacity>
                {t.bookingFormat==='show' && (
                  <>
                    <FI label="회차당 정원" value={String(t.capacity||'')} onChange={v=>updateTheme(bi,ti,'capacity',Number(v)||0)} keyboard="numeric" placeholder="예: 30"/>
                    {/* 80차 후속: 단독 대관 vs 합석 일반 회차 — 고객에게 뱃지로 노출됨 */}
                    <Text style={[s.muted,{marginBottom:6}]}>좌석 형태</Text>
                    <View style={{flexDirection:'row',gap:6,marginBottom:10}}>
                      {Object.entries(SEATING_TYPES).map(([v,meta])=>(
                        <TouchableOpacity key={v} style={[s.chip,(t.seatingType||'shared')===v&&s.chipOn]} onPress={()=>updateTheme(bi,ti,'seatingType',v)}>
                          <Text style={[s.chipTxt,(t.seatingType||'shared')===v&&s.chipTxtOn]}>{meta.label}</Text>
                        </TouchableOpacity>
                      ))}
                    </View>
                    <FI label="유의사항" value={t.notices||''} onChange={v=>updateTheme(bi,ti,'notices',v)} multiline placeholder="한 줄에 하나씩 입력하세요"/>
                    <FI label="환불 정책" value={t.refundPolicy||''} onChange={v=>updateTheme(bi,ti,'refundPolicy',v)} multiline/>
                  </>
                )}
                <FI label="진행 시간 (분)" value={String(t.duration)} onChange={v=>updateTheme(bi,ti,'duration',v)} keyboard="numeric" placeholder="60"/>
                {/* 78차 57차: 방마다 첫 회차 시작시간/회차 사이 준비시간이 다를 수 있어 테마별 입력 추가 */}
                <View style={{flexDirection:'row',gap:12}}>
                  <View style={{flex:1}}><FI label="시작 시간 (비우면 매장 공통)" value={t.startTime||''} onChange={v=>updateTheme(bi,ti,'startTime',v)} placeholder="09:00"/></View>
                  {/* 78차: 여러 방을 동시 운영해 실제 회전 주기가 진행시간보다 짧은 매장을
                      위해 마이너스 준비시간 허용 — -60~+60분 스크롤 선택으로 교체 */}
                  <MinutesPickerField label="준비시간 (분)" value={t.prepMinutes ?? 0} onChange={v=>updateTheme(bi,ti,'prepMinutes',v)} />
                </View>
                <View style={{flexDirection:'row',gap:12}}>
                  <View style={{flex:1}}><FI label="최소 인원" value={String(t.minPeople)} onChange={v=>updateTheme(bi,ti,'minPeople',v)} keyboard="numeric"/></View>
                  <View style={{flex:1}}><FI label="최대 인원" value={String(t.maxPeople)} onChange={v=>updateTheme(bi,ti,'maxPeople',v)} keyboard="numeric"/></View>
                </View>
                {/* 80차 후속: [기능 추가] 체험형도 실제 예약 흐름은 방탈출과 동일하게 인원별
                    가격표(pricing)만 참조 — "1인당 가격"을 입력값 자체가 아니라 "일괄
                    채우기" 도우미로 바꿔서, 신촌성심병원처럼 인원과 무관한 고정 총액이나
                    비선형 그룹 할인(예: 1인 35,000/2인 68,000)도 등록 후 표 아래에서
                    인원별로 직접 고칠 수 있게 함(실제 시장 조사로 확인된 사례). */}
                {t.bookingFormat==='show' && (
                  <View style={{flexDirection:'row',gap:8,marginBottom:8}}>
                    <View style={{flex:1}}>
                      <FI label="1인당 가격 (원)" value={String(t.pricePerPerson||'')} onChange={v=>updateTheme(bi,ti,'pricePerPerson',Number(v)||0)} keyboard="numeric" placeholder="예: 120000"/>
                    </View>
                    <SecondaryButton
                      label="표에 일괄 채우기"
                      onPress={()=>updateTheme(bi,ti,'pricing', computeShowPricing(Number(t.minPeople)||1, Number(t.maxPeople)||1, t.pricePerPerson))}
                      style={{alignSelf:'flex-end',marginBottom:12}}
                    />
                  </View>
                )}
                {(t.pricing||[]).length>0&&(
                  <>
                    <Text style={[s.muted,{marginBottom:8}]}>
                      인원별 가격 (원){t.bookingFormat==='show' ? ' — 인원마다 다르게 직접 수정할 수 있어요' : ''}
                    </Text>
                    {t.pricing.map((pp,pi)=>(
                      <View key={pi} style={{flexDirection:'row',alignItems:'center',gap:10,marginBottom:8}}>
                        <View style={s.pricePeopleBadge}>
                          <Text style={s.pricePeopleTxt}>{pp.people}명</Text>
                        </View>
                        <TextInput
                          style={[s.input,{flex:1}]}
                          value={String(pp.price)}
                          onChangeText={v=>updatePricing(bi,ti,pi,v)}
                          keyboardType="numeric"
                          placeholder="예: 25000"
                          placeholderTextColor={C.muted}
                        />
                        <Text style={s.muted}>원</Text>
                      </View>
                    ))}
                  </>
                )}
                <Text style={[s.muted,{marginBottom:8}]}>테마 대표 이미지</Text>
                {t.imageLocalUri||t.imageUrl ? (
                  <View style={{marginBottom:10}}>
                    <Image source={{uri:t.imageLocalUri||t.imageUrl}} style={s.imgPreview} resizeMode="cover"/>
                    <TouchableOpacity style={s.imgRemoveBtn} onPress={()=>{updateTheme(bi,ti,'imageLocalUri','');updateTheme(bi,ti,'imageUrl','');}}>
                      <Text style={s.imgRemoveTxt}>✕ 이미지 제거</Text>
                    </TouchableOpacity>
                  </View>
                ) : (
                  <TouchableOpacity style={s.imgPickBtn} onPress={()=>pickThemeImage(bi,ti)}>
                    {uploadingTheme?.bi===bi&&uploadingTheme?.ti===ti
                      ?<ActivityIndicator color={C.gold}/>
                      :<>
                        <Text style={{fontSize:28,marginBottom:4}}>🖼</Text>
                        <Text style={{color:C.gold,fontWeight:'600',fontSize:13}}>갤러리에서 선택</Text>
                        <Text style={[s.muted,{fontSize:11,marginTop:2}]}>권장: 4:3 비율</Text>
                      </>
                    }
                  </TouchableOpacity>
                )}
              </View>
            ))}
            <SecondaryButton label="+ 테마 추가" onPress={()=>addTheme(bi)} style={[s.smBtn,{marginTop:8,alignSelf:'flex-start'}]} textStyle={s.smBtnTxt} />
          </View>
        ))}
      </SCard>

      <GradientButton
        label={saving ? '등록 중...' : '매장 등록'}
        Icon={saving ? undefined : CheckmarkIcon}
        onPress={handleRegister}
        disabled={saving}
        style={s.primaryBtn}
        textStyle={s.primaryBtnTxt}
      />

      {/* 76차: 계정 발급 결과 — 임시 비밀번호는 여기서만 보여주고 다시 조회 불가.
          닫기(✕) 없이 "확인"만 — 실수로 비밀번호를 못 보고 닫는 것을 방지 */}
      <Modal visible={!!issuedAccount} transparent animationType="fade">
        <View style={s.issuedOverlay}>
          <View style={[s.issuedBox,{padding:0,overflow:'hidden'}]}>
            <AppHeader isModal centerElement={<IconLabel Icon={CheckmarkIcon} size={14} color={C.text} textStyle={s.modalHeaderTitle}>계정 발급 완료</IconLabel>} />
            <View style={{padding:24}}>
            <Text style={s.issuedWarn}>이 비밀번호는 다시 확인할 수 없어요. 지금 매장에 전달해주세요.</Text>
            <IconLabel Icon={PersonIcon} size={12} color={C.gold} textStyle={{color:C.gold,fontSize:12,fontWeight:'700'}} style={{marginBottom:4}}>사장님 계정 (전체 권한)</IconLabel>
            <Text style={s.muted}>로그인 ID</Text>
            <TextInput style={s.input} value={issuedAccount?.loginId} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
            <Text style={[s.muted,{marginTop:10}]}>임시 비밀번호</Text>
            <TextInput style={s.input} value={issuedAccount?.tempPassword} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
            {/* 78차 68차: 직원용 제한 계정도 함께 발급했다면 같은 모달에서 이어서 표시 —
                staff.error가 있으면(사장님 계정은 성공했지만 직원 계정만 실패) 안내만. */}
            {issuedAccount?.staff && !issuedAccount.staff.error && (
              <>
                <Text style={{color:C.gold,fontSize:12,fontWeight:'700',marginTop:20,marginBottom:4}}>🧑‍💼 직원용 제한 계정 (매장관리 탭 제외)</Text>
                <Text style={s.muted}>로그인 ID</Text>
                <TextInput style={s.input} value={issuedAccount.staff.loginId} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
                <Text style={[s.muted,{marginTop:10}]}>임시 비밀번호</Text>
                <TextInput style={s.input} value={issuedAccount.staff.tempPassword} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
              </>
            )}
            {issuedAccount?.staff?.error && (
              <IconLabel Icon={WarningIcon} size={13} color="#e05555" textStyle={[s.muted,{color:'#e05555'}]} style={{marginTop:16}}>직원용 계정 발급은 실패했어요: {issuedAccount.staff.error}. 유저관리에서 다시 시도해주세요.</IconLabel>
            )}
            <GradientButton
              label="확인"
              onPress={()=>{ setIssuedAccount(null); onComplete(); }}
              style={{marginTop:16}}
              textStyle={s.primaryBtnTxt}
            />
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 76차 신규: 매장 일괄 등록 (엑셀) — 계약 체결 후 첫 매장 정보를 총관리자가 직접 다수
// 등록하는 경우가 많을 것으로 예상되어, 정해진 엑셀 규칙대로 입력하면 매장 등록 +
// 로그인 ID/PW 발급까지 한 번에 처리. StoreAdminScreen.js의 BulkThemeImportTab(75차)와
// 동일한 파일 읽기/파싱 패턴을 재사용, 매장 생성 후 createStoreAdminAccountCF(Feature 2,
// 이번 세션에 이미 구현)를 그대로 재호출 — 코드 중복 최소화.
// ══════════════════════════════════════════════════════════════════════════════
// StoreAdminScreen.js의 BulkThemeImportTab과 동일한 난이도 한글 매핑
const DIFFICULTY_KO_MAP = { 쉬움:'easy', 초급:'easy', 보통:'normal', 중급:'normal', 어려움:'hard', 고급:'hard', 전문가:'expert', 최고난도:'expert' };
// 78차 63차: 실제 도트 표기(●●●●, 4단계)와 헷갈리지 않도록 일괄등록 난이도 입력을
// 1~5 숫자로도 받을 수 있게 함(1~2=쉬움, 3=보통, 4=어려움, 5=전문가) — 한글 라벨 입력도
// 계속 지원(하위호환).
const DIFFICULTY_NUM_MAP = { 1:'easy', 2:'easy', 3:'normal', 4:'hard', 5:'expert' };
const normalizeDifficulty = (v) => {
  const num = Number(v);
  if (!isNaN(num) && DIFFICULTY_NUM_MAP[num]) return DIFFICULTY_NUM_MAP[num];
  const str = String(v || '').trim();
  if (['easy', 'normal', 'hard', 'expert'].includes(str)) return str;
  return DIFFICULTY_KO_MAP[str] || 'normal';
};
// 80차 후속: 체험형 공연 "활동성" 컬럼 — 난이도와 같은 4단계 enum(easy~expert)이라
// 숫자/영문/기존 난이도 한글 라벨은 normalizeDifficulty에 그대로 위임하고, 활동성
// 전용 한글 라벨(여유로움/활동적/격렬함)만 추가로 인식.
const ACTIVITY_KO_MAP = { 여유로움:'easy', 여유:'easy', 보통:'normal', 활동적:'hard', 격렬함:'expert', 격렬:'expert' };
const normalizeActivity = (v) => ACTIVITY_KO_MAP[String(v || '').trim()] || normalizeDifficulty(v);
// 80차 후속: [기능 공백 수정] 체험형 엑셀 일괄등록에 좌석형태(단독/합석) 컬럼이 아예
// 없어서 항상 기본값(합석)으로만 등록되고 있었음(fork로 발견) — SEATING_TYPES 라벨과
// 동일한 한글 값, 인식 안 되면 안전하게 '합석'.
const normalizeSeatingType = (v) => (String(v || '').trim() === '단독' ? 'exclusive' : 'shared');

// 78차 45차: 테마 장르 2개까지 다중 선택 — 실제 매장 테마 중 "공포/추리"처럼 두 장르를
// 같이 표기하는 경우가 많다는 피드백으로 추가. 스키마 변경 없이 기존 genre 문자열
// 필드에 "/"로 이어붙여 저장(화면 대부분이 genre를 그냥 텍스트로 찍고 있어 표시는
// 자동 해결됨 — constants/index.js의 splitGenres/getGenreMeta가 파싱 담당).
// 이미 2개 선택된 상태에서 세 번째를 누르면 가장 먼저 고른 것을 밀어내고 교체.
const toggleGenreValue = (current, g) => {
  const parts = (current || '').split('/').map(s => s.trim()).filter(Boolean);
  if (parts.includes(g)) return parts.filter(p => p !== g).join('/');
  if (parts.length >= 2) return [parts[1], g].join('/');
  return [...parts, g].join('/');
};

// 78차 62차: "기타" 장르 직접 입력 — 특이 장르(예: 야외테마)는 GENRES 목록에 없어
// 고를 수가 없었음. "기타" 칩 자리를 커스텀 텍스트 슬롯으로 취급 — 저장 형식은
// 그대로 genre 문자열("공포/야외테마"처럼)이라 스키마 변경 없음, getGenreMeta도
// 이미 목록 밖 값은 중립색으로 안전하게 처리하고 있어 표시 쪽은 손댈 필요 없음.
const isCustomGenrePart = (p) => p === '기타' || !GENRE_OPTIONS.includes(p);
const hasCustomGenre = (genre) => (genre || '').split('/').map(s => s.trim()).filter(Boolean).some(isCustomGenrePart);
const getCustomGenreText = (genre) => {
  const found = (genre || '').split('/').map(s => s.trim()).filter(Boolean).find(p => p !== '기타' && isCustomGenrePart(p));
  return found || '';
};
const toggleEtcGenre = (current) => {
  const parts = (current || '').split('/').map(s => s.trim()).filter(Boolean);
  const idx = parts.findIndex(isCustomGenrePart);
  if (idx >= 0) { parts.splice(idx, 1); return parts.join('/'); }
  if (parts.length >= 2) return [parts[1], '기타'].join('/');
  return [...parts, '기타'].join('/');
};
const setCustomGenreText = (current, text) => {
  const parts = (current || '').split('/').map(s => s.trim()).filter(Boolean);
  const idx = parts.findIndex(isCustomGenrePart);
  const value = text.trim() || '기타';
  if (idx >= 0) parts[idx] = value; else parts.push(value);
  return parts.slice(0, 2).join('/');
};

// 78차 44차: 시/도·구/군·장르 컬럼은 진짜 드롭다운이 아니라 자유 텍스트라 오타/변형
// 표기("강남구" vs "강남")가 들어올 수 있음 — 정확히 일치하면 그대로, 시/구/군 접미사
// 차이만 있으면 그것만 보정, 그래도 없으면 fallback으로 대체.
// 78차 62차: 엑셀에서 "시작시간"/"종료시간" 셀을 시간 서식(예: h:mm)으로 입력하면
// xlsx가 셀 텍스트("12:00") 대신 그 서식의 실제 저장값(하루 대비 비율, 예: 0.5)을
// 그대로 돌려줘 String()으로 감싸면 "0.5" 같은 소수 문자열이 되던 버그 — 셀이
// 숫자(0~1 사이 분수)로 오면 시:분으로 환산, 이미 "12:00" 문자열이면 그대로 사용.
// 78차: 실사용 중 실제로 이 소수가 "숫자"가 아니라 이미 "0.451..." 형태의 *문자열*로
// 들어오는 경로도 있는 것으로 확인(콜론 정규식과 안 맞아 그대로 통과되고 있었음) —
// 숫자든 순수 소수 형태 문자열이든 전부 잡아내도록 보강.
const parseExcelTimeCell = (val) => {
  const str = String(val ?? '').trim();
  const m = str.match(/^(\d{1,2}):(\d{2})/);
  if (m) return `${m[1].padStart(2, '0')}:${m[2]}`;
  const frac = typeof val === 'number' ? val : Number(str);
  if (Number.isFinite(frac) && frac >= 0 && frac < 1) {
    const totalMin = Math.round(frac * 24 * 60);
    const hh = Math.floor(totalMin / 60) % 24;
    const mm = totalMin % 60;
    return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
  }
  return str;
};

const matchInList = (value, list, fallback) => {
  const v = String(value || '').trim();
  if (list.includes(v)) return v;
  const stripped = v.replace(/(시|구|군)$/, '');
  if (list.includes(stripped)) return stripped;
  return fallback;
};

// 78차 44차: "2인:22000;3인:24000;4인:26000" 형식을 pricing 배열로 변환.
// 78차 61차: 단일 "가격" 컬럼 폴백 삭제 — 인원별가격만 지원(사용자 요청).
const parsePricingField = (row) => {
  const raw = String(row['인원별가격'] || '').trim();
  if (!raw) return [];
  return raw.split(/[;,]/).map(seg => seg.trim()).filter(Boolean).map(seg => {
    const [peopleStr, priceStr] = seg.split(':');
    const people = parseInt(String(peopleStr || '').replace(/[^0-9]/g, ''), 10);
    const price = parseInt(String(priceStr || '').replace(/[^0-9]/g, ''), 10);
    return { people, price };
  }).filter(p => p.people > 0 && p.price > 0);
};

// 78차 48차: 일괄등록 시 시작/종료 시간을 안 받고 있어 등록 직후엔 테마의 startTime/
// endTime이 항상 기본값(09:00~22:00)이고 실제 예약 가능 시간(availableTimes)도 비어
// 있었음(매장관리자가 매장설정 화면에서 운영시간을 한 번 더 저장해야만 실제로 예약
// 가능해지던 문제) — StoreAdminScreen.js의 generateSlots와 동일한 계산을 여기서도
// 수행해 등록 시점부터 바로 예약 가능하게 함(세부 조정은 매장관리자가 매장설정에서
// 그대로 할 수 있음).
// 78차 50차: blocked(특정 시간 차단, StoreAdminScreen ScheduleTab에서 설정) 파라미터
// 추가 — EditStore 저장 시 이걸 무시하고 재생성하면 매장관리자가 이미 막아둔 시간대
// (점심시간 등)가 조용히 되살아나는 회귀가 생겨서 반드시 반영해야 함.
const generateBulkSlots = (start, end, interval = 60, blocked = []) => {
  // 78차: 준비시간 마이너스 허용으로 duration+prepMinutes가 0 이하가 될 수 있음 —
  // StoreAdminScreen.js의 generateSlots와 동일한 이유로 무한루프 방지 가드.
  interval = Math.max(1, Number(interval) || 1);
  const slots = [];
  const [sh, sm] = String(start || '09:00').split(':').map(Number);
  const [eh, em] = String(end || '22:00').split(':').map(Number);
  const startMin = sh * 60 + sm;
  let endMin = eh * 60 + em;
  // 78차 44차: 자정을 넘기는 영업시간(예: 22:00~02:00) 지원 — StoreAdminScreen.js의
  // generateSlots와 동일한 처리.
  if (endMin <= startMin) endMin += 24 * 60;
  const norm = (min) => (min < startMin ? min + 24 * 60 : min);
  for (let t = startMin; t < endMin; t += interval) {
    const wrapped = t % (24 * 60);
    const isBlocked = (blocked || []).some(b => {
      const [bsh, bsm] = String(b.start || '').split(':').map(Number);
      const [beh, bem] = String(b.end || '').split(':').map(Number);
      const bStart = norm(bsh * 60 + bsm);
      const bEnd   = norm(beh * 60 + bem);
      return t >= bStart && t < bEnd;
    });
    if (!isBlocked) slots.push(`${String(Math.floor(wrapped / 60)).padStart(2, '0')}:${String(wrapped % 60).padStart(2, '0')}`);
  }
  return slots;
};

// 78차 44차: 수수료방식/수수료율(%)/방당금액(원) 삭제 — 매출 연동 수수료 없이 플랜
// 구독료만 받기로 확정(계약 시 discountRate/fixedFee를 아예 안 넣으면 calcStoreFee가
// 자동으로 0원 처리하므로 별도 로직 변경 없이 컬럼만 빼면 됨). 납부일은 플랜 구독료
// 청구 주기로 계속 쓰이므로 유지. 이미지URL/인원별가격 신규 추가.
// 78차 61차: 사용자 요청 순서로 재배열 + 가격(단일가 폴백)/이미지URL 컬럼 삭제
// (인원별가격만 지원, 이미지는 등록 후 매장 수정에서 업로드).
// 78차 71차: "직원계정ID" 컬럼 신규(선택) — 채워두면 사장님 계정(로그인ID)과 별개로
// 매출·통계가 보이는 "매장관리" 탭이 빠진 직원용 제한 계정을 함께 발급.
// 80차 후속: 방탈출/체험형을 한 시트에 "예약형식" 컬럼으로 섞어 받던 것을, 두 형식이
// 필요로 하는 테마 필드가 서로 달라(난이도 vs 활동성, 인원별가격 vs 1인당가격, 체험형만
// 있는 유의사항/환불정책) 시트를 아예 분리 — 매장/지점 컬럼은 두 시트가 동일하고,
// 같은 사업자명+이메일+지점명이면 두 시트에 걸쳐 있어도 한 매장·한 지점으로 합쳐진다.
// 80차 후속: "매장관리자기능" 컬럼 신규(선택) — O를 넣으면 예약관리·통계·정산 애드온을
// 함께 켠 상태로 등록(플랜과 무관, 비워두면 기본 꺼짐).
const BULK_STORE_BASE_COLUMNS = [
  '사업자명','지점명','담당자명','이메일','연락처','사업자등록번호','로그인ID','직원계정ID','플랜','매장관리자기능','납부일','할인율(%)',
  '계약시작일','계약종료일','예약URL','시/도','구/군','상세주소',
];
const BULK_STORE_COLUMNS_ROOM = [
  ...BULK_STORE_BASE_COLUMNS,
  '테마명','장르','난이도','최소인원','최대인원','소요시간(분)','시작시간','준비시간(분)','종료시간','인원별가격','설명',
];
const BULK_STORE_COLUMNS_SHOW = [
  ...BULK_STORE_BASE_COLUMNS,
  '테마명','장르','활동성','정원','좌석형태','최소인원','최대인원','소요시간(분)','시작시간','준비시간(분)','종료시간','1인당가격','설명','유의사항','환불정책',
];

// 78차 37차: 일괄 등록 템플릿 다운로드 버튼용 예시 데이터 — 한 매장이 지점 2개(강남점/홍대점),
// 다른 매장이 지점 1개를 갖는 예시로 "같은 사업자명+이메일 행은 자동으로 한 매장으로 묶인다"는
// 규칙을 실제 값으로 보여줌.
const BULK_STORE_TEMPLATE_ROWS_ROOM = [
  { '사업자명':'(주)이스케이프코리아','이메일':'owner1@example.com','연락처':'02-1234-5678','담당자명':'김담당','사업자등록번호':'123-45-67890','로그인ID':'escapekorea1','플랜':'standard','매장관리자기능':'O','납부일':15,'계약시작일':'2026-07-01','계약종료일':'2027-06-30','예약URL':'','지점명':'강남점','시/도':'서울','구/군':'강남','상세주소':'테헤란로 123 2층','테마명':'탈출: 봉인된 서재','장르':'미스터리','난이도':3,'최소인원':2,'최대인원':4,'소요시간(분)':60,'시작시간':'12:00','준비시간(분)':10,'종료시간':'22:00','인원별가격':'2인:22000;3인:24000;4인:26000','설명':'고서점 안에 숨겨진 비밀을 풀어라' },
  { '사업자명':'(주)이스케이프코리아','이메일':'owner1@example.com','연락처':'02-1234-5678','담당자명':'김담당','사업자등록번호':'123-45-67890','로그인ID':'escapekorea1','플랜':'standard','매장관리자기능':'O','납부일':15,'계약시작일':'2026-07-01','계약종료일':'2027-06-30','예약URL':'','지점명':'강남점','시/도':'서울','구/군':'강남','상세주소':'테헤란로 123 2층','테마명':'심해 연구소 SOS','장르':'SF','난이도':4,'최소인원':3,'최대인원':6,'소요시간(분)':70,'시작시간':'12:15','준비시간(분)':20,'종료시간':'22:00','인원별가격':'3인:28000;4인:30000;5인:32000;6인:34000','설명':'침수 직전의 연구소를 탈출하라' },
  { '사업자명':'(주)이스케이프코리아','이메일':'owner1@example.com','연락처':'02-1234-5678','담당자명':'김담당','사업자등록번호':'123-45-67890','로그인ID':'escapekorea1','플랜':'standard','매장관리자기능':'O','납부일':15,'계약시작일':'2026-07-01','계약종료일':'2027-06-30','예약URL':'','지점명':'홍대점','시/도':'서울','구/군':'마포','상세주소':'와우산로 45 3층','테마명':'유령 저택의 비밀','장르':'공포','난이도':5,'최소인원':2,'최대인원':5,'소요시간(분)':60,'시작시간':'12:00','준비시간(분)':10,'종료시간':'22:00','인원별가격':'2인:27000;3인:27000;4인:29000;5인:31000','설명':'한밤중 저택에서 살아 나가라' },
  { '사업자명':'넘버원방탈출','이메일':'owner2@example.com','연락처':'031-987-6543','담당자명':'김담당','사업자등록번호':'123-45-67890','로그인ID':'numberone1','플랜':'standard','매장관리자기능':'X','납부일':1,'계약시작일':'2026-08-01','계약종료일':'2027-07-31','예약URL':'https://example-booking.com/reserve','지점명':'분당점','시/도':'경기','구/군':'성남','상세주소':'판교로 100 1층','테마명':'타임머신 오작동','장르':'SF','난이도':1,'최소인원':2,'최대인원':4,'소요시간(분)':50,'시작시간':'12:00','준비시간(분)':10,'종료시간':'22:00','인원별가격':'2인:22000;3인:22000;4인:24000','설명':'고장난 타임머신을 고쳐 현재로 돌아가라' },
];
// 80차 후속: 체험형 공연 시트 예시 — 1번 시트(방탈출)와 동일한 매장/지점 컬럼 구조를
// 그대로 따르되, 테마 컬럼만 체험형 전용(활동성/정원/1인당가격/유의사항/환불정책)으로 구성.
const BULK_STORE_TEMPLATE_ROWS_SHOW = [
  { '사업자명':'미스터리씨어터','이메일':'owner3@example.com','연락처':'02-555-1234','담당자명':'박담당','사업자등록번호':'123-45-67891','로그인ID':'mysterytheater1','플랜':'standard','매장관리자기능':'O','납부일':10,'계약시작일':'2026-08-01','계약종료일':'2027-07-31','예약URL':'','지점명':'홍대점','시/도':'서울','구/군':'마포','상세주소':'와우산로 100 4층','테마명':'인형의 저주','장르':'공포','활동성':4,'정원':20,'좌석형태':'합석','최소인원':1,'최대인원':4,'소요시간(분)':50,'시작시간':'14:00','준비시간(분)':10,'종료시간':'22:00','1인당가격':120000,'설명':'배우가 함께하는 체험형 공포 공연입니다.','유의사항':'공연 시작 10분 전까지 도착해주세요.\n최소 2인 이상 모이지 않으면 공연이 취소될 수 있습니다.','환불정책':'공연 3일 전까지 취소 시 전액 환불됩니다. 이후 취소·노쇼 시 환불이 제한될 수 있습니다.' },
  { '사업자명':'미스터리씨어터','이메일':'owner3@example.com','연락처':'02-555-1234','담당자명':'박담당','사업자등록번호':'123-45-67891','로그인ID':'mysterytheater1','플랜':'standard','매장관리자기능':'O','납부일':10,'계약시작일':'2026-08-01','계약종료일':'2027-07-31','예약URL':'','지점명':'홍대점','시/도':'서울','구/군':'마포','상세주소':'와우산로 100 4층','테마명':'탐정 아카데미','장르':'추리','활동성':2,'정원':30,'좌석형태':'단독','최소인원':1,'최대인원':6,'소요시간(분)':60,'시작시간':'12:00','준비시간(분)':10,'종료시간':'22:00','1인당가격':98000,'설명':'관객이 직접 단서를 추리하는 참여형 공연입니다.','유의사항':'공연 시작 10분 전까지 도착해주세요.','환불정책':'공연 3일 전까지 취소 시 전액 환불됩니다.' },
];

// 78차 44차: 무료 xlsx 라이브러리는 엑셀 드롭다운(데이터 유효성 검사)을 쓸 수 없어서
// (SheetJS 커뮤니티 버전은 dataValidations 작성을 지원 안 함 — Pro 전용 기능) 대신
// 별도 시트에 실제로 쓰이는 값 목록을 그대로 적어 참고하도록 함.
const buildReferenceSheet = () => {
  const rows = [];
  rows.push(['컬럼', '사용 가능한 값']);
  rows.push(['플랜', PLAN_TIERS.join(' / ')]);
  rows.push(['매장관리자기능', 'O(예약관리·통계·정산 애드온 켜기) / 비워두면 X(꺼짐, 기본값)']);
  rows.push(['난이도 (방탈출 시트)', '1~5 숫자 권장(1~2=쉬움, 3=보통, 4=어려움, 5=전문가) — 또는 쉬움/보통/어려움/전문가 텍스트도 가능']);
  rows.push(['활동성 (체험형 시트)', '1~5 숫자 권장(1~2=여유로움, 3=보통, 4=활동적, 5=격렬함) — 또는 여유로움/보통/활동적/격렬함 텍스트도 가능']);
  rows.push(['장르', GENRES.join(' / ') + ' (2개까지 가능, 예: "공포/추리")']);
  rows.push(['시/도', REGIONS.join(' / ')]);
  Object.entries(SUB_REGIONS).forEach(([city, list]) => rows.push([`구/군 (${city})`, list.join(' / ')]));
  rows.push(['', '']);
  rows.push(['인원별가격 (방탈출 시트)', '"2인:22000;3인:24000;4인:26000" 처럼 세미콜론(;)으로 구분. 필수 — 비워두면 그 테마는 가격 없이 등록됨.']);
  rows.push(['1인당가격 (체험형 시트)', '숫자 하나만 입력(예: 120000) — 인원수만큼 자동으로 곱해 청구됩니다.']);
  rows.push(['정원 (체험형 시트)', '회차당 총 정원(숫자), 필수 — 비워두면 0으로 등록돼 실제 예약을 받을 수 없어요.']);
  rows.push(['좌석형태 (체험형 시트)', '합석 / 단독 — 선택 입력, 비워두면 "합석"(다른 팀과 함께 관람)으로 등록됩니다. "단독"은 우리 팀이 회차를 통째로 대관하는 경우.']);
  rows.push(['유의사항 (체험형 시트)', '선택 입력. 여러 줄로 적으려면 셀 안에서 Alt+Enter(줄바꿈)로 구분하세요.']);
  rows.push(['환불정책 (체험형 시트)', '선택 입력, 한 문단으로 작성하세요.']);
  // 할인율은 매장별로 총괄관리자가 개별 협의하는 재량 사항이라 구체적인 수치는
  // 이런 참고용 문서에 적어두지 않음(사용자 지시) — 등급별 기본값이 있다는 사실만 안내.
  rows.push(['할인율(%)', '플랜 구독료 할인율(0~100). 비워두면 등급별 최초계약 기본값이 자동 적용됩니다.']);
  rows.push(['시작시간', '"12:00" 형식(24시간제) — 테마(행)별로 다르게 지정 가능(방마다 첫 회차 시간이 다를 수 있음). 비워두면 매장 공통 시작시간(같은 매장의 첫 행 기준, 그마저 없으면 09:00) 사용.']);
  rows.push(['종료시간', '"22:00" 형식 — 매장 전체 공통 값(같은 매장의 첫 행 기준). 비워두면 22:00.']);
  rows.push(['준비시간(분)', '테마(행)별 회차 사이 청소/세팅 시간. 비워두면 0(플레이시간만큼만 간격). 예약 간격 = 소요시간(분) + 준비시간(분).']);
  rows.push(['사업자등록번호', '선택 입력, 정산·세금계산서 참고용. 같은 매장의 첫 행 기준으로 한 번만 적용됨.']);
  rows.push(['직원계정ID', '선택 입력 — 채워두면 로그인ID(사장님, 전체 권한) 외에 매출·통계가 보이는 "매장관리" 탭이 빠진 직원용 제한 계정을 추가로 발급. 같은 매장의 첫 행 기준으로 한 번만 적용됨.']);
  rows.push(['', '']);
  rows.push(['시트 안내', '같은 사업자명+이메일+지점명이면 "방탈출 등록"/"체험형 등록" 두 시트에 나눠 적어도 한 매장·한 지점으로 합쳐서 등록됩니다.']);
  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws['!cols'] = [{ wch: 20 }, { wch: 80 }];
  return ws;
};

const downloadBulkStoreTemplate = async () => {
  const wsRoom = XLSX.utils.json_to_sheet(BULK_STORE_TEMPLATE_ROWS_ROOM, { header: BULK_STORE_COLUMNS_ROOM });
  wsRoom['!cols'] = BULK_STORE_COLUMNS_ROOM.map(c => ({ wch: Math.max(10, c.length + 2) }));
  const wsShow = XLSX.utils.json_to_sheet(BULK_STORE_TEMPLATE_ROWS_SHOW, { header: BULK_STORE_COLUMNS_SHOW });
  wsShow['!cols'] = BULK_STORE_COLUMNS_SHOW.map(c => ({ wch: Math.max(10, c.length + 2) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, wsRoom, '방탈출 등록');
  XLSX.utils.book_append_sheet(wb, wsShow, '체험형 등록');
  XLSX.utils.book_append_sheet(wb, buildReferenceSheet(), '선택값 안내');
  const bytes = new Uint8Array(XLSX.write(wb, { type: 'array', bookType: 'xlsx' }));
  await saveAndShareXlsx(bytes, '매장_일괄등록_템플릿.xlsx');
};

function BulkStoreImportTab({ onComplete }) {
  const [groups,       setGroups]       = useState([]); // 매장 단위로 그룹핑된 결과
  const [parseErrors,  setParseErrors]  = useState([]);
  const [processing,   setProcessing]  = useState(false);
  const [results,      setResults]      = useState(null); // {succeeded:[], failed:[]}

  const handlePickFile = async () => {
    try {
      const result = await DocumentPicker.getDocumentAsync({
        type: [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'text/csv',
        ],
        copyToCacheDirectory: true,
      });
      if (result.canceled || !result.assets?.[0]) return;

      const bytes = await readPickedFileBytes(result.assets[0]);
      const workbook = XLSX.read(bytes, { type: 'array' });
      // 80차 후속: 방탈출/체험형 두 시트로 분리 — 시트명으로 우선 찾고(템플릿 그대로 쓴
      // 경우), 없으면 순서(0번째=방탈출, 1번째=체험형)로 폴백(사용자가 시트명을 바꾼 경우 대비)
      const sheetRoom = workbook.Sheets['방탈출 등록'] || workbook.Sheets[workbook.SheetNames[0]];
      const sheetShow = workbook.Sheets['체험형 등록'] || workbook.Sheets[workbook.SheetNames[1]];
      const roomRows = sheetRoom ? XLSX.utils.sheet_to_json(sheetRoom, { defval: '' }) : [];
      const showRows = sheetShow ? XLSX.utils.sheet_to_json(sheetShow, { defval: '' }) : [];

      const errs = [];
      const byStore = new Map(); // key: 사업자명|이메일

      // 80차 후속: 두 시트가 공유하는 매장/지점 보장 로직을 하나로 추출 — 같은
      // 사업자명+이메일+지점명이면 어느 시트에서 왔든 같은 지점(themes 배열)으로 합쳐진다.
      const ensureBranch = (row, rowLabel) => {
        const ownerName = String(row['사업자명'] || '').trim();
        const email      = String(row['이메일'] || '').trim();
        const loginId    = String(row['로그인ID'] || '').trim();
        const branchName = String(row['지점명'] || '').trim();
        if (!ownerName || !email || !loginId || !branchName) {
          errs.push(`${rowLabel}: 사업자명/이메일/로그인ID/지점명 중 빠진 값이 있어 건너뛰었어요.`);
          return null;
        }
        const storeKey = `${ownerName}|${email}`;
        if (!byStore.has(storeKey)) {
          byStore.set(storeKey, {
            ownerName, email,
            contact: String(row['연락처'] || '').trim(),
            contactName: String(row['담당자명'] || '').trim(), // 78차 52차
            businessRegNumber: String(row['사업자등록번호'] || '').trim(), // 78차 54차
            loginId,
            staffLoginId: String(row['직원계정ID'] || '').trim(), // 78차 71차
            reservationUrl: String(row['예약URL'] || '').trim(),
            // 78차 57차: 종료시간만 매장 공통(첫 행 값 기준) 유지 — 시작시간은 테마(행)마다
            // 다를 수 있어(방마다 첫 회차가 다름) 아래 테마별 push에서 각자 처리.
            // 여기 startTime은 테마가 시작시간을 안 적었을 때의 매장 공통 기본값 역할만 함.
            startTime: parseExcelTimeCell(row['시작시간']) || '09:00',
            endTime: parseExcelTimeCell(row['종료시간']) || '22:00',
            branchesByName: new Map(),
          });
        }
        const store = byStore.get(storeKey);
        if (!store.branchesByName.has(branchName)) {
          // 78차 44차: 시/도·구/군 오타·표기차 보정(matchInList) — REGIONS/SUB_REGIONS는
          // 필터·검색 등 다른 화면에서도 그대로 쓰이는 값이라 정확히 맞춰둬야 함
          const city = matchInList(row['시/도'], REGIONS, '기타');
          // 78차 62차: plan/납부일/할인율/계약기간을 "사업자 그룹" 최초 1회가 아니라
          // "이 지점" 최초 1회 기준으로 저장 — 같은 사업자(예: "솔버")의 지점끼리도
          // 서로 다른 플랜/계약조건으로 계약하는 경우가 실제로 있어서(예: 1호점 PREMIUM,
          // 2호점 STANDARD), 기존엔 사업자 그룹 전체가 첫 행 값 하나만 쓰고 있어
          // 나머지 지점의 값이 조용히 무시되고 있었음(실사용자 신고로 발견).
          store.branchesByName.set(branchName, {
            branchName,
            city,
            district: matchInList(row['구/군'], SUB_REGIONS[city] || [], String(row['구/군'] || '').trim()),
            addressDetail: String(row['상세주소'] || '').trim(),
            plan: PLAN_TIERS.includes(row['플랜']) ? row['플랜'] : 'standard',
            // 80차 후속: 매장관리자 기능(예약관리·통계·정산) 애드온 — "O"만 켜짐으로 인정,
            // 비어있거나 다른 값이면 기본 꺼짐(자체 예약 시스템이 있는 대형 매장이 일괄
            // 등록되는 경우가 많을 것으로 예상해 보수적으로 기본값을 꺼짐으로 둠).
            opsAddon: String(row['매장관리자기능'] || '').trim().toUpperCase() === 'O',
            paymentDay: Number(row['납부일']) || null,
            // 78차 64차: 미기입 시 최초계약 할인 정책(등급별 기본값, PLAN_DEFAULT_DISCOUNT_RATE)
            // 으로 처리 — 구체적 수치는 매장별 개별 협의 재량이라 여기 적지 않음(사용자 지시).
            planDiscountRate: row['할인율(%)'] !== undefined && row['할인율(%)'] !== ''
              ? Math.min(100, Math.max(0, Number(row['할인율(%)']) || 0))
              : PLAN_DEFAULT_DISCOUNT_RATE[PLAN_TIERS.includes(row['플랜']) ? row['플랜'] : 'standard'],
            contractStart: String(row['계약시작일'] || '').trim() || today10(),
            contractEnd: String(row['계약종료일'] || '').trim() || localAddDaysStr(365),
            themes: [],
          });
        }
        return { store, branch: store.branchesByName.get(branchName) };
      };

      roomRows.forEach((row, i) => {
        const themeName = String(row['테마명'] || '').trim();
        if (!themeName) { errs.push(`방탈출 시트 ${i + 2}행: 테마명이 없어 건너뛰었어요.`); return; }
        const ctx = ensureBranch(row, `방탈출 시트 ${i + 2}행`);
        if (!ctx) return;
        const { store, branch } = ctx;
        const maxPeople = Number(row['최대인원']) || 6;
        const duration = Number(row['소요시간(분)']) || 60;
        // 78차 57차: 이 행(테마)이 시작시간을 적었으면 그걸, 안 적었으면 매장 공통 기본값 사용.
        // 준비시간(분) 신규 — 예약 간격 = 소요시간(분) + 준비시간(분)(회차 사이 청소/세팅 시간).
        const themeStartTime = parseExcelTimeCell(row['시작시간']);
        const prepMinutes = Number(row['준비시간(분)']) || 0;
        const interval = duration + prepMinutes;
        branch.themes.push({
          name: themeName,
          // 78차 45차: "공포/추리"처럼 2개 이어붙여 입력할 수 있어 "/"로 나눠 각각 보정 후 재조합
          genre: String(row['장르'] || '').split('/').map(g => matchInList(g, GENRES, '기타')).filter(Boolean).slice(0, 2).join('/') || '기타',
          difficulty: normalizeDifficulty(row['난이도']),
          minPeople: Number(row['최소인원']) || 2,
          maxPeople,
          duration,
          description: String(row['설명'] || '').trim(),
          pricing: parsePricingField(row),
          imageUrl: '', // 78차 61차: 일괄등록에서 이미지URL 컬럼 삭제 — 필요하면 등록 후 매장 수정에서 업로드
          startTime: themeStartTime, // 비어있으면 매장 공통(store.startTime) 사용
          prepMinutes,
          intervalMinutes: interval,
          availableTimes: generateBulkSlots(themeStartTime || store.startTime, store.endTime, interval),
        });
      });

      // 80차 후속: 체험형 시트 — 활동성/정원/1인당가격/유의사항/환불정책 전용 파싱.
      // pricing 배열은 예약 흐름(reserveShowSlotCF 등)이 그대로 참조하므로 여기서도
      // computeShowPricing으로 미리 계산해 저장(EditStore 저장 로직과 동일한 헬퍼 재사용).
      showRows.forEach((row, i) => {
        const themeName = String(row['테마명'] || '').trim();
        if (!themeName) { errs.push(`체험형 시트 ${i + 2}행: 테마명이 없어 건너뛰었어요.`); return; }
        const ctx = ensureBranch(row, `체험형 시트 ${i + 2}행`);
        if (!ctx) return;
        const { store, branch } = ctx;
        const minPeople = Number(row['최소인원']) || 1;
        const maxPeople = Number(row['최대인원']) || minPeople;
        const duration = Number(row['소요시간(분)']) || 60;
        const themeStartTime = parseExcelTimeCell(row['시작시간']);
        const prepMinutes = Number(row['준비시간(분)']) || 0;
        const interval = duration + prepMinutes;
        const pricePerPerson = Number(row['1인당가격']) || 0;
        branch.themes.push({
          name: themeName,
          genre: String(row['장르'] || '').split('/').map(g => matchInList(g, GENRES, '기타')).filter(Boolean).slice(0, 2).join('/') || '기타',
          bookingFormat: 'show',
          activityLevel: normalizeActivity(row['활동성']),
          capacity: Number(row['정원']) || 0,
          seatingType: normalizeSeatingType(row['좌석형태']),
          pricePerPerson,
          pricing: computeShowPricing(minPeople, maxPeople, pricePerPerson),
          notices: String(row['유의사항'] || '').trim(),
          refundPolicy: String(row['환불정책'] || '').trim(),
          minPeople,
          maxPeople,
          duration,
          description: String(row['설명'] || '').trim(),
          imageUrl: '',
          startTime: themeStartTime,
          prepMinutes,
          intervalMinutes: interval,
          availableTimes: generateBulkSlots(themeStartTime || store.startTime, store.endTime, interval),
        });
      });

      const parsedGroups = Array.from(byStore.values()).map(store => ({
        ...store,
        branches: Array.from(store.branchesByName.values()),
      }));
      if (!parsedGroups.length && !errs.length) {
        errs.push('읽을 수 있는 행이 없어요. "방탈출 등록"/"체험형 등록" 시트에 필수 컬럼이 채워져 있는지 확인해주세요.');
      }
      setGroups(parsedGroups);
      setParseErrors(errs);
      setResults(null);
    } catch (e) {
      showAlert('파일을 읽지 못했어요', e.message || '엑셀(.xlsx) 또는 CSV 파일인지 확인해주세요.');
    }
  };

  const handleConfirm = async () => {
    if (!groups.length) { showAlert('알림', '등록할 매장이 없어요.'); return; }
    setProcessing(true);
    const succeeded = [];
    const failed = [];
    for (const group of groups) {
      try {
        // 78차 70차: 이미 등록된 매장과 이메일/사업자등록번호가 같으면 이 매장만 건너뛰고
        // (부분 실패 허용, 나머지 그룹은 계속 진행) failed 목록에 사유와 함께 기록.
        const dupReason = await checkDuplicateStore({ email: group.email, businessRegNumber: group.businessRegNumber });
        if (dupReason) { failed.push({ ownerName: group.ownerName, error: dupReason }); continue; }

        const now = new Date();
        // 78차 62차: plan/납부일/할인율/계약기간은 이제 지점(branch)마다 따로 저장(위 파싱
        // 단계에서 지점별로 채움) — branches 배열엔 그대로 실어 보내고, store 최상위 필드는
        // "첫 지점" 값으로 채워 레거시/서버(functions/index.js) 등 아직 지점 단위를 모르는
        // 코드가 있어도 undefined 대신 안전한 대표값을 읽도록 유지(하위호환 폴백).
        const branches = group.branches.map(
          ({ branchName, city, district, addressDetail, themes, plan, opsAddon, paymentDay, planDiscountRate, contractStart, contractEnd }) =>
          ({ branchName, city, district, addressDetail, themes, plan, opsAddon, paymentDay, planDiscountRate, contractStart, contractEnd })
        );
        const primary = group.branches[0] || {};
        const storeRef = await addDoc(collection(db, 'stores'), {
          ownerName: group.ownerName, email: group.email, contact: group.contact, contactName: group.contactName,
          businessRegNumber: group.businessRegNumber,
          // 78차 44차: 매출 연동 수수료(feeType/discountRate/fixedFee) 없이 플랜 구독료만
          // 받기로 확정 — 아예 안 넣으면 calcStoreFee가 revenue*0/100=0으로 자동 처리됨
          paymentDay: primary.paymentDay, contractStart: primary.contractStart, contractEnd: primary.contractEnd,
          planDiscountRate: primary.planDiscountRate,
          startTime: group.startTime, endTime: group.endTime,
          paymentType: group.reservationUrl ? 'external' : 'internal', reservationUrl: group.reservationUrl,
          branches, status: 'active', plan: primary.plan, opsAddon: primary.opsAddon, createdAt: now.toISOString(),
          // 78차 62차: 일괄등록 직후엔 이미지/가격 등 추가 설정이 안 된 상태로 바로 전체
          // 노출되는 게 위험하다는 요청 — 총괄관리자가 확인 후 직접 복구(활성화)하기 전까지
          // 기본 비활성 상태로 생성.
          isDeleted: true,
        });
        try {
          const cf = httpsCallable(functions, 'createStoreAdminAccountCF');
          const { data } = await cf({ loginId: group.loginId, storeId: storeRef.id, storeName: group.ownerName });
          // 78차 71차: "직원계정ID" 컬럼이 채워져 있으면 사장님 계정에 이어 직원용
          // 제한 계정도 발급 — 실패해도 사장님 계정은 이미 만들어졌으니 전체를 실패로
          // 처리하지 않고 staff.error로만 남김.
          let staff = null;
          if (group.staffLoginId) {
            try {
              const staffRes = await cf({ loginId: group.staffLoginId, storeId: storeRef.id, storeName: group.ownerName, tier: 'staff' });
              staff = { loginId: staffRes.data.loginId, tempPassword: staffRes.data.tempPassword };
            } catch (staffErr) {
              staff = { error: staffErr.message };
            }
          }
          succeeded.push({ ownerName: group.ownerName, loginId: data.loginId, tempPassword: data.tempPassword, staff });
        } catch (accErr) {
          // 매장은 이미 생성됨 — 계정만 실패로 기록(부분 실패 허용, 전체 롤백 안 함)
          succeeded.push({ ownerName: group.ownerName, loginId: null, tempPassword: null, accountError: accErr.message });
        }
      } catch (storeErr) {
        failed.push({ ownerName: group.ownerName, error: storeErr.message });
      }
    }
    if (succeeded.length > 0) invalidateStoreCache();
    setResults({ succeeded, failed });
    setGroups([]); setParseErrors([]);
    setProcessing(false);
    onComplete();
  };

  if (results) {
    return (
      <View>
        <IconLabel Icon={CheckmarkIcon} size={13} color={C.gold} textStyle={s.sectionTitle}>일괄 등록 결과</IconLabel>
        <Text style={[s.muted,{marginBottom:16}]}>
          이 화면을 벗어나면 임시 비밀번호를 다시 확인할 수 없어요. 지금 각 매장에 전달해주세요.
        </Text>
        {/* 78차 62차: 일괄등록 매장은 기본 비활성 상태로 생성됨 — 이미지/가격 등 추가 확인 후
            매장관리 탭에서 "🔓 복구"로 직접 노출해야 함을 안내 */}
        <IconLabel Icon={WarningIcon} size={13} color={C.warning} textStyle={[s.muted,{color:C.warning}]} style={{marginBottom:16}}>
          등록된 매장은 안전을 위해 기본적으로 비활성 상태예요. 이미지·가격 등을 확인한 뒤
          매장관리 탭에서 "🔓 매장 복구"를 눌러야 고객 앱에 노출됩니다.
        </IconLabel>
        {results.succeeded.map((r,i)=>(
          <View key={i} style={[s.card,{marginBottom:10}]}>
            <Text style={s.drillName}>{r.ownerName}</Text>
            {r.loginId ? (
              <>
                <Text style={[s.muted,{marginTop:6}]}>로그인 ID</Text>
                <TextInput style={s.input} value={r.loginId} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
                <Text style={[s.muted,{marginTop:6}]}>임시 비밀번호</Text>
                <TextInput style={s.input} value={r.tempPassword} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
              </>
            ) : (
              <Text style={{color:C.danger,fontSize:12,marginTop:6}}>매장은 등록됐지만 계정 발급 실패: {r.accountError}</Text>
            )}
            {/* 78차 71차: "직원계정ID" 컬럼으로 함께 발급한 직원용 제한 계정 */}
            {r.staff && !r.staff.error && (
              <>
                <Text style={{color:C.gold,fontSize:11,fontWeight:'700',marginTop:14,marginBottom:2}}>🧑‍💼 직원용 제한 계정</Text>
                <Text style={[s.muted,{marginTop:4}]}>로그인 ID</Text>
                <TextInput style={s.input} value={r.staff.loginId} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
                <Text style={[s.muted,{marginTop:6}]}>임시 비밀번호</Text>
                <TextInput style={s.input} value={r.staff.tempPassword} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
              </>
            )}
            {r.staff?.error && (
              <IconLabel Icon={WarningIcon} size={12} color={C.danger} textStyle={{color:C.danger,fontSize:12}} style={{marginTop:8}}>직원용 계정 발급 실패: {r.staff.error}</IconLabel>
            )}
          </View>
        ))}
        {results.failed.map((r,i)=>(
          <View key={i} style={[s.card,{marginBottom:10,borderColor:C.danger}]}>
            <Text style={s.drillName}>{r.ownerName}</Text>
            <Text style={{color:C.danger,fontSize:12,marginTop:6}}>등록 실패: {r.error}</Text>
          </View>
        ))}
        <GradientButton label="확인" onPress={()=>setResults(null)} style={{marginTop:8}} textStyle={s.primaryBtnTxt} />
      </View>
    );
  }

  return (
    <View>
      <IconLabel Icon={StatsIcon} size={13} color={C.gold} textStyle={s.sectionTitle}>매장 일괄 등록</IconLabel>
      <Text style={[s.muted,{marginBottom:16}]}>
        엑셀(.xlsx) 파일 안 "방탈출 등록"/"체험형 등록" 두 시트에 한 행 = 테마 하나씩 적어주세요.{'\n'}
        같은 사업자명+이메일+지점명이면 두 시트에 나눠 적어도 한 매장·한 지점으로 자동 합쳐져요.{'\n'}
        방탈출 시트 필수 컬럼: {BULK_STORE_COLUMNS_ROOM.join(', ')}{'\n'}
        체험형 시트 필수 컬럼: {BULK_STORE_COLUMNS_SHOW.join(', ')}{'\n'}
        플랜·시/도·구/군·장르·난이도·활동성에 실제로 쓰이는 값 목록은 템플릿의 "선택값 안내" 시트를 참고하세요.
      </Text>
      <SecondaryButton label="📄 템플릿 다운로드 (예시 포함)" onPress={downloadBulkStoreTemplate} style={{marginBottom:10}} />
      <GradientButton label="📁 파일 선택" onPress={handlePickFile} style={{marginBottom:16}} textStyle={s.primaryBtnTxt} />

      {parseErrors.length > 0 && (
        <View style={[s.card,{borderColor:C.danger,marginBottom:14}]}>
          <IconLabel Icon={WarningIcon} size={13} color={C.danger} textStyle={{color:C.danger,fontWeight:'700'}} style={{marginBottom:6}}>건너뛴 행</IconLabel>
          {parseErrors.map((e,i)=><Text key={i} style={[s.muted,{fontSize:12}]}>{e}</Text>)}
        </View>
      )}

      {groups.length > 0 && (
        <>
          <Text style={s.sectionTitle}>미리보기 ({groups.length}개 매장)</Text>
          {groups.map((g,i)=>{
            const themeCount = g.branches.reduce((a,b)=>a+b.themes.length,0);
            return (
              <View key={i} style={[s.card,{marginBottom:10}]}>
                <Text style={s.drillName}>{g.ownerName}</Text>
                <Text style={s.muted}>ID: {g.loginId} · 플랜: {PLAN_LABELS[g.plan]} · 지점 {g.branches.length}개 · 테마 {themeCount}개</Text>
              </View>
            );
          })}
          <GradientButton
            label={processing ? '등록 중...' : '일괄 등록 실행'}
            onPress={handleConfirm}
            disabled={processing}
            style={{marginTop:8}}
            textStyle={s.primaryBtnTxt}
          />
        </>
      )}
    </View>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 78차 70차: 일반 계정(직원용) 등록 — 매장 신규등록 없이, 이미 있는 매장에 매출·통계가
// 안 보이는 직원용 제한 계정만 단독으로 추가 발급. 새 매장 등록 폼의 체크박스는
// "사장님 계정+직원 계정"을 한 번에 만드는 것이라, 일괄등록으로 만든 매장이나 이미
// 사장님 계정만 있는 기존 매장에 나중에 직원 계정을 추가하려면 이 화면이 필요함.
// ══════════════════════════════════════════════════════════════════════════════
function StaffAccountTab({ stores, onComplete }) {
  const [search, setSearch] = useState('');
  const [selectedStore, setSelectedStore] = useState(null);
  const [loginId, setLoginId] = useState('');
  const [saving, setSaving] = useState(false);
  const [issued, setIssued] = useState(null); // {loginId, tempPassword}

  const activeStores = stores.filter(st => st.isDeleted !== true);
  const filteredStores = search.trim()
    ? activeStores.filter(st => (st.ownerName || '').toLowerCase().includes(search.trim().toLowerCase()))
    : activeStores;

  const handleIssue = async () => {
    if (!selectedStore) return showAlert('알림', '매장을 먼저 선택해주세요.');
    if (!loginId || !/^[A-Za-z0-9_]{4,}$/.test(loginId))
      return showAlert('알림', '로그인 ID는 영문/숫자/밑줄 4자 이상이어야 해요.');
    setSaving(true);
    try {
      const cf = httpsCallable(functions, 'createStoreAdminAccountCF');
      const { data } = await cf({ loginId, storeId: selectedStore.id, storeName: selectedStore.ownerName, tier: 'staff' });
      setIssued(data);
      setLoginId('');
      setSelectedStore(null);
    } catch (e) {
      showAlert('오류', '계정 발급 실패: ' + e.message);
    } finally { setSaving(false); }
  };

  if (issued) {
    return (
      <View>
        <IconLabel Icon={CheckmarkIcon} size={13} color={C.gold} textStyle={s.sectionTitle}>계정 발급 완료</IconLabel>
        <Text style={[s.muted, { marginBottom: 16 }]}>이 비밀번호는 다시 확인할 수 없어요. 지금 매장에 전달해주세요.</Text>
        <Text style={s.muted}>로그인 ID</Text>
        <TextInput style={s.input} value={issued.loginId} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
        <Text style={[s.muted, { marginTop: 10 }]}>임시 비밀번호</Text>
        <TextInput style={s.input} value={issued.tempPassword} showSoftInputOnFocus={false} onChangeText={() => {}} selectTextOnFocus/>
        <GradientButton label="확인" onPress={() => { setIssued(null); onComplete(); }} style={{ marginTop: 16 }} textStyle={s.primaryBtnTxt} />
      </View>
    );
  }

  return (
    <View>
      <Text style={s.sectionTitle}>일반 계정 등록 (직원용)</Text>
      <Text style={[s.muted, { marginBottom: 16 }]}>
        매출·통계·정산이 보이는 "매장관리" 탭이 빠진 제한 계정을 기존 매장에 추가로 발급해요.
        일괄 등록으로 만든 매장이나, 사장님 계정만 있는 매장에 직원 계정을 나중에 추가할 때 쓰세요.
      </Text>

      <Text style={s.muted}>매장 선택</Text>
      {selectedStore ? (
        <View style={[s.card, { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }]}>
          <Text style={s.drillName}>{selectedStore.ownerName}</Text>
          <TouchableOpacity onPress={() => setSelectedStore(null)}>
            <Text style={{ color: C.muted, fontSize: 12 }}>변경</Text>
          </TouchableOpacity>
        </View>
      ) : (
        <>
          <TextInput style={[s.input, { marginBottom: 8 }]} value={search} onChangeText={setSearch}
            placeholder="매장명 검색" placeholderTextColor={C.muted}/>
          <ScrollView style={{ maxHeight: 220, marginBottom: 14 }}>
            {filteredStores.map(st => (
              <TouchableOpacity key={st.id} style={s.card} onPress={() => setSelectedStore(st)}>
                <Text style={s.drillName}>{st.ownerName || '(매장명 없음)'}</Text>
              </TouchableOpacity>
            ))}
            {filteredStores.length === 0 && <Text style={s.muted}>검색 결과가 없어요.</Text>}
          </ScrollView>
        </>
      )}

      <Text style={[s.muted, { marginTop: 4 }]}>로그인 ID (영문/숫자/밑줄 4자 이상)</Text>
      <TextInput style={s.input} value={loginId} onChangeText={v => setLoginId(v.trim())} placeholder="예: solver_staff1" placeholderTextColor={C.muted}/>

      <GradientButton label={saving ? '발급 중...' : '계정 발급'} onPress={handleIssue} disabled={saving}
        style={{ marginTop: 16 }} textStyle={s.primaryBtnTxt} />
    </View>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 58차: 정산 콤보탭 — 기존 "수수료" + "정산" 두 탭을 현황/수납관리 뷰 전환으로 통합
// ══════════════════════════════════════════════════════════════════════════════
function SettlementComboTab({ stores, reservations, billings, onUpdate }) {
  const [view, setView] = useState('overview'); // 'overview' | 'manage'
  return (
    <View>
      <View style={{flexDirection:'row',gap:8,marginBottom:14}}>
        <TouchableOpacity
          style={[s.viewToggleBtn, view==='overview' && s.viewToggleBtnOn]}
          onPress={()=>setView('overview')}>
          <IconLabel Icon={PriceIcon} size={12} color={view==='overview' ? undefined : C.muted} textStyle={[s.viewToggleTxt, view==='overview' && s.viewToggleTxtOn]}>현황</IconLabel>
        </TouchableOpacity>
        <TouchableOpacity
          style={[s.viewToggleBtn, view==='manage' && s.viewToggleBtnOn]}
          onPress={()=>setView('manage')}>
          <IconLabel Icon={ReceiptIcon} size={12} color={view==='manage' ? undefined : C.muted} textStyle={[s.viewToggleTxt, view==='manage' && s.viewToggleTxtOn]}>수납 관리</IconLabel>
        </TouchableOpacity>
      </View>
      {view==='overview'
        ? <FeeTab stores={stores} reservations={reservations}/>
        : <BillingTab stores={stores} reservations={reservations} billings={billings} onUpdate={onUpdate}/>
      }
    </View>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 수수료 탭
// ══════════════════════════════════════════════════════════════════════════════
function FeeTab({ stores, reservations }) {
  const thisMonth=localThisMonthStr();
  // 78차 52차: cancelled만 걸러내고 paymentStatus:'pending'(결제/입금 확인 전)을 그대로
  // 포함하고 있었음 — SuperAdminScreen GMV/StoreAdminScreen 매출 계산과 다른 기준이라
  // 서로 다른 화면의 "매출"이 어긋나 보이던 원인. 다른 화면과 동일 기준으로 통일.
  const activeRes=reservations.filter(r=>!r.cancelled&&r.paymentStatus!=='pending'&&r.revenueDuplicate!==true); // 78차 44차: 모집 일괄예약 매출 중복집계 방지
  // 78차 52차: success(탈출 성공/실패 결과)는 매출과 무관한데 success===true인 것만
  // 매출로 잡고 있어서, 아직 방문 전이거나 실패로 기록된 예약은 전부 누락되고 있었음.
  const totalRevenue=activeRes.reduce((acc,r)=>acc+(r.price||0),0);
  // 78차 39차: PICK 무제한 등록 — 무료 슬롯 초과분 요금(매장별 개수)을 한 번의 쿼리로
  // 미리 집계해서 아래 매장별 .map() 안에서는 동기적으로 조회만 함(매장마다 쿼리 X).
  const [paidPickCounts, setPaidPickCounts] = useState({});
  // 78차 43차: "오늘 기준 활성"은 이번 달 중 이미 끝난 PICK을 놓쳐 "이번달 수익" 표시가
  // 과소 집계될 수 있었음 — thisMonth와 실제 겹치는 기간으로 판정하도록 교체.
  useEffect(() => { getAllPaidPickCountsForMonth(thisMonth).then(setPaidPickCounts).catch(() => setPaidPickCounts({})); }, [thisMonth]);
  // 79차: [버그 수정] 테마명 매칭만으로 매장별 매출을 걸러내면 서로 다른 매장이 같은
  // 테마명을 쓸 때 매출이 섞임 — storeId가 있으면 그걸로 정확히 매칭, 레거시(storeId
  // 없는) 예약만 테마명 매칭으로 폴백.
  const matchesStore = (r, store, names) => r.storeId ? r.storeId === store.id : names.includes(r.productName);
  // 79차: [버그 수정] names.length(소프트삭제 필터 없음)를 그대로 themeCount로 썼는데,
  // 매출 이름매칭 폴백용 names는 삭제된 테마명도 포함해야 정확하지만(레거시 예약이
  // 그 이름을 참조할 수 있음), 수수료 계산의 themeCount는 BillingTab이 이미 쓰고 있는
  // getStoreThemeCount(store)(isDeleted 필터링됨)와 기준을 맞춰야 함 — 현재는
  // feeType:'fixed'(정액제, themeCount를 실제로 쓰는 유일한 분기)가 어느 매장에도
  // 없어 휴면 상태지만, 두 탭이 같은 매장·같은 달에 서로 다른 테마 개수 기준을 쓰는
  // 구조 자체를 통일(전수 정독으로 발견).
  const totalFee=stores.reduce((sum,store)=>{
    const names=store.branches?.flatMap(b=>b.themes?.map(t=>t.name)||[])||[];
    const rev=activeRes.filter(r=>matchesStore(r,store,names)&&r.date?.startsWith(thisMonth)).reduce((acc,r)=>acc+(r.price||0),0);
    return sum+calcTotalOwed(store,rev,getStoreThemeCount(store),paidPickCounts[store.id]||0);
  },0);
  return (
    <View>
      <View style={[s.card,{borderColor:C.gold,borderWidth:1.5}]}>
        <Text style={[s.sectionTitle,{marginTop:0}]}>이번달 요약</Text>
        <View style={{flexDirection:'row',justifyContent:'space-around'}}>
          {/* 78차 73차: "누적 매출"이 총관리자 본인 매출처럼 보인다는 신고 — 사실은
              전체 매장 매출 합계라 "매장 누적매출"로 명확히 구분 */}
          {[{l:'매장 누적매출',v:krw(totalRevenue),c:C.success},{l:'이번달 수익',v:krw(totalFee),c:C.gold}].map(item=>(
            <View key={item.l} style={{alignItems:'center'}}>
              <Text style={{fontSize:15,fontWeight:'700',color:item.c}}>{item.v}</Text>
              <Text style={s.muted}>{item.l}</Text>
            </View>
          ))}
        </View>
      </View>
      <Text style={s.sectionTitle}>매장별 수수료</Text>
      {stores.length===0?<EmptyState Icon={MenuStoreIcon} text="등록된 매장이 없습니다."/>:
        stores.map(store=>{
          const names=store.branches?.flatMap(b=>b.themes?.map(t=>t.name)||[])||[];
          const rev=activeRes.filter(r=>matchesStore(r,store,names)&&r.date?.startsWith(thisMonth)).reduce((acc,r)=>acc+(r.price||0),0);
          const themeCount=getStoreThemeCount(store);
          const commission=calcStoreFee(store,rev,themeCount);
          const planFee=getPlanFee(store);
          const opsAddonFee=getOpsAddonFee(store);
          const pickAddonFee=getPickAddonFee(paidPickCounts[store.id]||0);
          // 79차: calcTotalOwed()가 정확히 이 세 항목의 합인데 인라인으로 재조립하고
          // 있었음(중복구현) — 캐노니컬 함수로 교체해 나중에 계산식이 바뀌어도 이 지점만
          // 어긋나는 일이 없게 함.
          const fee=calcTotalOwed(store,rev,themeCount,paidPickCounts[store.id]||0);
          // 78차 52차: feeType/discountRate/fixedFee(요율·정액 수수료)는 78차 44차에 이미
          // 삭제된 개념인데 이 탭만 안 고쳐져 있어서 모든 매장이 "수수료 없음"으로만 뜨고
          // 있었음 — 실제로 지금 받는 건 플랜 구독료(할인율 적용)뿐이라 그걸 표시.
          const discountRate = getPlanDiscountRate(store);
          const planPrice = PLAN_PRICES[normalizePlan(store.plan)] || 0;
          const discountAmount = planPrice - planFee;
          const multiBranch = (store.branches||[]).length > 1;
          const getPayDay=()=>{
            if(store.paymentDay) return `매달 ${store.paymentDay}일`;
            if(store.contractStart){const d=new Date(store.contractStart);if(!isNaN(d))return `매달 ${d.getDate()}일 (계약일 기준)`;}
            return '-';
          };
          return (
            <View key={store.id} style={s.card}>
              <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'flex-start',marginBottom:4}}>
                <Text style={s.drillName}>{store.ownerName}</Text>
                <View style={{alignItems:'flex-end'}}>
                  <Text style={[s.muted,{fontSize:11}]}>정산일</Text>
                  <Text style={{color:C.gold,fontWeight:'700',fontSize:13}}>{getPayDay()}</Text>
                </View>
              </View>
              <Text style={[s.muted,{marginBottom:12}]}>
                {multiBranch ? '지점별 상이 (아래 참고)' : PLAN_LABELS[normalizePlan(store.plan)]} · 테마 {names.length}개
              </Text>
              {/* 78차 52차: "구독료" 대신 "할인금액(할인율)" 표기로 변경 — 정가에서 얼마나
                  할인됐는지가 총관리자에게 더 유용한 정보라는 요청 반영 */}
              <View style={{flexDirection:'row',justifyContent:'space-around'}}>
                {[{l:'이달 매출',v:krw(rev),c:C.success},
                  {l:'수수료',v:krw(commission),c:C.warning},
                  {l:multiBranch ? '할인금액' : `할인금액(${discountRate}%)`,v:krw(discountAmount),c:C.info},
                  // 최종 재검증: 합계(calcTotalOwed)는 opsAddonFee를 이미 포함해 계산되고
                  // 있었지만, 이 breakdown 칩엔 PICK 추가처럼 별도 행으로 안 보여줘서
                  // "수수료+할인금액"만 봐서는 합계가 왜 그 값인지 설명이 안 되는 완전성
                  // 누락이었음(금액 자체는 원래도 정확 — 표시만 불완전). PICK 추가와
                  // 동일한 패턴으로 조건부 행 추가.
                  ...(opsAddonFee>0?[{l:'애드온',v:krw(opsAddonFee),c:C.gold}]:[]),
                  ...(pickAddonFee>0?[{l:'PICK 추가',v:krw(pickAddonFee),c:C.gold}]:[]),
                  {l:multiBranch ? '합계(전체)' : '합계',v:krw(fee),c:C.danger}].map(item=>(
                  <View key={item.l} style={{alignItems:'center'}}>
                    <Text style={{fontSize:13,fontWeight:'700',color:item.c}}>{item.v}</Text>
                    <Text style={s.muted}>{item.l}</Text>
                  </View>
                ))}
              </View>
              {/* 78차 63차: 지점이 2개 이상이면 plan/할인율이 지점마다 다를 수 있어
                  위 합계 하나로는 "지점별 금액이 얼마인지" 알 수 없다는 요청 — 지점별로
                  풀어서 보여줌. */}
              {multiBranch && (
                <View style={{marginTop:12,paddingTop:12,borderTopWidth:1,borderTopColor:C.border,gap:8}}>
                  {(store.branches||[]).map((b,bi)=>{
                    // 79차: [버그 수정] 지점별 매출도 테마명 매칭만으로는 다른 매장(또는
                    // 같은 매장의 다른 지점)의 예약이 섞일 수 있었음 — storeId+branchIdx로
                    // 정확히 매칭, 레거시(storeId 없는) 예약만 테마명 매칭으로 폴백.
                    const branchNames = b.themes?.map(t=>t.name)||[];
                    const matchesBranch = r => r.storeId
                      ? (r.storeId === store.id && parseProductId(r.productId)?.branchIdx === bi)
                      : branchNames.includes(r.productName);
                    const branchRev = activeRes.filter(r=>matchesBranch(r)&&r.date?.startsWith(thisMonth)).reduce((acc,r)=>acc+(r.price||0),0);
                    const branchCommission = calcStoreFee(store,branchRev,branchNames.length,bi);
                    const branchPlanFee = getPlanFee(store,bi);
                    // 80차 후속: [버그 수정, 돈 표시 누락] 이 지점별 참고용 금액도 opsAddonFee가
                    // 빠져 있었음(같은 파일 BillingTab의 동일한 지점별 줄은 이미 수정됨) —
                    // 추가. PICK 추가요금은 paidPickCounts가 store.id 기준(지점별로 안 나뉨)이라
                    // 이 줄엔 원래부터 포함 대상 아님(BillingTab과 동일한 기존 관례).
                    const branchOpsAddonFee = getOpsAddonFee(store,bi);
                    const branchDiscountRate = getPlanDiscountRate(store,bi);
                    const branchTotal = branchCommission+branchPlanFee+branchOpsAddonFee;
                    return (
                      <View key={bi} style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                        <Text style={[s.muted,{fontSize:12,flex:1}]} numberOfLines={1}>
                          {b.branchName} · {PLAN_LABELS[normalizePlan(getBranchPlan(store,bi))]}({branchDiscountRate}%)
                        </Text>
                        <Text style={{color:C.text,fontSize:12,fontWeight:'700'}}>{krw(branchTotal)}</Text>
                      </View>
                    );
                  })}
                </View>
              )}
            </View>
          );
        })
      }
    </View>
  );
}

// ══════════════════════════════════════════════════════════════════════════════
// 정산 탭 — 월별 필터 추가
// ══════════════════════════════════════════════════════════════════════════════
function BillingTab({ stores, reservations, billings, onUpdate }) {
  const [selectedStore, setSelectedStore] = useState(null);
  const [memo,          setMemo]          = useState('');
  const [submitting,    setSubmitting]    = useState(false);

  // 최근 6개월 목록
  // 78차: new Date(year,month,1)은 로컬 자정으로 생성되는데, 한국(UTC+9)에서 이걸
  // toISOString()으로 UTC 변환하면 시간대만큼 전날로 밀려서 매번(시간대와 무관하게 항상)
  // 한 달 이른 값이 나오고 있었음 — 생성한 Date 객체에서 로컬 getFullYear/getMonth를
  // 그대로 다시 읽어(UTC 변환 없이) 문자열로 조립하는 걸로 근본 수정.
  const monthOptions = (() => {
    const months = [];
    const d = new Date();
    for (let i = 0; i < 6; i++) {
      const m = new Date(d.getFullYear(), d.getMonth()-i, 1);
      months.push(`${m.getFullYear()}-${String(m.getMonth()+1).padStart(2,'0')}`);
    }
    return months;
  })();
  const [selectedMonth, setSelectedMonth] = useState(monthOptions[0]);

  // 68차: 테마 개수 구간별 고정 금액표(rec)를 쓰던 기존 계산 — FeeTab이 쓰는
  // "매출 × 요율" 계산과 전혀 다른 결과를 냈던 버그. 실제 계약 조건(feeType/
  // discountRate/fixedFee)과 해당 월 실매출을 기반으로 하는 calcStoreFee로 통일.
  const activeRes = (reservations || []).filter(r => !r.cancelled && r.revenueDuplicate !== true); // 78차 44차: 모집 일괄예약 매출 중복집계 방지
  // 78차 39차: PICK 무제한 등록 — 무료 슬롯 초과분 요금을 이 탭의 정산액에도 반영.
  // 78차 43차: "오늘 기준 활성" 개수를 selectedMonth(최근 6개월 중 임의 선택)에도 그대로
  // 쓰고 있어서, 과거 달을 골라 "결제완료" 처리(handleMarkPaid)하면 그 달의 실제
  // PICK 추가요금이 아니라 오늘 시점 활성 개수로 billings 문서를 덮어쓰는 버그였음 —
  // selectedMonth와 실제 겹치는 기간으로 판정하도록 교체.
  const [paidPickCounts, setPaidPickCounts] = useState({});
  useEffect(() => { getAllPaidPickCountsForMonth(selectedMonth).then(setPaidPickCounts).catch(() => setPaidPickCounts({})); }, [selectedMonth]);
  // 76차: 플랜 구독료가 정산에 반영 안 되던 버그 — 수수료+구독료 breakdown을 반환하고,
  // calcMonthlyFee는 총액(.fee)만 반환하는 얇은 래퍼로 유지(기존 호출부 그대로 동작).
  const calcMonthlyBreakdown=(store)=>{
    const themeCount = getStoreThemeCount(store);
    // 79차: [버그 수정] 테마명(자유 입력) 매칭만으로 이 매장의 매출을 걸러내고 있었음 —
    // 서로 다른 매장이 우연히 같은 테마명을 쓰면 한 매장의 실제 청구액(billings에 기록되는
    // 값)에 남의 매장 예약이 섞여 들어갈 수 있는 구조(전수 정독으로 발견). storeId가
    // 있는 예약은 그걸로 정확히 매칭, 레거시(storeId 없는) 예약만 테마명 매칭으로 폴백.
    const names = store.branches?.flatMap(b=>b.themes?.map(t=>t.name)||[])||[];
    const revenue = activeRes
      .filter(r => (r.storeId ? r.storeId === store.id : names.includes(r.productName)) && r.date?.startsWith(selectedMonth))
      .reduce((acc,r)=>acc+(r.price||0),0);
    const commissionFee = calcStoreFee(store, revenue, themeCount);
    const planFee = getPlanFee(store);
    // 80차 후속: [버그 수정, 실제 청구 누락] opsAddonFee(매장관리자 기능 애드온, 월
    // 15,000원)가 이 breakdown에 아예 빠져 있었음 — scheduledMonthlySettlement(서버 자동
    // 정산)는 fee에 opsAddonFee를 포함하는데, 이 화면(수납 관리 BillingTab)만 별도로
    // commissionFee+planFee+pickAddonFee만 더해서 애드온이 켜진 매장은 여기서 "수납
    // 완료" 처리할 때마다 실제 청구액보다 15,000원 적게 기록되고 있었음(billings 문서에
    // 직접 쓰는 handleMarkPaid/handleMarkUnpaid도 이 값을 그대로 저장) — calcTotalOwed와
    // 동일하게 opsAddonFee 포함.
    const opsAddonFee = getOpsAddonFee(store);
    const pickAddonFee = getPickAddonFee(paidPickCounts[store.id]||0);
    return { revenue, commissionFee, planFee, opsAddonFee, pickAddonFee, fee: commissionFee + planFee + opsAddonFee + pickAddonFee };
  };
  const calcMonthlyFee=(store)=>calcMonthlyBreakdown(store).fee;
  const getBilling=(storeId)=>billings.find(b=>b.storeId===storeId&&b.month===selectedMonth);

  const handleMarkPaid=async(store)=>{
    setSubmitting(true);
    try{
      const existing=getBilling(store.id);
      const { commissionFee, planFee, opsAddonFee, pickAddonFee, fee } = calcMonthlyBreakdown(store);
      if(existing){
        await updateDoc(doc(db,'billings',existing.id),{status:'paid',paidAt:new Date().toISOString(),memo:memo||existing.memo||'',fee,commissionFee,planFee,opsAddonFee,pickAddonFee});
      }else{
        await addDoc(collection(db,'billings'),{storeId:store.id,storeName:store.ownerName,month:selectedMonth,fee,commissionFee,planFee,opsAddonFee,pickAddonFee,status:'paid',paidAt:new Date().toISOString(),memo:memo||'',createdAt:new Date().toISOString()});
      }
      setSelectedStore(null);setMemo('');onUpdate();
      showAlert('완료','수납 처리되었습니다.');
    }catch(e){showAlert('오류',e.message);}
    finally{setSubmitting(false);}
  };

  const handleMarkUnpaid=async(store)=>{
    try{
      const { commissionFee, planFee, opsAddonFee, pickAddonFee, fee } = calcMonthlyBreakdown(store);
      const existing=getBilling(store.id);
      if(existing){await updateDoc(doc(db,'billings',existing.id),{status:'unpaid'});}
      else{await addDoc(collection(db,'billings'),{storeId:store.id,storeName:store.ownerName,month:selectedMonth,fee,commissionFee,planFee,opsAddonFee,pickAddonFee,status:'unpaid',createdAt:new Date().toISOString()});}
      onUpdate();
    }catch(e){showAlert('오류',e.message);}
  };

  const totalExpected=stores.reduce((a,st)=>a+calcMonthlyFee(st),0);
  const totalPaid=stores.reduce((a,st)=>{const b=getBilling(st.id);return a+(b?.status==='paid'?calcMonthlyFee(st):0);},0);

  // 75차: 미납 매장 한눈에 보기 — "전체/미납만" 필터 + 미납 매장 이름을 요약 카드에 바로 노출
  const [unpaidOnly, setUnpaidOnly] = useState(false);
  const unpaidStores = stores.filter(st => getBilling(st.id)?.status !== 'paid');
  const visibleStores = unpaidOnly ? unpaidStores : stores;

  return (
    <View>
      <IconLabel Icon={ReceiptIcon} size={13} color={C.gold} textStyle={s.sectionTitle}>정산 관리</IconLabel>

      {/* 월 선택 필터 */}
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{marginBottom:14}}>
        <View style={{flexDirection:'row',gap:8}}>
          {monthOptions.map(m=>(
            <TouchableOpacity key={m}
              style={[s.chip, selectedMonth===m&&s.chipOn]}
              onPress={()=>setSelectedMonth(m)}>
              <Text style={[s.chipTxt, selectedMonth===m&&s.chipTxtOn]}>{m}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>

      {/* 요약 */}
      <View style={[s.card,{borderColor:C.gold,borderWidth:1.5,marginBottom:16}]}>
        <Text style={[s.muted,{textAlign:'center',marginBottom:10,fontWeight:'700',color:C.gold}]}>
          {selectedMonth} 정산 현황
        </Text>
        <View style={{flexDirection:'row',justifyContent:'space-around'}}>
          {/* 76차: "예상 수수료" → "예상 납부액"으로 문구 수정 — 이제 구독료도 포함된 총액이므로 */}
          {[{l:'예상 납부액',v:`${totalExpected.toLocaleString()}원`,c:C.gold},{l:'수납',v:`${totalPaid.toLocaleString()}원`,c:C.success},{l:'미수납',v:`${(totalExpected-totalPaid).toLocaleString()}원`,c:C.danger}].map(item=>(
            <View key={item.l} style={{alignItems:'center'}}>
              <Text style={{fontSize:13,fontWeight:'800',color:item.c}}>{item.v}</Text>
              <Text style={s.muted}>{item.l}</Text>
            </View>
          ))}
        </View>
        {/* 75차: 미납 매장을 한눈에 — 요약 카드에 이름까지 바로 노출 */}
        {unpaidStores.length > 0 && (
          <View style={{marginTop:12,paddingTop:12,borderTopWidth:1,borderTopColor:C.border}}>
            <IconLabel Icon={WarningIcon} size={12} color={C.danger} textStyle={{color:C.danger,fontSize:12,fontWeight:'700'}}>
              미납 매장 {unpaidStores.length}곳: {unpaidStores.map(st=>st.ownerName).join(', ')}
            </IconLabel>
          </View>
        )}
      </View>

      {/* 75차: 전체/미납만 필터 */}
      <View style={{flexDirection:'row',gap:8,marginBottom:14}}>
        {[{k:false,l:`전체 (${stores.length})`,warn:false},{k:true,l:`미납만 (${unpaidStores.length})`,warn:true}].map(f=>(
          <TouchableOpacity key={String(f.k)}
            style={[s.chip, unpaidOnly===f.k&&s.chipOn]}
            onPress={()=>setUnpaidOnly(f.k)}>
            {f.warn
              ? <IconLabel Icon={WarningIcon} size={12} color={(unpaidOnly===f.k ? s.chipTxtOn.color : s.chipTxt.color)} textStyle={[s.chipTxt, unpaidOnly===f.k&&s.chipTxtOn]}>{f.l}</IconLabel>
              : <Text style={[s.chipTxt, unpaidOnly===f.k&&s.chipTxtOn]}>{f.l}</Text>}
          </TouchableOpacity>
        ))}
      </View>

      {visibleStores.length===0?<EmptyState Icon={unpaidOnly?CheckmarkIcon:MenuStoreIcon} text={unpaidOnly?'미납 매장이 없습니다.':'등록된 매장이 없습니다.'}/>:
        visibleStores.map(store=>{
          const billing=getBilling(store.id);
          const fee=calcMonthlyFee(store);
          const isPaid=billing?.status==='paid';
          // 79차: [버그 수정] 소프트삭제된 테마까지 세고 있어서, 실제 수수료 계산(getStoreThemeCount
          // 기반)과 화면에 나란히 보이는 "테마 N개" 표시가 어긋날 수 있었음(순수 표시 불일치,
          // SuperAdminScreen.js의 핵심지표-드릴다운 불일치와 동일 유형) — 기준 통일.
          const themeCount=getStoreThemeCount(store);
          const multiBranch=(store.branches||[]).length>1;
          return(
            <View key={store.id} style={[s.card,isPaid&&{borderColor:C.success+'60'}]}>
              <View style={{flexDirection:'row',alignItems:'center',justifyContent:'space-between',marginBottom:6}}>
                <View style={{flex:1}}>
                  <Text style={s.drillName}>{store.ownerName}</Text>
                  <Text style={[s.muted,{marginTop:2}]}>테마 {themeCount}개 · {fee.toLocaleString()}원{multiBranch?' (전체 합산)':''}</Text>
                </View>
                <View style={{borderRadius:8,paddingHorizontal:10,paddingVertical:4,borderWidth:1,backgroundColor:isPaid?C.success+'15':C.danger+'15',borderColor:isPaid?C.success+'60':C.danger+'60'}}>
                  <IconLabel Icon={isPaid?CheckmarkIcon:HourglassIcon} size={12} color={isPaid?C.success:C.danger} textStyle={{color:isPaid?C.success:C.danger,fontSize:12,fontWeight:'800'}}>{isPaid?'수납완료':'미수납'}</IconLabel>
                </View>
              </View>
              {isPaid&&billing.paidAt&&(
                <Text style={[s.muted,{marginBottom:6}]}>수납일: {new Date(billing.paidAt).toLocaleDateString('ko-KR')}{billing.memo?`  · ${billing.memo}`:''}</Text>
              )}
              {/* 78차 63차: "전체" 볼 때도 지점별 금액이 궁금하다는 요청 — 수납 처리는
                  매장 단위 그대로 유지, 지점별 금액은 참고용으로만 풀어서 보여줌. */}
              {multiBranch && (
                <View style={{marginBottom:8,gap:4}}>
                  {(store.branches||[]).map((b,bi)=>{
                    // 79차: [버그 수정] 위 calcMonthlyBreakdown과 동일한 이유 — storeId+
                    // branchIdx로 정확히 매칭, 레거시 예약만 테마명 매칭으로 폴백.
                    const branchNames=b.themes?.map(t=>t.name)||[];
                    const matchesBranch = r => r.storeId
                      ? (r.storeId === store.id && parseProductId(r.productId)?.branchIdx === bi)
                      : branchNames.includes(r.productName);
                    const branchRevenue=activeRes.filter(r=>matchesBranch(r)&&r.date?.startsWith(selectedMonth)).reduce((acc,r)=>acc+(r.price||0),0);
                    // 80차 후속: [버그 수정, 돈 표시 누락] 지점별 참고용 금액도
                    // opsAddonFee(지점별 계산 가능)가 빠져 있었음 — 추가. PICK 추가요금은
                    // 지점별로 안 나뉘는 매장 단위 집계라(paidPickCounts가 store.id 기준)
                    // 이 참고용 지점별 줄에는 원래부터 포함 대상 아님(수납 처리 자체는
                    // 여전히 매장 단위 calcMonthlyBreakdown이 담당, 정확함).
                    const branchFee=calcStoreFee(store,branchRevenue,branchNames.length,bi)+getPlanFee(store,bi)+getOpsAddonFee(store,bi);
                    return (
                      <View key={bi} style={{flexDirection:'row',justifyContent:'space-between'}}>
                        <Text style={[s.muted,{fontSize:11}]} numberOfLines={1}>{b.branchName}</Text>
                        <Text style={{color:C.text,fontSize:11,fontWeight:'700'}}>{branchFee.toLocaleString()}원</Text>
                      </View>
                    );
                  })}
                </View>
              )}
              <View style={{flexDirection:'row',gap:8,marginTop:6}}>
                {!isPaid?(
                  <SecondaryButton
                    label="수납 처리"
                    onPress={()=>setSelectedStore(store)}
                    style={[s.smBtn,{flex:1,borderColor:C.success+'60'}]}
                    textStyle={[s.smBtnTxt,{color:C.success}]}
                  />
                ):(
                  <SecondaryButton
                    label="수납 취소"
                    onPress={()=>showAlert('수납 취소','미수납으로 변경하시겠습니까?',[{text:'취소',style:'cancel'},{text:'변경',onPress:()=>handleMarkUnpaid(store)}])}
                    style={[s.smBtn,{flex:1}]}
                    textStyle={s.smBtnTxt}
                  />
                )}
              </View>
            </View>
          );
        })
      }
      <Modal visible={!!selectedStore} transparent animationType="slide" onRequestClose={()=>setSelectedStore(null)}>
        <View style={s.modalOverlay}>
          <View style={[s.modalBox,{padding:0,overflow:'hidden'}]}>
            <AppHeader isModal
              centerElement={<IconLabel Icon={PriceIcon} size={14} color={C.text} textStyle={s.modalHeaderTitle}>수납 처리</IconLabel>}
              rightElement={
                <TouchableOpacity onPress={()=>{setSelectedStore(null);setMemo('');}}>
                  <IconLabel Icon={CancelIcon} color={C.muted} size={13} textStyle={{color:C.muted,fontSize:14}}>닫기</IconLabel>
                </TouchableOpacity>
              }
            />
            <View style={{padding:24}}>
            {selectedStore&&(
              <>
                <InfoRow label="매장" value={selectedStore.ownerName}/>
                <InfoRow label="월"   value={selectedMonth}/>
                <InfoRow label="수수료" value={`${calcMonthlyBreakdown(selectedStore).commissionFee.toLocaleString()}원`}/>
                <InfoRow label="구독료" value={`${calcMonthlyBreakdown(selectedStore).planFee.toLocaleString()}원`}/>
                {calcMonthlyBreakdown(selectedStore).opsAddonFee > 0 && (
                  <InfoRow label="매장관리자 기능 애드온" value={`${calcMonthlyBreakdown(selectedStore).opsAddonFee.toLocaleString()}원`}/>
                )}
                {calcMonthlyBreakdown(selectedStore).pickAddonFee > 0 && (
                  <InfoRow label="PICK 추가 요금" value={`${calcMonthlyBreakdown(selectedStore).pickAddonFee.toLocaleString()}원`}/>
                )}
                <InfoRow label="합계"   value={`${calcMonthlyFee(selectedStore).toLocaleString()}원`}/>
                <View style={{height:12}}/>
                <FI label="메모 (선택)" value={memo} onChange={setMemo} placeholder="이체 확인번호, 메모 등"/>
              </>
            )}
            <View style={s.modalBtns}>
              <SecondaryButton label="취소" onPress={()=>{setSelectedStore(null);setMemo('');}} style={{flex:1}} textStyle={s.outlineBtnTxt} />
              <GradientButton
                label={submitting?'처리중...':'수납 완료'}
                Icon={submitting?undefined:CheckmarkIcon}
                onPress={()=>selectedStore&&handleMarkPaid(selectedStore)}
                disabled={submitting}
                style={{flex:2}}
                textStyle={s.primaryBtnTxt}
              />
            </View>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
}

function SCard({title,Icon,children}){return(<View style={[s.card,{marginBottom:12}]}>{Icon?<IconLabel Icon={Icon} size={14} color={C.gold} textStyle={[s.sectionTitle,{marginTop:0,marginBottom:0}]} style={{marginBottom:12}}>{title}</IconLabel>:<Text style={[s.sectionTitle,{marginTop:0,marginBottom:12}]}>{title}</Text>}{children}</View>);}
function FI({label,value,onChange,keyboard,placeholder,multiline}){return(<View style={{marginBottom:12}}><Text style={[s.muted,{marginBottom:6}]}>{label}</Text><TextInput style={[s.input,multiline&&{minHeight:80,textAlignVertical:'top',paddingTop:10}]} value={value} onChangeText={onChange} keyboardType={keyboard||'default'} placeholder={placeholder||''} placeholderTextColor={C.muted} multiline={!!multiline} numberOfLines={multiline?3:1}/></View>);}

// 78차 46차: 계약 시작/종료일 — 자유 텍스트 입력("2026.06.15" 등 형식 어긋남으로 문자열
// 비교가 깨지는 문제)을 달력 선택으로 교체. StoreAdminScreen.js의 EventDateField와
// 동일한 패턴(react-native-calendars, 토글형 드롭다운).
function DateField({label,value,onChange,minDate,maxDate}){
  const [open,setOpen]=useState(false);
  return (
    <View style={{marginBottom:12}}>
      <Text style={[s.muted,{marginBottom:6}]}>{label}</Text>
      <TouchableOpacity style={[s.input,{flexDirection:'row',alignItems:'center',justifyContent:'space-between'}]} onPress={()=>setOpen(v=>!v)}>
        <Text style={{color:value?C.text:C.muted,fontSize:14}}>{value||'날짜 선택'}</Text>
        <Text style={{color:C.gold,fontSize:12}}>{open?'▲':'▼'}</Text>
      </TouchableOpacity>
      {open&&(
        <View style={{marginTop:8,backgroundColor:C.surface,borderRadius:10,borderWidth:1,borderColor:C.border,overflow:'hidden'}}>
          <Calendar
            theme={{
              backgroundColor:'transparent', calendarBackground:'transparent',
              textSectionTitleColor:C.muted,
              selectedDayBackgroundColor:C.gold, selectedDayTextColor:C.onGold,
              todayTextColor:C.gold, dayTextColor:C.text,
              textDisabledColor:'rgba(255,255,255,0.15)',
              arrowColor:C.gold, monthTextColor:C.text,
              textDayFontWeight:'500', textMonthFontWeight:'800',
              textDayFontSize:13, textMonthFontSize:13,
            }}
            minDate={minDate} maxDate={maxDate}
            current={value||minDate}
            markedDates={value?{[value]:{selected:true,selectedColor:C.gold,selectedTextColor:C.onGold}}:{}}
            onDayPress={day=>{onChange(day.dateString);setOpen(false);}}
            hideExtraDays
          />
        </View>
      )}
    </View>
  );
}
function InfoRow({label,value}){return(<View style={{flexDirection:'row',justifyContent:'space-between',paddingVertical:5,borderBottomWidth:1,borderBottomColor:C.border}}><Text style={s.muted}>{label}</Text><Text style={[s.muted,{color:C.textSec,flex:1,textAlign:'right'}]}>{value}</Text></View>);}
function EmptyState({emoji,Icon,text}){return(<View style={{alignItems:'center',paddingVertical:40}}>{Icon?<View style={{marginBottom:12}}><Icon size={36} color={C.muted}/></View>:<Text style={{fontSize:40,marginBottom:12}}>{emoji}</Text>}<Text style={s.muted}>{text}</Text></View>);}

const s = StyleSheet.create({
  container:    {flex:1,backgroundColor:C.bg},
  roleBadge:    {backgroundColor:C.goldBg,borderRadius:20,paddingHorizontal:10,paddingVertical:4,borderWidth:1,borderColor:C.goldBdr},
  roleBadgeTxt: {color:C.gold,fontSize:11,fontWeight:'700'},
  tabScroll:    {backgroundColor:C.surface,maxHeight:50,borderBottomWidth:1,borderBottomColor:C.border},
  // 78차 15차: tabRow에 alignItems가 없어 가로 ScrollView 기본 stretch로 tabBtn이
  // tabScroll의 maxHeight(50)까지 늘어나고, tabBtn 자체에도 justifyContent가 없어
  // 그 안의 라벨(IconLabel)이 버튼 위쪽에 붙어 보이던 버그 — 둘 다 center로 고정.
  tabRow:       {flexDirection:'row',alignItems:'center',paddingHorizontal:12,paddingVertical:8,gap:8},
  tabBtn:       {paddingHorizontal:14,paddingVertical:5,borderRadius:RADIUS.sm,borderWidth:1,borderColor:C.border,backgroundColor:C.card,justifyContent:'center',alignItems:'center'},
  tabBtnOn:     {backgroundColor:C.goldBg,borderColor:C.goldBdr},
  tabTxt:       {color:C.muted,fontSize:12},
  tabTxtOn:     {color:C.gold,fontWeight:'700'},
  body:         {flex:1,padding:16},
  sectionTitle: {fontSize:14,fontWeight:'700',color:C.gold,marginBottom:10,marginTop:6,letterSpacing:0.5,fontFamily:FONTS.display},
  // 78차 68차: 직원용 제한 계정 발급 체크박스
  checkboxRow:  {flexDirection:'row',alignItems:'center',gap:10,marginTop:10},
  checkbox:     {width:20,height:20,borderRadius:5,borderWidth:1.5,borderColor:C.border,alignItems:'center',justifyContent:'center'},
  checkboxOn:   {backgroundColor:C.gold,borderColor:C.gold},
  muted:        {color:C.muted,fontSize:12},
  card:         {backgroundColor:C.card,borderRadius:RADIUS.md,borderWidth:1,borderColor:C.border,padding:16,marginBottom:12,...SHADOW.card},
  // 32차: 비활성화 매장 카드
  cardDeleted:  {opacity:0.55,borderColor:C.dangerSoftBorder,borderStyle:'dashed'},
  deletedBadge: {backgroundColor:C.dangerSoftBg,borderRadius:6,paddingHorizontal:7,paddingVertical:2,borderWidth:1,borderColor:C.dangerSoftBorder},
  deletedBadgeTxt:{color:C.dangerSoft,fontSize:10,fontWeight:'800'},
  demoBadge:    {backgroundColor:COLORS.warningBg,borderRadius:6,paddingHorizontal:7,paddingVertical:2,borderWidth:1,borderColor:C.warning},
  demoBadgeTxt: {color:C.warning,fontSize:10,fontWeight:'800'},
  // 56차: 프리미엄 플랜 배지
  premiumBadge: {backgroundColor:C.goldBg,borderRadius:6,paddingHorizontal:7,paddingVertical:2,borderWidth:1,borderColor:C.goldBdr},
  premiumBadgeTxt:{color:C.gold,fontSize:10,fontWeight:'800'},
  drillName:    {color:C.text,fontWeight:'600',fontSize:14},
  storeHeader:  {flexDirection:'row',padding:16,alignItems:'center'},
  storeDetail:  {paddingHorizontal:16,paddingBottom:16,borderTopWidth:1,borderTopColor:C.border},
  badge:        {borderRadius:20,paddingHorizontal:8,paddingVertical:2,borderWidth:1},
  badgeTxt:     {fontSize:10,fontWeight:'600'},
  input:        {backgroundColor:C.surface,borderWidth:1,borderColor:C.border,borderRadius:RADIUS.sm,padding:12,color:C.text,fontSize:14},
  chip:         {paddingHorizontal:12,paddingVertical:7,borderRadius:20,borderWidth:1,borderColor:C.border,backgroundColor:C.surface},
  chipOn:       {backgroundColor:C.goldBg,borderColor:C.goldBdr},
  chipTxt:      {color:C.muted,fontSize:12},
  chipTxtOn:    {color:C.gold,fontWeight:'600'},
  // 78차 15차: paddingVertical만 있으면 라벨에 이모지가 섞인 버튼(예: "📊 일괄 등록")과
  // 순수 텍스트/기호 버튼(예: "+ 새 매장 등록")의 줄높이가 폰트 메트릭 차이로 미묘하게
  // 달라져 같은 행에 나란히 두면 세로 크기가 달라 보였음 — minHeight로 항상 동일하게.
  // (처음엔 height:30 고정으로 했다가, SecondaryButton 기본 스타일의 paddingVertical:12가
  // 여기 paddingVertical로 덮어써지지 않은 채 남아있어 30-24=6px 안에 텍스트가 눌려
  // 글자가 안 보이는 버그가 있었음 — paddingVertical을 명시적으로 줄이고 height를
  // minHeight로 바꿔 내용이 늘 들어갈 공간을 확보하도록 수정)
  smBtn:        {paddingHorizontal:12,paddingVertical:6,minHeight:30,justifyContent:'center'},
  // 58차: 정산 콤보탭(현황/수납관리) 토글 버튼
  viewToggleBtn:    {paddingHorizontal:16,paddingVertical:7,borderRadius:16,borderWidth:1,borderColor:C.border,backgroundColor:C.card},
  viewToggleBtnOn:  {borderColor:C.goldBdr,backgroundColor:C.goldBg},
  viewToggleTxt:    {color:C.muted,fontSize:12,fontWeight:'600'},
  viewToggleTxtOn:  {color:C.gold,fontWeight:'800'},
  smBtnTxt:     {fontSize:12},
  primaryBtn:   {marginTop:4},
  primaryBtnTxt:{fontSize:14},
  outlineBtnTxt:{fontSize:13},
  radioRow:     {flexDirection:'row',alignItems:'center',gap:12,padding:10,borderRadius:RADIUS.sm,borderWidth:1,borderColor:C.border,marginBottom:8},
  radioRowOn:   {borderColor:C.goldBdr,backgroundColor:C.goldBg},
  radio:        {width:18,height:18,borderRadius:9,borderWidth:2,borderColor:C.muted},
  radioOn:      {borderColor:C.gold,backgroundColor:C.gold},
  radioLabel:   {color:C.text,fontSize:14},
  modalOverlay: {flex:1,backgroundColor:'rgba(0,0,0,0.75)',justifyContent:'flex-end'},
  modalBox:     {backgroundColor:C.surface,borderTopLeftRadius:RADIUS.lg,borderTopRightRadius:RADIUS.lg,padding:24,paddingBottom:40,overflow:'hidden'},
  modalHeaderTitle: {color:C.text,fontSize:15,fontWeight:'800'},
  modalBtns:    {flexDirection:'row',gap:10,marginTop:20},
  pricePeopleBadge:{width:40,height:40,borderRadius:20,backgroundColor:C.goldBg,borderWidth:1,borderColor:C.goldBdr,alignItems:'center',justifyContent:'center'},
  pricePeopleTxt:  {color:C.gold,fontWeight:'700',fontSize:13},
  imgPreview:   {width:'100%',height:160,borderRadius:RADIUS.sm,borderWidth:1,borderColor:C.border},
  imgRemoveBtn: {alignSelf:'flex-end',paddingHorizontal:10,paddingVertical:4,borderRadius:6,borderWidth:1,borderColor:C.danger,marginTop:6},
  imgRemoveTxt: {color:C.danger,fontSize:11,fontWeight:'600'},
  imgPickBtn:   {borderWidth:1,borderStyle:'dashed',borderColor:C.goldBdr,borderRadius:RADIUS.sm,paddingVertical:20,alignItems:'center',marginBottom:12,backgroundColor:C.goldBg},
  // 68차: 플랜 선택 모달 옵션 행
  planOptionRow:  {flexDirection:'row',justifyContent:'space-between',alignItems:'center',padding:14,borderRadius:RADIUS.md,borderWidth:1,borderColor:C.border,backgroundColor:C.surface},
  planOptionRowOn:{borderColor:C.goldBdr,backgroundColor:C.goldBg},
  planOptionLabel:{color:C.text,fontSize:15,fontWeight:'800',marginBottom:2},
  // 76차: 매장관리자 계정 발급 결과 모달
  issuedOverlay:{flex:1,backgroundColor:'rgba(0,0,0,0.75)',justifyContent:'center',padding:24},
  issuedBox:    {backgroundColor:C.surface,borderRadius:RADIUS.lg,borderWidth:1,borderColor:C.goldBdr},
  issuedWarn:   {color:C.danger,fontSize:12,lineHeight:18,marginBottom:16},
});